webpackJsonp([1],{

/***/ "+S/E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UPDATE_TIP_MSG */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENTER_GAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_GAME_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SHARE_REWARD; });
/* unused harmony export RESFRESH_SHARE_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESFRESH_TIPS_STATUS; });
/* unused harmony export SHOW_TIPS_FIRST_TIME */
/* unused harmony export GAME_STATUS_NORMAL */
/* unused harmony export GAME_STATUS_MAINTAIN */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__("2aIq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ultile__ = __webpack_require__("VtGx");




var _actions, _mutations;




var UPDATE_TIP_MSG = "updateTipsMsg";
var ENTER_GAME = "enterGame";
var LOAD_GAME_URL = "loagGameUrl";
var SHARE_REWARD = "shareRewardAction";
var RESFRESH_SHARE_STATUS = "resfreh_share_status";
var RESFRESH_TIPS_STATUS = "refreshTips";
var SHOW_TIPS_FIRST_TIME = "showTipsFirstTime";
var GAME_STATUS_NORMAL = 1;
var GAME_STATUS_MAINTAIN = 0;
var LOAD_GAME_URL_ACTION = "//m.gm99.com/h5/play_games/enterGameUrl";
var SHARE_REWARD_URL = "//m.gm99.com/h5/page/get_share_reward";
var SHARE_REWARD_URL_LINE = "//m.gm99.com/h5/page/get_line_reward";
var enterGameHost = "add_server";
var CHANGE_GAME_URL = "changeGameUrl";
var CHANGE_GAME_INFO = "changeGameInfo";

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);
var GAME_ID = Object(__WEBPACK_IMPORTED_MODULE_5__ultile__["h" /* getGameId */])();

var getShareTipsStatus = function getShareTipsStatus() {
  var res = false;
  try {
    res = window.localStorage.getItem("show" + GAME_ID + "ShareFistTime") === "false" || !window.localStorage.getItem("show" + GAME_ID + "ShareFistTime");
  } catch (e) {}
  return res;
};

var setShareTipsStatus = function setShareTipsStatus(status) {
  try {
    window.localStorage.setItem("show" + GAME_ID + "ShareFistTime", status);
  } catch (e) {}
};

/* harmony default export */ __webpack_exports__["e"] = ({
  strict: "production" !== "production", //在非生产环境下，使用严格模式
  state: {
    tipMsg: "",
    gameUrl: "",
    shareStatus: false,
    shareTipsStatus: false,
    showShareTipsFistTime: getShareTipsStatus(),
    gameState: 1,
    maintainUrl: ""
  },
  actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, ENTER_GAME, function (_ref, params) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref);

    var anilyzeParam = {
      game_server_sid: params.serverId,
      roleName: params.roleName || "",
      roleId: params.roleId || "",
      roleLevel: params.level || ""
    };
    if (window.isFbCanvas) {
      var fb_source = Object(__WEBPACK_IMPORTED_MODULE_5__ultile__["i" /* getHrefParam */])("fb_source", window.parent.location.search);
      anilyzeParam["fb_source"] = fb_source || "";
    }
    var linkParam = Object(__WEBPACK_IMPORTED_MODULE_5__ultile__["j" /* getHrefParamObj */])();
    Object(__WEBPACK_IMPORTED_MODULE_5__ultile__["k" /* getJSON */])(__WEBPACK_IMPORTED_MODULE_5__ultile__["c" /* PASSPORT_HOST */] + enterGameHost, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, anilyzeParam, linkParam));
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, LOAD_GAME_URL, function (_ref2) {
    var commit = _ref2.commit;

    var linkParam = Object(__WEBPACK_IMPORTED_MODULE_5__ultile__["j" /* getHrefParamObj */])();
    Object(__WEBPACK_IMPORTED_MODULE_5__ultile__["k" /* getJSON */])(LOAD_GAME_URL_ACTION, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      is_fb: window.isFbCanvas ? 1 : 0
    }, linkParam)).then(function (res) {
      if (!res.errmsg) {
        commit(CHANGE_GAME_URL, res.data.enterUrl);
        commit(CHANGE_GAME_INFO, res.data);
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SHARE_REWARD, function (_ref3, shareInfo) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref3);

    var url = shareInfo.type == "line" ? SHARE_REWARD_URL_LINE : SHARE_REWARD_URL;
    return Object(__WEBPACK_IMPORTED_MODULE_5__ultile__["n" /* post */])(url, {
      achievementId: shareInfo.achievementId,
      appId: __WEBPACK_IMPORTED_MODULE_5__ultile__["a" /* APP_ID */],
      gameId: Object(__WEBPACK_IMPORTED_MODULE_5__ultile__["h" /* getGameId */])(),
      serverId: shareInfo.serverId,
      fbid: shareInfo.fbid || "",
      loginAccount: shareInfo.name,
      timestamp: new Date().getTime(),
      roleId: shareInfo.roleId,
      roleName: shareInfo.roleName,
      devicePlate: "pc",
      postId: shareInfo.postId || "",
      token: shareInfo.token,
      sign: ""
    });
  }), _actions),
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, UPDATE_TIP_MSG, function (state, status) {
    state.tipMsg = status;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, CHANGE_GAME_URL, function (state, url) {
    state.gameUrl = url;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, RESFRESH_SHARE_STATUS, function (state, gameInfo) {
    var serverInfo = gameInfo.serverInfo,
        roleInfo = gameInfo.roleInfo;

    if (serverInfo.serverId && roleInfo.roleId && roleInfo.roleName) {
      state.shareStatus = true;
      state.shareTipsStatus = true;
    } else {
      state.shareStatus = false;
      state.shareTipsStatus = false;
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, RESFRESH_TIPS_STATUS, function (state, status) {
    // state.shareTipsStatus = status;
    if (getShareTipsStatus()) {
      setShareTipsStatus(!status);
      state.showShareTipsFistTime = getShareTipsStatus();
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, CHANGE_GAME_INFO, function (state, gameInfo) {
    state.gameState = gameInfo.game.STATE;
    if (gameInfo && gameInfo.game) {
      state.maintainUrl = gameInfo.maintenance_pic;
    } else {
      state.maintainUrl = "";
    }
  }), _mutations)
});

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("GQna");


/***/ }),

/***/ "9Roz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/symbol.js
var symbol = __webpack_require__("5QVw");
var symbol_default = /*#__PURE__*/__webpack_require__.n(symbol);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TipPopUpIframe.vue


//
//
//
//
//
//
//
//
//
//



var POPUP_STYLE = {
  good: symbol_default()(),
  bad: symbol_default()()
};

/* harmony default export */ var TipPopUpIframe = ({
  data: function data() {
    return {};
  },

  methods: {
    close: function close() {
      this.$store.commit("updateCommonTips", {
        msg: "",
        style: ""
      });
    }
  },
  computed: extends_default()({
    goodType: function goodType() {
      return this.commonTipsStyle === POPUP_STYLE.good;
    },
    badType: function badType() {
      return this.commonTipsStyle === POPUP_STYLE.bad;
    }
  }, Object(vuex_esm["c" /* mapGetters */])(["commonTips", "commonTipsStyle"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79ace5ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TipPopUpIframe.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup"},[_c('div',{staticClass:"popup-bg",on:{"click":_vm.close}}),_vm._v(" "),_c('div',{staticClass:"popup-tip j-popup-tip",class:{good:_vm.goodType,bad:_vm.badType}},[_c('p',{staticClass:"popup-tip-text"},[_vm._v(_vm._s(_vm.commonTips))]),_vm._v(" "),_c('a',{staticClass:"popup-close",attrs:{"href":"javascript:;"},on:{"click":_vm.close}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_TipPopUpIframe = (esExports);
// CONCATENATED MODULE: ./src/components/TipPopUpIframe.vue
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return POPUP_STYLE; });
function injectStyle (ssrContext) {
  __webpack_require__("UCuA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  TipPopUpIframe,
  components_TipPopUpIframe,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_TipPopUpIframe = __webpack_exports__["b"] = (Component.exports);


/***/ }),

/***/ "9ilI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/components/Account.vue + 2 modules
var Account = __webpack_require__("uK6g");

// EXTERNAL MODULE: ./src/utile/index.js
var utile = __webpack_require__("ZCHt");

// EXTERNAL MODULE: ./src/utile/device.js
var device = __webpack_require__("FSl1");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/store/gamePage/index.js
var gamePage = __webpack_require__("+S/E");

// EXTERNAL MODULE: ./src/utile/fb.js
var fb = __webpack_require__("Rmiw");

// EXTERNAL MODULE: ./src/store/ultile.js + 2 modules
var ultile = __webpack_require__("VtGx");

// EXTERNAL MODULE: ./src/store/gift.js
var gift = __webpack_require__("MnT7");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Gift.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Gift = ({
  data: function data() {
    return {};
  },
  created: function created() {
    this.$store.dispatch("loadGiftList");
  },

  computed: {
    gifts: function gifts() {
      return gift["a" /* default */].state.giftList;
    }
  },
  methods: {
    getGift: function getGift(type) {
      var _this = this;

      this.$store.dispatch("recieveGift", { type: type }).then(function () {
        _this.$emit("showPopupWindow");
        _this.$store.dispatch("loadGiftList");
      });
    },
    checkGift: function checkGift(type) {
      var _this2 = this;

      this.$store.dispatch("checkGift", type).then(function () {
        _this2.$emit("showPopupWindow");
      });
    }
  },
  name: "Gift"
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bf85c4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gift.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"gift-list"},[_vm._l((_vm.gifts),function(gift,index){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.gifts.length > 0),expression:"gifts.length > 0"}],key:("gift-" + index),staticClass:"gift-item"},[_c('i',{staticClass:"gift-state-icon",class:{ recieved: gift.type == 'member_gift',recieveAble: gift.type=='novice_gift' }}),_vm._v(" "),_c('div',[_c('p',{staticClass:"gift-name",class:{ recievedText: gift.state,recieveAbleText: !gift.state }},[_vm._v(_vm._s(gift.name))]),_vm._v(" "),_c('div',[_c('span',{staticClass:"less-tips"},[_vm._v("剩余")]),_vm._v(" "),_c('progress',{staticClass:"less-process",attrs:{"max":"1"},domProps:{"value":gift.less/gift.totalNum}}),_vm._v(" "),_c('output',{staticClass:"less-rate"},[_vm._v(_vm._s(parseInt(gift.less/gift.totalNum*100))+"%")])])]),_vm._v(" "),(gift.state)?_c('button',{staticClass:"recieve-btn",on:{"click":function($event){return _vm.getGift(gift.type)}}},[_vm._v("領取")]):_vm._e(),_vm._v(" "),(!gift.state)?_c('button',{staticClass:"recieve-btn",on:{"click":function($event){return _vm.checkGift(gift.type)}}},[_vm._v("查看")]):_vm._e()])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.gifts.length < 1),expression:"gifts.length < 1"}],staticClass:"gift-empty"}),_vm._v(" "),(_vm.gifts.length >= 1)?_c('div',{staticClass:"gift-tips"},[_vm._v("注：此處禮包和遊戲APP內的禮包為同一個，無法重複兌換")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Gift = (esExports);
// CONCATENATED MODULE: ./src/components/Gift.vue
function injectStyle (ssrContext) {
  __webpack_require__("G1L6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Gift,
  components_Gift,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Gift = (Component.exports);

// EXTERNAL MODULE: ./node_modules/clipboard/lib/clipboard.js
var clipboard = __webpack_require__("V33R");
var clipboard_default = /*#__PURE__*/__webpack_require__.n(clipboard);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GiftPopup.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var GiftPopup = ({
  data: function data() {
    return {
      copyText: "複 製"
    };
  },

  methods: {
    close: function close() {
      this.$emit("closeGiftPopup");
      this.copyText = "複 製";
    },
    copyResult: function copyResult() {
      this.copyText = "複製成功";
      //this.$emit("copySuccess");
    }
  },
  computed: {
    popupType: function popupType() {
      return gift["a" /* default */].state.getGiftSuccess;
    },
    giftInfo: function giftInfo() {
      return gift["a" /* default */].state.giftInfo;
    },
    errMsg: function errMsg() {
      return gift["a" /* default */].state.errmsg;
    }
  },
  name: "Gift",
  mounted: function mounted() {
    var clipboards = new clipboard_default.a(".gift-popup-content-copy");
    clipboards.on("success", this.copyResult.bind(this));
    clipboards.on("error", function (e) {
      console.log(e);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-845db690","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GiftPopup.vue
var GiftPopup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gift-popup"},[_c('div',{staticClass:"gift-popup-bg",on:{"click":_vm.close}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popupType=='successPop'),expression:"popupType=='successPop'"}],staticClass:"gift-popup-get j-gift-popup"},[_c('div',{staticClass:"gift-popup-pic"}),_vm._v(" "),_c('div',{staticClass:"gift-popup-content"},[_c('button',{staticClass:"gift-popup-cancle",on:{"click":_vm.close}}),_vm._v(" "),_c('h3',{staticClass:"gift-popup-content-title"},[_vm._v("恭喜您領到禮包")]),_vm._v(" "),_c('div',{staticClass:"gift-popup-content-gift"},[_c('span',{staticClass:"gift-popup-content-gift-title"},[_vm._v("禮包內容：")]),_vm._v(" "),_c('span',{staticClass:"gift-popup-content-gift-content"},[_vm._v(_vm._s(_vm.giftInfo.content))])]),_vm._v(" "),_c('p',{staticClass:"gift-popup-content-box"},[_c('span',{staticClass:"gift-popup-content-num"},[_vm._v(_vm._s(_vm.giftInfo.card))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.giftInfo.card),expression:"giftInfo.card"}],staticClass:"copy-input",attrs:{"type":"text","name":"","id":"j-gift-num"},domProps:{"value":(_vm.giftInfo.card)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.giftInfo, "card", $event.target.value)}}}),_vm._v(" "),_c('button',{staticClass:"gift-popup-content-copy",attrs:{"data-clipboard-target":"#j-gift-num"}},[_vm._v(_vm._s(_vm.copyText))])]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popupType=='failGiftPop'),expression:"popupType=='failGiftPop'"}],staticClass:"gift-popup-unget j-gift-popup"},[_c('button',{staticClass:"gift-popup-cancle",on:{"click":_vm.close}}),_vm._v(" "),_c('div',{staticClass:"gift-popup-unget-pic"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.popupType=='failCheckPop'),expression:"popupType=='failCheckPop'"}],staticClass:"gift-popup-unget j-gift-popup"},[_c('button',{staticClass:"gift-popup-cancle",on:{"click":_vm.close}}),_vm._v(" "),_c('div',{staticClass:"gift-popup-unget-bg"},[_c('span',{staticClass:"gift-popup-unget-text"},[_vm._v(_vm._s(_vm.errMsg))])])])])}
var GiftPopup_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gift-popup-content-tipbox"},[_c('span',{staticClass:"gift-popup-content-other"},[_vm._v("兌換方式")]),_vm._v(" "),_c('p',{staticClass:"gift-popup-content-tips"},[_c('a',{staticClass:"reard-url",attrs:{"target":"blank","href":"//events.gm99.com/static/html/gm_platform/gmexchange/index.html"}},[_vm._v("請複製禮包序號，並前往【序號兌換頁】處領用")])])])}]
var GiftPopup_esExports = { render: GiftPopup_render, staticRenderFns: GiftPopup_staticRenderFns }
/* harmony default export */ var components_GiftPopup = (GiftPopup_esExports);
// CONCATENATED MODULE: ./src/components/GiftPopup.vue
function GiftPopup_injectStyle (ssrContext) {
  __webpack_require__("PvY0")
}
var GiftPopup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GiftPopup___vue_template_functional__ = false
/* styles */
var GiftPopup___vue_styles__ = GiftPopup_injectStyle
/* scopeId */
var GiftPopup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GiftPopup___vue_module_identifier__ = null
var GiftPopup_Component = GiftPopup_normalizeComponent(
  GiftPopup,
  components_GiftPopup,
  GiftPopup___vue_template_functional__,
  GiftPopup___vue_styles__,
  GiftPopup___vue_scopeId__,
  GiftPopup___vue_module_identifier__
)

/* harmony default export */ var src_components_GiftPopup = (GiftPopup_Component.exports);

// EXTERNAL MODULE: ./src/components/TipPopUpIframe.vue + 2 modules
var TipPopUpIframe = __webpack_require__("9Roz");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Aside.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var shareParams = {
  fb: {},
  line: {}
};

var AWARD_ID = {
  fb: 10005,
  line: 10006
};

/* harmony default export */ var Aside = ({
  components: { Gift: src_components_Gift, GiftPopup: src_components_GiftPopup },
  data: function data() {
    var isIOS9 = false;
    if (Object(utile["e" /* isPhone */])() && Object(device["a" /* iOSversion */])() && Object(device["a" /* iOSversion */])().length > 0) {
      isIOS9 = Object(device["a" /* iOSversion */])()[0] < 10;
    }
    return {
      isFb: Object(utile["d" /* isFBApp */])(),
      isIE: Object(device["c" /* isIE */])(),
      isIOS9: isIOS9,
      fbShareState: false,
      lineShareState: false,
      showGift: true,
      giftPopupState: false,
      showShareSuccess: false
    };
  },

  computed: extends_default()({
    avatar: function avatar() {
      var timesmap = new Date().getTime();
      var avatar = this.user.id && this.user.avatar ? this.user.avatar + '?v=' + timesmap : '';
      return avatar;
    },
    serviceSrc: function serviceSrc() {
      return '//service.gm99.com/?isH5=1&gameId=' + this.gameId + '&serverId=' + this.roleInfo.serverId + '&roleId=' + this.roleInfo.roleId + '&roleName=' + this.roleInfo.roleName + '/#/wo';
    },
    isEnterGame: function isEnterGame() {
      var res = this.roleInfo.serverId && this.roleInfo.roleId;
      if (res) {
        // 进了游戏之后，请求分享参数
        this.getShareParams();
      }
      return res;
    }
  }, Object(vuex_esm["c" /* mapGetters */])(['user', 'roleInfo', 'gameId', 'showShareTipsFistTime'])),
  methods: extends_default()({
    toggleAside: function toggleAside() {
      this.$emit('toggleAside');
    },
    switchAccount: function switchAccount() {
      this.$emit('openAccountPopup', Account["a" /* ACCOUNT_TYPE */].switchAccount);
    },
    getShareParams: function getShareParams() {
      var _this = this;

      var data = {
        serverId: this.roleInfo.serverId,
        roleId: this.roleInfo.roleId,
        roleName: this.roleInfo.roleName,
        name: this.user.name
      };
      Object(ultile["g" /* getFbParam */])(extends_default()({
        achievementId: AWARD_ID.fb
      }, data)).then(function (res) {
        if (res.errmsg) {
          return;
        }
        _this.fbShareState = true;
        shareParams.fb = res;
      });
      Object(ultile["l" /* getLineParam */])(extends_default()({
        achievementId: AWARD_ID.line
      }, data)).then(function (res) {
        if (res.errmsg) {
          return;
        }
        _this.lineShareState = true;
        shareParams.line = res;
      });
    },
    doFbShare: function doFbShare() {
      var _this2 = this;

      this.gaStatistics({ eventName: 'share', data: { type: 'fb' } });
      Object(fb["d" /* fbShare */])(shareParams.fb).then(function () {
        _this2.getShareAward('fb');
      }, this.shareFail);
    },
    doLineShare: function doLineShare() {
      this.gaStatistics({ eventName: 'line', data: { type: 'fb' } });
      Object(fb["f" /* lineShare */])(shareParams.line);
      this.getShareAward('line');
    },
    getShareAward: function getShareAward(type) {
      var _this3 = this;

      this.$store.dispatch(gamePage["d" /* SHARE_REWARD */], {
        serverId: this.roleInfo.serverId,
        roleId: this.roleInfo.roleId,
        roleName: this.roleInfo.roleName,
        achievementId: AWARD_ID[type],
        fbid: '',
        postId: '',
        token: shareParams[type].token,
        name: this.user.name,
        type: type
      }).then(function () {
        _this3.showShareSuccess = true;
      }, function () {
        _this3.$store.commit('updateCommonTips', {
          msg: '領獎失敗',
          style: TipPopUpIframe["a" /* POPUP_STYLE */].bad
        });
      });
    },
    shareFail: function shareFail() {
      this.$store.commit('updateCommonTips', {
        msg: '分享失敗',
        style: TipPopUpIframe["a" /* POPUP_STYLE */].bad
      });
    },
    hideShareTips: function hideShareTips() {
      this.$store.commit(gamePage["c" /* RESFRESH_TIPS_STATUS */], false);
    }
  }, Object(vuex_esm["b" /* mapActions */])(['gaStatistics']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b42f93e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Aside.vue
var Aside_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aside-box"},[_c('i',{staticClass:"close",on:{"click":_vm.toggleAside}}),_vm._v(" "),_c('i',{staticClass:"aside-bg j-aside-bg"}),_vm._v(" "),_c('div',{staticClass:"platform-container j-aside-popup"},[_c('div',{staticClass:"showPlatform",on:{"click":_vm.toggleAside}}),_vm._v(" "),_c('header',{staticClass:"platform-header"},[_c('div',{staticClass:"avatar-wrapper"},[_c('img',{staticClass:"avatar",attrs:{"src":_vm.avatar}})]),_vm._v(" "),_c('div',{staticClass:"platform-account-contianer"},[_c('div',{staticClass:"user-wrapper platform-account--wapper",class:{ fb: _vm.isFb }},[_c('p',{staticClass:"user-name"},[_vm._v("您好 , "+_vm._s(_vm.user.name))]),_vm._v(" "),_c('button',{staticClass:"switch-user account-btn",on:{"click":_vm.switchAccount}})]),_vm._v(" "),(!_vm.isFb && _vm.isEnterGame && _vm.fbShareState && _vm.lineShareState)?_c('div',{staticClass:"line"}):_vm._e(),_vm._v(" "),(!_vm.isFb && _vm.isEnterGame)?_c('div',{staticClass:"share-btn-wrapper platform-account--wapper"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.lineShareState),expression:"lineShareState"}],staticClass:"line-share account-btn",on:{"click":_vm.doLineShare}}),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.fbShareState),expression:"fbShareState"}],staticClass:"fb-share account-btn",on:{"click":_vm.doFbShare}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"platform-content"},[_c('nav',{staticClass:"tab-nav"},[_c('a',{staticClass:"tab",class:{ active: _vm.showGift },staticStyle:{"width":"100%"},on:{"click":function($event){_vm.showGift = true}}},[_vm._m(0)]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"tab",class:{ active: !_vm.showGift },on:{"click":function($event){_vm.showGift = false}}},[_vm._m(1)]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('ul',{staticClass:"plaform-contaner-container"},[_c('transition',{attrs:{"name":"fade"}},[_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGift),expression:"showGift"}],staticClass:"gift-container"},[_c('Gift',{on:{"showPopupWindow":function($event){_vm.giftPopupState = true}}})],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showGift),expression:"!showGift"}],staticClass:"service"},[(_vm.isEnterGame && !_vm.isIE && !_vm.isIOS9)?_c('iframe',{staticClass:"server-page j-server-page",attrs:{"src":_vm.serviceSrc}}):_vm._e(),_vm._v(" "),(!_vm.isEnterGame || _vm.isIE || _vm.isIOS9)?_c('div',{staticClass:"showServicePhoneWrapper"},[_c('div',{staticClass:"service-phone-container"},[_c('p',{staticClass:"service-phone"},[_vm._v("\n                  台灣專線\n                  "),_c('a',{staticClass:"phone",attrs:{"href":"tel:02-23560356"}},[_vm._v("02-23560356")])]),_vm._v(" "),_c('time',{staticClass:"service-time"},[_vm._v("每天09:00-22:00")])])]):_vm._e()])])],1)])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('GiftPopup',{directives:[{name:"show",rawName:"v-show",value:(_vm.giftPopupState),expression:"giftPopupState"}],on:{"closeGiftPopup":function($event){_vm.giftPopupState = false}}})],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(
        _vm.showShareTipsFistTime &&
        _vm.isEnterGame &&
        !_vm.isFb &&
        (_vm.fbShareState || _vm.lineShareState)
      ),expression:"\n        showShareTipsFistTime &&\n        isEnterGame &&\n        !isFb &&\n        (fbShareState || lineShareState)\n      "}],staticClass:"share-tips",on:{"click":_vm.hideShareTips}})]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showShareSuccess),expression:"showShareSuccess"}],staticClass:"share-success",on:{"click":function($event){_vm.showShareSuccess = false}}},[_c('div',{staticClass:"share-success-img"})])])],1)}
var Aside_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-wrapper"},[_c('i',{staticClass:"icon gift-tab-icon"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("禮    包")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-wrapper"},[_c('i',{staticClass:"icon service-tab-icon"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("客    服")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"curentTabBorder",staticStyle:{"left":"0","width":"100%"}},[_c('i',{staticClass:"currentTabIcon"})])}]
var Aside_esExports = { render: Aside_render, staticRenderFns: Aside_staticRenderFns }
/* harmony default export */ var components_Aside = (Aside_esExports);
// CONCATENATED MODULE: ./src/components/Aside.vue
function Aside_injectStyle (ssrContext) {
  __webpack_require__("YAvk")
}
var Aside_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Aside___vue_template_functional__ = false
/* styles */
var Aside___vue_styles__ = Aside_injectStyle
/* scopeId */
var Aside___vue_scopeId__ = "data-v-b42f93e8"
/* moduleIdentifier (server only) */
var Aside___vue_module_identifier__ = null
var Aside_Component = Aside_normalizeComponent(
  Aside,
  components_Aside,
  Aside___vue_template_functional__,
  Aside___vue_styles__,
  Aside___vue_scopeId__,
  Aside___vue_module_identifier__
)

/* harmony default export */ var src_components_Aside = (Aside_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PayTips.vue

//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var PayTips = ({
  props: ["pageLink", "pid"],
  methods: extends_default()({
    close: function close() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit("closePayTips");
      });
    },
    pay: function pay() {
      this.gaStatistics({
        eventName: "exc_store_pay",
        data: {
          pid: this.pid,
          pay_type: "store_page"
        }
      });
      window.open(this.pageLink, "_blank");
      this.close();
    }
  }, Object(vuex_esm["b" /* mapActions */])(["gaStatistics"])),
  name: "PayTips"
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc172a56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PayTips.vue
var PayTips_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tipsContianer j-pay-tips"},[_c('i',{staticClass:"closeTipsBtn",on:{"click":_vm.close}}),_vm._v(" "),_c('p',{staticClass:"tips-content"},[_vm._v("請跳轉前往儲值頁面")]),_vm._v(" "),_c('footer',{staticClass:"tips-footer"},[_c('a',{staticClass:"skipPayBtn j-skip-pay-btn",on:{"click":_vm.pay}},[_vm._v("跳轉")])])])}
var PayTips_staticRenderFns = []
var PayTips_esExports = { render: PayTips_render, staticRenderFns: PayTips_staticRenderFns }
/* harmony default export */ var components_PayTips = (PayTips_esExports);
// CONCATENATED MODULE: ./src/components/PayTips.vue
function PayTips_injectStyle (ssrContext) {
  __webpack_require__("C05d")
}
var PayTips_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PayTips___vue_template_functional__ = false
/* styles */
var PayTips___vue_styles__ = PayTips_injectStyle
/* scopeId */
var PayTips___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PayTips___vue_module_identifier__ = null
var PayTips_Component = PayTips_normalizeComponent(
  PayTips,
  components_PayTips,
  PayTips___vue_template_functional__,
  PayTips___vue_styles__,
  PayTips___vue_scopeId__,
  PayTips___vue_module_identifier__
)

/* harmony default export */ var src_components_PayTips = (PayTips_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FBPayTips.vue

//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var FBPayTips = ({
  props: ["orderId", "pid"],
  data: function data() {
    return {
      canPay: true
    };
  },

  methods: extends_default()({
    close: function close() {
      this.$emit("closePayTips");
    },
    pay: function pay() {
      var _this = this;

      if (this.canPay) {
        this.canPay = false;

        Object(fb["c" /* fbSdkPay */])(this.orderId).then(function (res) {
          _this.$store.commit("updateCommonTips", {
            msg: "儲值成功",
            style: TipPopUpIframe["a" /* POPUP_STYLE */].good
          });
          _this.canPay = true;
          _this.close();
        }, function (res) {
          var errmsg = "儲值失敗" + (!!res ? res["error_code"] == 1383010 ? "您取消了本次交易！" : "原因：" + res["error_message"] : "");
          _this.$store.commit("updateCommonTips", {
            msg: errmsg,
            style: TipPopUpIframe["a" /* POPUP_STYLE */].bad
          });
          _this.canPay = true;
          _this.close();
        });
        this.gaStatistics({
          eventName: "exc_store_pay",
          data: {
            pid: this.pid,
            pay_type: "facebook_local_money"
          }
        });
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(["gaStatistics"])),
  name: "FBPayTips"
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e20a3a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FBPayTips.vue
var FBPayTips_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tipsContianer fb-pay-tips"},[_c('i',{staticClass:"closeTipsBtn",on:{"click":_vm.close}}),_vm._v(" "),_c('p',{staticClass:"tips-content"},[_vm._v("請前往儲值頁面")]),_vm._v(" "),_c('footer',{staticClass:"tips-footer"},[_c('button',{staticClass:"skipPayBtn",on:{"click":_vm.pay}},[_vm._v("\n      "+_vm._s(_vm.canPay ? "儲值" : "正在前往……")+"\n    ")])])])}
var FBPayTips_staticRenderFns = []
var FBPayTips_esExports = { render: FBPayTips_render, staticRenderFns: FBPayTips_staticRenderFns }
/* harmony default export */ var components_FBPayTips = (FBPayTips_esExports);
// CONCATENATED MODULE: ./src/components/FBPayTips.vue
function FBPayTips_injectStyle (ssrContext) {
  __webpack_require__("McQA")
}
var FBPayTips_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var FBPayTips___vue_template_functional__ = false
/* styles */
var FBPayTips___vue_styles__ = FBPayTips_injectStyle
/* scopeId */
var FBPayTips___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var FBPayTips___vue_module_identifier__ = null
var FBPayTips_Component = FBPayTips_normalizeComponent(
  FBPayTips,
  components_FBPayTips,
  FBPayTips___vue_template_functional__,
  FBPayTips___vue_styles__,
  FBPayTips___vue_scopeId__,
  FBPayTips___vue_module_identifier__
)

/* harmony default export */ var src_components_FBPayTips = (FBPayTips_Component.exports);

// EXTERNAL MODULE: ./src/store/user.js
var store_user = __webpack_require__("wMq3");

// EXTERNAL MODULE: ./src/store/ga.js
var ga = __webpack_require__("lV9K");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GameIframe.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var gameLinkSave = ""; //用于防止研发重定向、刷新的骚操作

/* harmony default export */ var GameIframe = ({
  data: function data() {
    return {
      loginType: Account["a" /* ACCOUNT_TYPE */].loginAccount,
      accountState: false,
      isFbCanvas: window.isFbCanvas,
      asideState: false,
      pagePayLink: "", // 儲值頁跳轉鏈接
      fbPayOrderId: false, // fb canvas 储值订单号
      productId: "" //储值目标商品
    };
  },

  watch: {
    user: function user(newV, oldV) {
      if (newV && newV.id && oldV.id !== newV.id) {
        this[gamePage["b" /* LOAD_GAME_URL */]]();
        this.getGiftState();
        this.asideState = false;
      }
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["gameUrl", "user", "roleInfo", "gameId", "commonTips", "pageInfo"])),
  components: {
    AccountComponnet: Account["b" /* default */],
    AsidePopup: src_components_Aside,
    PayTips: src_components_PayTips,
    TipPopUpComponent: TipPopUpIframe["b" /* default */],
    FBPayTips: src_components_FBPayTips
  },
  created: function created() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this[store_user["b" /* GET_USER_INFO */]]({ isCheck: true });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    var _this2 = this;

    window.addEventListener("message", this.messageHandler, false);
    window.onbeforeunload = function () {
      _this2.gaStatistics({ eventName: "click_close_window" });
      return;
    };
  },

  methods: extends_default()({
    toggleAside: function toggleAside() {
      this.asideState = !this.asideState;
    },
    clickAsideBtn: function clickAsideBtn() {
      switch (this.pageInfo.asideType) {
        case "default":
          this.toggleAside();
          break;
        case "page":
          window.open("//m.gm99.com/user?isH5=1&pc=" + (window.isPhone ? 0 : 1) + "&gameId=" + this.gameId + "&serverId=" + this.roleInfo.serverId + "&roleId=" + this.roleInfo.roleId + "&roleName=" + this.roleInfo.roleName, "_blank");
          break;
        case "default":
          break;
      }
    },
    openAccountPopup: function openAccountPopup(type) {
      this.accountState = true;
      this.loginType = type;
    },
    hideAccountPopup: function hideAccountPopup() {
      this.accountState = false;
    },
    fbPay: function fbPay(params) {
      this.$refs.fbstoreiframe.contentWindow.postMessage({
        info: {
          appId: window.appInfo.appId,
          productId: params.productId,
          paytype: "facebook_local_money",
          fpaytype: "facebook_local_money",
          gameId: this.gameId,
          serverId: params.serverId,
          roleId: params.roleId,
          roleName: params.roleName,
          roleLevel: 0,
          loginAccount: this.user.name,
          currency: "TWD",
          remark: params.price || "",
          cpOrderID: params.order_no || ""
        }
      }, window.location.protocol + "//mstore.gm99.com");
    },
    pagePay: function pagePay(params) {
      this.pagePayLink = "//mstore.gm99.com" + (Object(utile["e" /* isPhone */])() ? "/mobile" : "") + "?gameId=" + this.gameId + "&serverId=" + this.roleInfo.serverId + "&roleId=" + this.roleInfo.roleId + "&roleName=" + encodeURIComponent(this.roleInfo.roleName) + "&order_no=" + params.order_no + "&productId=" + params.productId + "&productName=" + params.productName + "&price=" + params.price + "&remark=" + (params.remark || params.order_no || "") + "&publishPlatForm=pc&devicePlat=pc";
    },
    closePayTips: function closePayTips() {
      this.pagePayLink = "";
    },
    closeFbPayTips: function closeFbPayTips() {
      this.fbPayOrderId = "";
    },
    gameLoaded: function gameLoaded() {
      if (this.gameUrl && this.gameUrl !== gameLinkSave) {
        gameLinkSave = this.gameUrl;
        this.gaStatistics({ eventName: "game_load" });
      }
    },
    messageHandler: function messageHandler(evt) {
      var ev = evt || event;
      var action = ev.data.action;
      if (!!action && !!this["sdk_" + action]) {
        console.log("\u89E6\u53D1\uFF1A" + action);
        console.log(ev.data.param);
        this["sdk_" + action](ev.data.param);
      }
    },
    sdk_enter_server: function sdk_enter_server(params) {
      // this.gaStatistics({ eventName: "enter_server" });
    },
    sdk_enter_create_role_page: function sdk_enter_create_role_page() {
      this.gaStatistics({ eventName: "enter_create_role_page" });
    },
    sdk_is_role: function sdk_is_role(params) {
      this.gaStatistics({ eventName: "is_role", params: params });
    },
    sdk_get_role_info: function sdk_get_role_info(params) {
      this.$store.dispatch(gamePage["a" /* ENTER_GAME */], params);
      this.$store.commit("updateRoleInfo", params);
      this.gaStatistics({ eventName: "enter_server_role" });
    },
    sdk_get_create_role_info: function sdk_get_create_role_info(params) {
      this.$store.commit("updateRoleInfo", params);
      this.gaStatistics({ eventName: "create_role" });
    },
    sdk_pay: function sdk_pay(params) {
      this.gaStatistics({ eventName: "pay" });
      this.productId = params.productId;
      if (this.isFbCanvas) {
        this.fbPay(params);
      } else {
        this.pagePay(params);
      }
    },
    sdk_fb_share: function sdk_fb_share(href) {},
    sdk_select_server: function sdk_select_server() {
      this[gamePage["b" /* LOAD_GAME_URL */]]();
    },
    sdk_logout: function sdk_logout() {
      this.openAccountPopup(Account["a" /* ACCOUNT_TYPE */].switchAccount);
    },
    sdk_open_pay_list: function sdk_open_pay_list() {
      this.gaStatistics({ eventName: "open_pay_list" });
    },
    sdk_open_user_center: function sdk_open_user_center() {
      this.asideState = true;
    },
    sdk_enter_main_game: function sdk_enter_main_game() {
      this.gaStatistics({ eventName: "enter_game" });
    },
    sdk_enter_select_server_page: function sdk_enter_select_server_page() {
      this.gaStatistics({ eventName: "enter_server_page" });
    },
    sdk_click_create_role_btn: function sdk_click_create_role_btn() {
      this.gaStatistics({ eventName: "click_create_role" });
    },
    sdk_click_enter_game_btn: function sdk_click_enter_game_btn() {
      this.gaStatistics({ eventName: "click_enter_game" });
    },
    sdk_user_behave: function sdk_user_behave() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      console.log(params.eventName);
      // this.gaStatistics({
      //   eventName: "game_user_behave",
      //   data: params || {},
      // });
      // 绕过 上一步/账号记录 流程
      this.gaStatisticsCommon({
        eventName: "game_user_behave",
        data: extends_default()({
          is_new: Object(ga["b" /* judgeIsNewUser */])(this.user.id),
          userName: this.user.name
        }, params)
      });
    },
    sdk_get_order_succ: function sdk_get_order_succ(res) {
      if (0 == res.result) {
        this.$store.commit("updateCommonTips", {
          msg: res.msg,
          style: TipPopUpIframe["a" /* POPUP_STYLE */].bad
        });
      } else {
        this.fbPayOrderId = res.data.order_id;
      }
    },
    sdk_gerOrderSuccess: function sdk_gerOrderSuccess(res) {
      if (0 == res.result) {
        this.$store.commit("updateCommonTips", {
          msg: res.msg,
          style: TipPopUpIframe["a" /* POPUP_STYLE */].bad
        });
      } else {
        this.fbPayOrderId = res.data.order_id;
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])([gamePage["b" /* LOAD_GAME_URL */], store_user["b" /* GET_USER_INFO */], "gaStatistics", "gaStatisticsCommon", "getGiftState"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-291c9cb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GameIframe.vue
var GameIframe_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-content-box"},[(_vm.isFbCanvas)?_c('iframe',{ref:"fbstoreiframe",staticClass:"mstoreMessagePage j-mstoreMessagePage",attrs:{"src":"//mstore.gm99.com/html/h5FbCanvas.html"}}):_vm._e(),_vm._v(" "),_c('iframe',{staticClass:"game-iframe",attrs:{"src":_vm.gameUrl},on:{"load":_vm.gameLoaded}}),_vm._v(" "),(!_vm.isFbCanvas)?_c('a',{staticClass:"aside-icon j-aside-icon",on:{"click":_vm.clickAsideBtn}}):_vm._e(),_vm._v(" "),(!_vm.isFbCanvas && _vm.pageInfo.asideType == 'default')?_c('AsidePopup',{class:{ show: _vm.asideState },on:{"toggleAside":_vm.toggleAside,"openAccountPopup":_vm.openAccountPopup}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(!_vm.isFbCanvas)?_c('AccountComponnet',{directives:[{name:"show",rawName:"v-show",value:(!_vm.user.id || _vm.accountState),expression:"!user.id || accountState"}],staticClass:"loginComponent",attrs:{"loginType":_vm.loginType,"show":!_vm.user.id},on:{"hideAccountPopup":_vm.hideAccountPopup}}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('PayTips',{directives:[{name:"show",rawName:"v-show",value:(_vm.pagePayLink),expression:"pagePayLink"}],attrs:{"pageLink":_vm.pagePayLink,"pid":_vm.productId},on:{"closePayTips":_vm.closePayTips}})],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.isFbCanvas)?_c('FBPayTips',{directives:[{name:"show",rawName:"v-show",value:(_vm.fbPayOrderId),expression:"fbPayOrderId"}],attrs:{"orderId":_vm.fbPayOrderId,"pid":_vm.productId},on:{"closePayTips":_vm.closeFbPayTips}}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('TipPopUpComponent',{directives:[{name:"show",rawName:"v-show",value:(_vm.commonTips),expression:"commonTips"}]})],1)],1)}
var GameIframe_staticRenderFns = []
var GameIframe_esExports = { render: GameIframe_render, staticRenderFns: GameIframe_staticRenderFns }
/* harmony default export */ var components_GameIframe = (GameIframe_esExports);
// CONCATENATED MODULE: ./src/components/GameIframe.vue
function GameIframe_injectStyle (ssrContext) {
  __webpack_require__("Ce8h")
}
var GameIframe_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GameIframe___vue_template_functional__ = false
/* styles */
var GameIframe___vue_styles__ = GameIframe_injectStyle
/* scopeId */
var GameIframe___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GameIframe___vue_module_identifier__ = null
var GameIframe_Component = GameIframe_normalizeComponent(
  GameIframe,
  components_GameIframe,
  GameIframe___vue_template_functional__,
  GameIframe___vue_styles__,
  GameIframe___vue_scopeId__,
  GameIframe___vue_module_identifier__
)

/* harmony default export */ var src_components_GameIframe = __webpack_exports__["a"] = (GameIframe_Component.exports);


/***/ }),

/***/ "C05d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ce8h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D9U6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FSl1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isAndroid */
/* unused harmony export isIOS */
/* unused harmony export isWinPhone */
/* unused harmony export isIpad */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isPhone; });
/* unused harmony export isMobileChrome */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isFBApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isSafari; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isIE; });
/* harmony export (immutable) */ __webpack_exports__["a"] = iOSversion;
var userAgent = window.navigator.userAgent;
var ua = userAgent.toLowerCase();

var isAndroid = function isAndroid() {
    return ua.indexOf("android") > -1;
};
var isIOS = function isIOS() {
    // return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    return ua.indexOf("iphone") > -1;
};
var isWinPhone = function isWinPhone() {
    return !!navigator.userAgent.match(/windows phone/i);
};
var isIpad = function isIpad() {
    return ua.indexOf("ipad") > -1;
};
var isPhone = function isPhone() {
    return isAndroid() || isIOS() || isWinPhone() || isIpad();
};

var isMobileChrome = function isMobileChrome() {
    var runingOnChrome = false;
    var chromeInIOS = /iapd|iphone|ipod/.test(ua) && /crios/.test(ua);
    var chromeInAndroid = isAndroid() && /chrome/.test(ua);
    return chromeInIOS || chromeInAndroid;
};

var isFBApp = function isFBApp() {
    var ua = navigator.userAgent || navigator.vendor || window.opera;
    return ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1;
};

var isSafari = function isSafari() {
    var safari = /version\/[\d\.]+.*safari/.test(ua);
    return !isMobileChrome() && safari;
};

var isIE = function isIE() {
    var ua = window.navigator.userAgent;

    // Test values; Uncomment to check result …

    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

    // Edge 12 (Spartan)
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

    // Edge 13
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

    var msie = ua.indexOf('MSIE ');
    if (msie > -1) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > -1) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    var edge = ua.indexOf('Edge/');
    if (edge > -1) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
};

function iOSversion() {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
        // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
        var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
        return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
    }
}

/***/ }),

/***/ "G1L6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GQna":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__("j1ja");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./src/pages/pc/directive/resize.js
// 因为设计稿的没有考虑到需求要兼容到所有的屏幕。
// 为了让h5 游戏更好的兼容到各个屏幕，整个屏幕的所有元素都要根据 计算出来的比例进行缩放，达到适配所有屏幕的效果。

var fullScreenMode = false;

var getConfigSize = function getConfigSize() {
  var isVerticalGame = !window.pageInfo.horizontal; //是否竖屏
  var orginPhoneWidth = isVerticalGame ? 702 : 2200;
  var orginPhoneHeight = isVerticalGame ? 1182 : 1398; //1144
  var phoneScale = orginPhoneWidth / orginPhoneHeight; //phone 背景图比例
  return {
    isVerticalGame: isVerticalGame,
    minWidth: 1024,
    orginPhoneWidth: orginPhoneWidth,
    orginPhoneHeight: orginPhoneHeight, //1144
    phoneScale: phoneScale, //phone 背景图比例
    minHeight: 1024 * phoneScale,
    desizeWidth: 1920,
    desizeHeight: 1215,
    desizeScale: 1920 / 1215,
    orignAsideWidth: 223,
    orignAsideHeight: 840,
    FULL_SCREEN_MIN_HEIGHT: 400,
    BASE_WIDTH: 0,
    BASE_HEIGHT: 1,
    FULL_SCREEN: 2
  };
};

var isBigScreen = function isBigScreen() {
  // 判定用户屏幕的宽度或者高度比开发这的屏幕大，则 使用根据宽高计算到缩放比例。
  var width = window.innerWidth;
  var height = window.innerHeight;
  return width > 1280 && height > 703;
};

var setPhoneSize = function setPhoneSize(el, fullScreen, conf) {
  //先通过屏幕宽高 和设计稿的宽高 去计算元素的缩放比例。
  var el_parent = el.parentElement;
  var winHeight = window.innerHeight;
  var winWidth = window.innerWidth;
  var currentHeight = fullScreen ? conf.FULL_SCREEN_MIN_HEIGHT : conf.minHeight;
  // max(currentHeight,winHeight)
  if (conf.isVerticalGame) {
    var parentHeight = winHeight < currentHeight ? currentHeight : winHeight;
  } else {
    var parentHeight = winHeight < currentHeight ? winHeight : currentHeight;
    parentHeight -= 70;
  }
  // max(winWidth,minWidth)
  var parentWidth = winWidth < conf.minWidth ? conf.minWidth : winWidth;
  // 设置手机壳的大小
  setParentWidth({
    width: parentWidth,
    height: parentHeight
  }, el_parent);
  resizePhoneStyle({
    el: el,
    parentHeight: parentHeight,
    parentWidth: parentWidth,
    fullScreen: fullScreen,
    conf: conf
  });
};

var resizePhoneStyle = function resizePhoneStyle(_ref) {
  var el = _ref.el,
      parentWidth = _ref.parentWidth,
      parentHeight = _ref.parentHeight,
      fullScreen = _ref.fullScreen,
      conf = _ref.conf;

  //如果当前父元素的宽高比例小于设置的比例
  //证明当前浏览器的状态处于 宽度缩小的状态，基于宽度去计算高度
  // 否则，都基于高度去计算宽度
  var resitStyle = parentWidth / parentHeight < conf.desizeScale ? conf.BASE_WIDTH : conf.BASE_HEIGHT;
  resitStyle = fullScreen ? conf.FULL_SCREEN : resitStyle;

  var width = 0;
  var height = 0;
  switch (resitStyle) {
    case conf.BASE_WIDTH:
      {
        width = parentWidth / conf.desizeWidth * conf.orginPhoneWidth;
        height = width / conf.phoneScale;
      }
      break;
    case conf.BASE_HEIGHT:
      {
        height = parentHeight / conf.desizeHeight * conf.orginPhoneHeight;
        width = height * conf.phoneScale;
      }
      break;
    case conf.FULL_SCREEN:
      {
        var winHeight = window.innerHeight;
        var winWidth = window.innerWidth;
        parentHeight = winHeight < conf.FULL_SCREEN_MIN_HEIGHT ? conf.FULL_SCREEN_MIN_HEIGHT : winHeight;
        height = parentHeight;
        width = height * conf.phoneScale;
      }
      break;
  }
  var scaleRatio = 0.9 * width / conf.orginPhoneWidth;
  setPhoneStyle({
    el: el,
    width: width,
    height: height,
    scaleRatio: scaleRatio,
    conf: conf
  });
  setAsideStyle(el, scaleRatio, conf);
  setOpsContainerStyle(el, scaleRatio, conf);
  setBtnsStyle(el, scaleRatio, conf);
  setcurrentGameStyle(el, scaleRatio, conf);
  setFillScreenBtnStyle(el, scaleRatio, conf);
  setQrCodeStyle(el, scaleRatio, conf);
  setAccountStyle(el, scaleRatio, conf);
  setFloatIconStyle(el, scaleRatio, conf);
  setAsidePopupStyle(el, scaleRatio, conf);
  setGiftPopupStyle(el, scaleRatio, conf);
  setPayTipsStyle(el, scaleRatio, conf);
  setCommonTips(el, scaleRatio, conf);
};

var setCommonTips = function setCommonTips(el, scaleRatio) {
  var ele = el.querySelector(".j-popup-tip");
  if (ele) {
    var reals = scaleRatio + 0.2;
    ele.style.transform = "scale(" + reals + ")";
  }
};

var setPayTipsStyle = function setPayTipsStyle(el, scaleRatio) {
  var ele = el.querySelector(".j-pay-tips");
  if (ele) {
    var reals = scaleRatio + 0.03;
    ele.style.transform = "scale(" + reals + ")";
  }
};

var setGiftPopupStyle = function setGiftPopupStyle(el, scaleRatio) {
  var ele = el.querySelectorAll(".j-gift-popup");
  for (var i = 0; i < ele.length; i++) {
    ele[i].style.transform = "scale(" + scaleRatio + ")";
    ele[i].style.transformOrigin = "center";
  }
};

var setAsidePopupStyle = function setAsidePopupStyle(el, scaleRatio) {
  var ele = el.querySelector(".j-aside-popup");
  var elebg = el.querySelector(".j-aside-bg");
  if (ele) {
    ele.style.transform = "scale(" + scaleRatio + ")";
    ele.style.transformOrigin = "right top";
  }
  if (elebg) {
    elebg.style.transform = "scaleX(" + scaleRatio + ")";
    elebg.style.transformOrigin = "right";
  }
};

var setFloatIconStyle = function setFloatIconStyle(el, scaleRatio) {
  var ele = el.querySelector(".j-aside-icon");
  if (ele) {
    ele.style.transform = "scale(" + scaleRatio + ")";
    ele.style.transformOrigin = "right";
    ele.style.top = 220 * scaleRatio + "px";
  }
};

var setAccountStyle = function setAccountStyle(el, scaleRatio) {
  var account_ele = el.querySelector(".j-account-form-wrapper");
  var reals = scaleRatio - 0.03;
  if (account_ele) {
    account_ele.style.transform = "scale(" + reals + ")";
  }
};

var setAddDesktopAlertStyle = function setAddDesktopAlertStyle(el, scaleRatio, parentWidth, conf) {
  // 使用scale 进行缩放，并且是左上角缩放，而不是中心缩放。
  var el_btn = el.querySelector(".j-add-desktop");
  if (el_btn) {
    el_btn.style.transform = "scale(" + scaleRatio + ")";
    el_btn.style.transformOrigin = "0";
    el_btn.style.left = parentWidth + "px";
    // 122 - 162 设计稿上的相对于父元素的绝对定位 值。122 - 162
    el_btn.style.top = conf.isVerticalGame ? (122 - 162) * scaleRatio + "px" : -10 * scaleRatio + "px";
  }
};

var setQrCodeStyle = function setQrCodeStyle(el, scaleRatio, conf) {
  //0.478003 为 在浏览器中调试得到的一个比较适合的最小值
  var el_qrCode = el.querySelector(".j-qr-code-container");
  if (el_qrCode) {
    scaleRatio = scaleRatio > 0.478003 ? scaleRatio : 0.478003;
    el_qrCode.style.transform = "scale(" + scaleRatio + ")";
  }
};

var setPhoneStyle = function setPhoneStyle(_ref2) {
  var el = _ref2.el,
      width = _ref2.width,
      height = _ref2.height,
      scaleRatio = _ref2.scaleRatio,
      conf = _ref2.conf;

  if (pageInfo.gameSize == "big" && !conf.isVerticalGame) {
    el.style.width = "100%";
    el.style.height = "100%";
    return;
  }
  var originPaddingTop = conf.isVerticalGame ? 99 : 188;
  var originPaddingbottom = conf.isVerticalGame ? 104 : 184;
  var originPaddingLeft = conf.isVerticalGame ? 40 : 264;
  var originPaddingRight = conf.isVerticalGame ? 40 : 264;
  var paddingTop = originPaddingTop * scaleRatio;
  var paddingBtm = originPaddingbottom * scaleRatio;
  var paddingLeft = originPaddingLeft * scaleRatio;
  var paddingRight = originPaddingRight * scaleRatio;
  el.style.width = width + "px";
  el.style.height = height + "px";
  el.style.paddingTop = paddingTop + "px";
  el.style.paddingBottom = paddingBtm + "px";
  el.style.paddingLeft = paddingLeft + "px";
  el.style.paddingRight = paddingRight + "px";

  var vmaxT = -36;
  var hmaxT = -100;
  var topD = conf.isVerticalGame ? vmaxT / scaleRatio : hmaxT * scaleRatio;

  el.style.top = topD + "px";
};

var setParentWidth = function setParentWidth(_ref3, el_parent) {
  var width = _ref3.width,
      height = _ref3.height;

  el_parent.style.height = height + "px";
  el_parent.style.width = width + "px";
};

var setAsideStyle = function setAsideStyle(el, scaleRatio, conf) {
  scaleRatio = isBigScreen() ? scaleRatio : scaleRatio * 1.15;
  var asideHeight = conf.orignAsideHeight * scaleRatio;
  var asideWidth = conf.orignAsideWidth * scaleRatio;
  var asideTop = 160 * scaleRatio;
  var opersHeight = 418 * scaleRatio;
  var tisWidth = 208 * scaleRatio;
  var tisHeight = 422 * scaleRatio;
  var el_aside = el.querySelector(".j-platform-operas");
  var el_operas = el.querySelector(".j-operas");
  var el_tips = el.querySelector(".j-tips");
  if (el_aside) {
    el_aside.style.width = asideWidth + "px";
    el_aside.style.left = conf.isVerticalGame ? -asideWidth - 28 + "px" : -asideWidth + 20 + "px";
    el_aside.style.height = asideHeight + "px";
    el_aside.style.top = asideTop + "px";
  }
  if (el_operas) {
    el_operas.style.height = opersHeight + "px";
  }
  if (el_tips) {
    el_tips.style.width = tisWidth + "px";
    el_tips.style.height = tisHeight + "px";
  }

  setAddDesktopAlertStyle(el, scaleRatio, asideWidth, conf);
};

var setOpsContainerStyle = function setOpsContainerStyle(el, scaleRatio) {
  scaleRatio = isBigScreen() ? scaleRatio : scaleRatio * 1.15;
  var width = 141 * scaleRatio;
  var height = 257 * scaleRatio;
  var marginTop = 65 * scaleRatio;
  var marginRight = 8 * scaleRatio;
  var gameNameMarginTop = 6 * scaleRatio;
  var fontSize = 18 * scaleRatio;
  var gameNamefontSize = 18 * scaleRatio;
  var el_operasContianer = el.querySelector(".j-ops-contianer");
  if (el_operasContianer) {
    el_operasContianer.style.height = height + "px";
    el_operasContianer.style.width = width + "px";
    el_operasContianer.style.marginTop = marginTop + "px";
    el_operasContianer.style.marginRight = marginRight + "px";
    el_operasContianer.style.fontSize = fontSize + "px";
    el.querySelector(".j-game-name").style.marginTop = gameNameMarginTop + "px";
  }
};

var setcurrentGameStyle = function setcurrentGameStyle(el, scaleRatio) {
  var height = 63 * scaleRatio;
  var el_currentGame = el.querySelector(".j-current-game");
  if (el_currentGame) {
    el_currentGame.style.height = height + "px";
  }
};

var setBtnsStyle = function setBtnsStyle(el, scaleRatio) {
  scaleRatio = isBigScreen() ? scaleRatio : scaleRatio * 1.2;
  var btnHeight = 50 * scaleRatio;
  var el_OpBtns = el.querySelectorAll(".j-ops-btn");
  for (var i = 0, len = el_OpBtns.length; i < len; i++) {
    el_OpBtns[i].style.height = btnHeight + "px";
    el_OpBtns[i].style.lineHeight = btnHeight + "px";
  }
};

var setFillScreenBtnStyle = function setFillScreenBtnStyle(el, scaleRatio, conf) {
  var littleScreenRatio = scaleRatio * 1.5;
  var btnHeight = 147 * littleScreenRatio;

  var btnWdith = 35 * littleScreenRatio;
  if (btnHeight > 110.37 || btnHeight > 26.2786) {
    btnHeight = 110.37;
    btnWdith = 26.2786;
  }
  var right = conf.isVerticalGame ? -7 * littleScreenRatio - btnWdith : littleScreenRatio * 8;

  var fillScreenBtnTop = 200 * scaleRatio;
  var el_fillScreenBtn = el.querySelector(".j-fill-screen-btn");
  if (el_fillScreenBtn) {
    el_fillScreenBtn.style.top = fillScreenBtnTop + "px";
    el_fillScreenBtn.style.height = btnHeight + "px";
    el_fillScreenBtn.style.width = btnWdith + "px";
    el_fillScreenBtn.style.right = right + "px";
  }
};

/* harmony default export */ var resize = ({
  inserted: function inserted(el, binding) {
    var conf = getConfigSize();
    //当元素 插入到dom 中，才能通过document.querySelector() 获取到对应的元素
    setPhoneSize(el, binding.value, conf);
    window.addEventListener("resize", function () {
      var conf = getConfigSize();
      setPhoneSize(el, fullScreenMode, conf);
    });
  },
  componentUpdated: function componentUpdated(el, binding, oldNode) {
    console.log(binding);
    //当元素的内容发生改变后（全屏）需要重新计算屏幕显示的比例
    if (fullScreenMode != binding.value) {
      var conf = getConfigSize();
      setPhoneSize(el, binding.value, conf);
    }
    fullScreenMode = binding.value;
  }
});
// EXTERNAL MODULE: ./src/components/GameIframe.vue + 17 modules
var GameIframe = __webpack_require__("9ilI");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/store/ultile.js + 2 modules
var ultile = __webpack_require__("VtGx");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/QrCode.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var qrCodeAjax = "//passport.gm99.com/ajax/h5_qrcode?" + Object(ultile["f" /* getAllParamsFromHref */])(true);

/* harmony default export */ var QrCode = ({
  data: function data() {
    return {
      showQrCode: false,
      timeout: false,
      beforeLaodQrCode: true
    };
  },

  computed: extends_default()({
    qrCodeSRc: function qrCodeSRc() {
      var timesmap = new Date().getTime();
      if (!this.user.id || this.showQrCode && !this.timeout) {
        return qrCodeAjax + "&v=" + timesmap;
      }
      return "";
    },
    qrCodeTipe: function qrCodeTipe() {
      if (this.timeout && !this.showQrCode && this.user.id) {
        return "您的QR CODE<br>已失效";
      }
      return "用手機掃一下也能<br>在手機上玩唷~";
    }
  }, Object(vuex_esm["c" /* mapGetters */])(["user"])),
  methods: {
    loadQRCode: function loadQRCode() {
      var _this = this;

      if (this.showQrCode) {
        return "";
      }
      this.timeout = false;
      this.showQrCode = true;
      this.beforeLaodQrCode = false;
      setTimeout(function () {
        _this.timeout = true;
        _this.showQrCode = false;
      }, 1000 * 60 * 5);
      /*
                二维码的状态：未登录，未加载，已加载 ， 已过时
                未登录 beforeLaodQrCode值为true。显示一张登录跳转的二维码。登录后，点击加载后，值变为true.
                未加载 显示点击加载二维码的提示 showQrCode 控制二维码的显示情况。点击后showQrCode 为true.
                已过时 当二维码显示超过五分钟后，会过期，需要提示用户重新点击加载一个新的二维码。
            */
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c9e9a71","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/QrCode.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qr-code-container j-qr-code-container"},[_c('p',{staticClass:"txt-tips",domProps:{"innerHTML":_vm._s(_vm.qrCodeTipe)}}),_vm._v(" "),_c('div',{staticClass:"qr-code-wrapper j-load-qr-code",class:{
      qrcodeWrapperLogined: _vm.user.id && !_vm.showQrCode,
      qrCodeWrapperLoaded: _vm.user.id && _vm.showQrCode && !_vm.timeout,
      qrCodeWrapper: !_vm.user.id
    },on:{"click":_vm.loadQRCode}},[(_vm.user.id && !_vm.showQrCode)?_c('div',{staticClass:"line"}):_vm._e(),_vm._v(" "),(_vm.user.id && !_vm.showQrCode)?_c('div',{staticClass:"img-tips",class:{
        load: _vm.beforeLaodQrCode && !_vm.timeout,
        refresh: !_vm.beforeLaodQrCode && _vm.timeout
      }}):_vm._e(),_vm._v(" "),(!_vm.user.id || (_vm.showQrCode && !_vm.timeout))?_c('img',{staticClass:"qr-code-img",attrs:{"src":_vm.qrCodeSRc}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_QrCode = (esExports);
// CONCATENATED MODULE: ./src/components/QrCode.vue
function injectStyle (ssrContext) {
  __webpack_require__("TBqg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  QrCode,
  components_QrCode,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_QrCode = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GiftListPopup.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var GiftListPopup = ({
  computed: extends_default()({
    fontcolor: function fontcolor() {
      return "color:" + this.pageInfo.color.font;
    },
    mainColor: function mainColor() {
      return "color:" + this.pageInfo.color.main;
    },
    borderColor: function borderColor() {
      return "border-color:" + this.pageInfo.color.border;
    },
    theadCss: function theadCss() {
      return "border-color:" + this.pageInfo.color.border + ";background-color:" + this.pageInfo.color.tableBg;
    },
    favourGiftContent: function favourGiftContent() {
      return this.giftState.like_award ? this.pageInfo.gift.favourContent : "-";
    },
    downloadGiftContent: function downloadGiftContent() {
      return this.giftState.download_award ? this.pageInfo.gift.downloadContent : "-";
    },
    favourGiftCard: function favourGiftCard() {
      return this.giftState.like_award_card || "-";
    },
    downloadGiftCard: function downloadGiftCard() {
      return this.giftState.download_award_card || "-";
    }
  }, Object(vuex_esm["c" /* mapGetters */])(["giftState", "pageInfo"])),
  methods: {
    closePopup: function closePopup() {
      this.$store.commit("updateState", {
        action: "giftListPopupState",
        value: false
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01041245","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GiftListPopup.vue
var GiftListPopup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gift-list-popup"},[_c('img',{attrs:{"src":_vm.pageInfo.img.bigPopup}}),_vm._v(" "),_c('a',{staticClass:"close",attrs:{"href":"javascript:;"},on:{"click":_vm.closePopup}}),_vm._v(" "),_c('div',{staticClass:"content",style:(_vm.fontcolor)},[_c('p',{staticClass:"title",style:(_vm.mainColor)},[_vm._v("查詢獎勵")]),_vm._v(" "),_c('div',{staticClass:"table"},[_c('table',[_c('thead',[_c('tr',[_c('th',{style:(_vm.theadCss)},[_vm._v("獎勵")]),_vm._v(" "),_c('th',{style:(_vm.theadCss)},[_vm._v("物品")]),_vm._v(" "),_c('th',{style:(_vm.theadCss)},[_vm._v("禮包兌換碼")])])])])]),_vm._v(" "),_c('div',{staticClass:"table table-content",style:(_vm.borderColor)},[_c('table',[_c('tbody',[_c('tr',[_c('td',{style:(_vm.borderColor)},[_vm._v("收藏禮包")]),_vm._v(" "),_c('td',{style:(_vm.borderColor),domProps:{"innerHTML":_vm._s(_vm.favourGiftContent)}}),_vm._v(" "),_c('td',{style:(_vm.borderColor)},[_vm._v(_vm._s(_vm.favourGiftCard))])]),_vm._v(" "),_c('tr',[_c('td',{style:(_vm.borderColor)},[_vm._v("下載禮包")]),_vm._v(" "),_c('td',{style:(_vm.borderColor),domProps:{"innerHTML":_vm._s(_vm.downloadGiftContent)}}),_vm._v(" "),_c('td',{style:(_vm.borderColor)},[_vm._v(_vm._s(_vm.downloadGiftCard))])])])])]),_vm._v(" "),_c('p',{staticClass:"tips",style:(_vm.mainColor),domProps:{"innerHTML":_vm._s(_vm.pageInfo.gift.exchangeTips)}})])])}
var GiftListPopup_staticRenderFns = []
var GiftListPopup_esExports = { render: GiftListPopup_render, staticRenderFns: GiftListPopup_staticRenderFns }
/* harmony default export */ var components_GiftListPopup = (GiftListPopup_esExports);
// CONCATENATED MODULE: ./src/components/GiftListPopup.vue
function GiftListPopup_injectStyle (ssrContext) {
  __webpack_require__("ep7n")
}
var GiftListPopup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GiftListPopup___vue_template_functional__ = false
/* styles */
var GiftListPopup___vue_styles__ = GiftListPopup_injectStyle
/* scopeId */
var GiftListPopup___vue_scopeId__ = "data-v-01041245"
/* moduleIdentifier (server only) */
var GiftListPopup___vue_module_identifier__ = null
var GiftListPopup_Component = GiftListPopup_normalizeComponent(
  GiftListPopup,
  components_GiftListPopup,
  GiftListPopup___vue_template_functional__,
  GiftListPopup___vue_styles__,
  GiftListPopup___vue_scopeId__,
  GiftListPopup___vue_module_identifier__
)

/* harmony default export */ var src_components_GiftListPopup = (GiftListPopup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GiftGetPopup.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var GiftGetPopup = ({
  computed: extends_default()({
    fontcolor: function fontcolor() {
      return "color:" + this.pageInfo.color.font;
    },
    mainColor: function mainColor() {
      return "color:" + this.pageInfo.color.main;
    },
    numberColor: function numberColor() {
      return "color:" + this.pageInfo.color.font + ";background-color:" + this.pageInfo.color.tableBg;
    }
  }, Object(vuex_esm["c" /* mapGetters */])(["giftNumberGetPopupState", "pageInfo"])),
  methods: {
    closePopup: function closePopup() {
      this.$store.commit("updateState", {
        action: "giftNumberGetPopupState",
        value: ""
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4715c2a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GiftGetPopup.vue
var GiftGetPopup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gift-get-popup"},[_c('img',{attrs:{"src":_vm.pageInfo.img.normalPopup}}),_vm._v(" "),_c('a',{staticClass:"close",attrs:{"href":"javascript:;"},on:{"click":_vm.closePopup}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('p',{staticClass:"title",style:(_vm.mainColor)},[_vm._v("恭喜獲得禮包兌換碼")]),_vm._v(" "),_c('p',{staticClass:"text pretitle",style:(_vm.fontcolor)},[_vm._v("收藏頁面到瀏覽器，方便下次再玩喔～")]),_vm._v(" "),_c('p',{staticClass:"number",style:(_vm.numberColor)},[_vm._v(_vm._s(_vm.giftNumberGetPopupState))]),_vm._v(" "),_c('p',{staticClass:"tips",style:(_vm.mainColor)},[_vm._v("兌換說明:")]),_vm._v(" "),_c('p',{staticClass:"text",style:(_vm.fontcolor)},[_vm._v("1、"+_vm._s(_vm.pageInfo.gift.exchangeTips))]),_vm._v(" "),_c('p',{staticClass:"text",style:(_vm.fontcolor)},[_vm._v("2、一個帳號只能兌換一次下載禮包")])])])}
var GiftGetPopup_staticRenderFns = []
var GiftGetPopup_esExports = { render: GiftGetPopup_render, staticRenderFns: GiftGetPopup_staticRenderFns }
/* harmony default export */ var components_GiftGetPopup = (GiftGetPopup_esExports);
// CONCATENATED MODULE: ./src/components/GiftGetPopup.vue
function GiftGetPopup_injectStyle (ssrContext) {
  __webpack_require__("gRuC")
}
var GiftGetPopup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GiftGetPopup___vue_template_functional__ = false
/* styles */
var GiftGetPopup___vue_styles__ = GiftGetPopup_injectStyle
/* scopeId */
var GiftGetPopup___vue_scopeId__ = "data-v-4715c2a0"
/* moduleIdentifier (server only) */
var GiftGetPopup___vue_module_identifier__ = null
var GiftGetPopup_Component = GiftGetPopup_normalizeComponent(
  GiftGetPopup,
  components_GiftGetPopup,
  GiftGetPopup___vue_template_functional__,
  GiftGetPopup___vue_styles__,
  GiftGetPopup___vue_scopeId__,
  GiftGetPopup___vue_module_identifier__
)

/* harmony default export */ var src_components_GiftGetPopup = (GiftGetPopup_Component.exports);

// CONCATENATED MODULE: ./src/directive/footer.js
var timer = void 0;
/**
 * 下一列链接
 * @param  {[type]}   argument [description]
 * @return {Function}          [description]
 */
var next = function next(el) {
    if (el.style.transform === "translate(0px, -15px)") {
        el.style.transform = "translate(0,0px)";
        el.style.transition = "transform 1s";
    } else {
        el.style.transform = "translate(0,-15px)";
        el.style.transition = "transform 1s";
    }
};

/**
 * 上一列链接
 * @return {[type]} [description]
 */
var pre = function pre(el) {

    if (el.style.transform === "translate(0px, 0px") {
        el.style.transform = "translate(0,-15px)";
        el.style.transition = "transform 1s";
    } else {
        el.style.transform = "translate(0,0)";
        el.style.transition = "transform 1s";
    }
};

/* harmony default export */ var footer = ({
    inserted: function inserted(el) {
        var el_footerLinkBox = el.querySelector("#links-inner");
        var el_footerLinkPre = el.querySelector("#top-arrow");
        var el_footerLinkNext = el.querySelector("#bottom-arrow");

        timer = setInterval(function () {
            next(el_footerLinkBox);
        }, 5000);

        el_footerLinkPre.addEventListener('click', function () {
            clearInterval(timer);
            pre(el_footerLinkBox);
            timer = setInterval(function () {
                pre(el_footerLinkBox);
            }, 5000);
        });
        el_footerLinkNext.addEventListener('click', function () {
            clearInterval(timer);
            next(el_footerLinkBox);
            timer = setInterval(function () {
                next(el_footerLinkBox);
            }, 5000);
        });
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PcFooter.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var PcFooter = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["pageInfo"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2402d938","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PcFooter.vue
var PcFooter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"pc-footer"},[_c('div',{staticClass:"footer-box"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',[_c('i',{staticClass:"grade",class:("class-" + (_vm.pageInfo.gameClass))}),_vm._v(" "),_c('p',{staticClass:"grade-t"},[_vm._v(_vm._s(_vm.pageInfo.classText.text1))]),_vm._v(" "),_c('p',{staticClass:"grade-t"},[_vm._v(_vm._s(_vm.pageInfo.classText.text2))]),_vm._v(" "),_c('p',{staticClass:"grade-t"},[_vm._v(_vm._s(_vm.pageInfo.classText.text3))])]),_vm._v(" "),_vm._m(1)])])])}
var PcFooter_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left"},[_c('a',{staticClass:"logo",attrs:{"href":"//www.gm99.com","target":"_blank"}}),_vm._v(" "),_c('p',{staticClass:"copyright"},[_vm._v("©Copyright 2021 www.gm99.com All Rights Reserved.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"link-group"},[_c('a',{staticClass:"link",attrs:{"target":"_blank","href":"//service.gm99.com/about/abouts.html"}},[_vm._v("關於我們")]),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"target":"_blank","href":"//service.gm99.com/about/termsofuse.html"}},[_vm._v("服務條款")]),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"target":"_blank","href":"//service.gm99.com/about/cooperation.html"}},[_vm._v("合作提案")]),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"target":"_blank","href":"//service.gm99.com/"}},[_vm._v("客服中心")])])}]
var PcFooter_esExports = { render: PcFooter_render, staticRenderFns: PcFooter_staticRenderFns }
/* harmony default export */ var components_PcFooter = (PcFooter_esExports);
// CONCATENATED MODULE: ./src/components/PcFooter.vue
function PcFooter_injectStyle (ssrContext) {
  __webpack_require__("GatL")
}
var PcFooter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PcFooter___vue_template_functional__ = false
/* styles */
var PcFooter___vue_styles__ = PcFooter_injectStyle
/* scopeId */
var PcFooter___vue_scopeId__ = "data-v-2402d938"
/* moduleIdentifier (server only) */
var PcFooter___vue_module_identifier__ = null
var PcFooter_Component = PcFooter_normalizeComponent(
  PcFooter,
  components_PcFooter,
  PcFooter___vue_template_functional__,
  PcFooter___vue_styles__,
  PcFooter___vue_scopeId__,
  PcFooter___vue_module_identifier__
)

/* harmony default export */ var src_components_PcFooter = (PcFooter_Component.exports);

// EXTERNAL MODULE: ./src/store/pc/index.js
var pc = __webpack_require__("xBpH");

// EXTERNAL MODULE: ./src/components/TipPopUpIframe.vue + 2 modules
var TipPopUpIframe = __webpack_require__("9Roz");

// CONCATENATED MODULE: ./src/mixins/Download.js




/* harmony default export */ var Download = ({
  computed: extends_default()({
    downloadLink: function downloadLink() {
      return "//m.gm99.com/h5/page/download" + window.location.search;
    },
    isDownloadAward: function isDownloadAward() {
      return this.pageInfo.gift.download;
    },
    isNormalGift: function isNormalGift() {
      return this.pageInfo.gift.type === "game";
    },
    isNumberGift: function isNumberGift() {
      return this.pageInfo.gift.type === "number";
    }
  }, Object(vuex_esm["c" /* mapGetters */])(["user", "roleInfo", "giftState", "gameId", "pageInfo"])),
  methods: extends_default()({
    downloadFn: function downloadFn() {
      var _this = this;

      // 如果沒有發獎，就直接下载
      if (!this.isDownloadAward) {
        this.doDownload();
        return;
      }

      // 如果還沒進入遊戲，就提示要先進遊戲
      if (!(this.user.id && this.roleInfo.roleId)) {
        this.doDownload("請先進入遊戲再下載，確保獎勵發送至您的郵箱哦～");
        return;
      }

      // 如果已經領過了，就提示已領
      if (this.giftState.download_award) {
        this.doDownload("您已獲得過獎勵哦～");
        return;
      }

      this.doDownload();
      this.$store.dispatch("get_save_gift", "download").then(function (data) {
        _this.$store.commit("updateGiftState", {
          action: "download",
          value: true
        });
        if (_this.isNormalGift) {
          _this.doFavour("獎勵已發送至您的郵箱~");
        }
        if (_this.isNumberGift) {
          _this.$store.commit("updateState", {
            action: "giftNumberGetPopupState",
            value: data.card
          });
          _this.$store.commit("updateGiftCard", {
            action: "download",
            value: data.card
          });
        }
        _this.gaStatistics({ eventName: "download_gift" });
      }, function (res) {
        _this.doDownload("獎勵領取失敗，請稍候再試", TipPopUpIframe["a" /* POPUP_STYLE */].bad, true);
      });
    },
    doDownload: function doDownload(text) {
      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TipPopUpIframe["a" /* POPUP_STYLE */].good;
      var onlyAlert = arguments[2];

      if (!onlyAlert) {
        window.open(this.downloadLink, "_blank");
      }

      if (text) {
        this.$store.commit("updateCommonTips", {
          msg: text,
          style: style
        });
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(["gaStatistics"]))
});
// CONCATENATED MODULE: ./src/mixins/Favour.js




/* harmony default export */ var Favour = ({
  computed: extends_default()({
    isFavourAward: function isFavourAward() {
      return this.pageInfo.gift.favour;
    },
    isNormalGift: function isNormalGift() {
      return this.pageInfo.gift.type === "game";
    },
    isNumberGift: function isNumberGift() {
      return this.pageInfo.gift.type === "number";
    }
  }, Object(vuex_esm["c" /* mapGetters */])(["user", "giftState", "roleInfo", "pageInfo"])),
  methods: extends_default()({
    favourFn: function favourFn() {
      var _this = this;

      // 如果沒有發獎，就直接提示收藏
      if (!this.isFavourAward) {
        this.doFavour("收藏頁面到瀏覽器，方便下次再玩喔～");
        return;
      }

      // 如果還沒進入遊戲，就提示要先進遊戲
      if (!(this.user.id && this.roleInfo.roleId)) {
        this.doFavour("請先進入遊戲再收藏，確保獎勵發送至您的郵箱哦～");
        return;
      }

      // 如果已經領過了，就提示已領
      if (this.giftState.like_award) {
        this.doFavour("您已獲得過獎勵哦～");
        return;
      }

      this.doFavour();
      this.$store.dispatch("get_save_gift", "like").then(function (data) {
        _this.$store.commit("updateGiftState", {
          action: "like",
          value: true
        });
        if (_this.isNormalGift) {
          _this.doFavour("獎勵已發送至您的郵箱~");
        }
        if (_this.isNumberGift) {
          _this.$store.commit("updateState", {
            action: "giftNumberGetPopupState",
            value: data.card
          });
          _this.$store.commit("updateGiftCard", {
            action: "like",
            value: data.card
          });
        }
        _this.gaStatistics({ eventName: "favour_gift" });
      }, function (res) {
        _this.doFavour("獎勵領取失敗，請稍候再試", TipPopUpIframe["a" /* POPUP_STYLE */].bad, true);
      });
    },
    doFavour: function doFavour(text) {
      var _this2 = this;

      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TipPopUpIframe["a" /* POPUP_STYLE */].good;
      var onlyAlert = arguments[2];

      if (!onlyAlert) {
        var curTitle = window.pageInfo["title"] || window.gameInfo["NAME"] || "";
        try {
          window.external.addFavorite(window.location.href, curTitle);
        } catch (e) {
          try {
            window.sidebar.addPanel(curTitle, window.location.href, "");
          } catch (e) {
            this.$store.commit("updateTipMsg", "加入收藏失敗，請使用Ctrl+D進行添加");
          }
        }
      }

      this.$nextTick(function () {
        if (text) {
          _this2.$store.commit("updateCommonTips", {
            msg: text,
            style: style
          });
        }
      });
    }
  }, Object(vuex_esm["b" /* mapActions */])(["gaStatistics"]))
});
// EXTERNAL MODULE: ./src/components/Account.vue + 2 modules
var Account = __webpack_require__("uK6g");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PcHeader.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var PcHeader = ({
  data: function data() {
    return {
      accountBoxState: false,
      login_type: Account["a" /* ACCOUNT_TYPE */],
      gameSite: window.gameSite
    };
  },

  mixins: [Download, Favour],
  mounted: function mounted() {
    this.$store.dispatch(pc["a" /* UNREAD_MSG */]);
    if (window.pageInfo.apkDownload) {
      this.$store.dispatch("getWebsiteInfo");
    }
  },

  computed: extends_default()({
    fontColor: function fontColor() {
      return "color:" + this.pageInfo.color.font;
    },
    avatar: function avatar() {
      return this.user.id && this.user.avatar ? this.user.avatar + "?v=" + new Date().getTime() : "";
    },
    headerAdState: function headerAdState() {
      if (!this.pageInfo.headerAd.href) {
        return false;
      }
      var startTime = new Date(this.pageInfo.headerAd.startTime).getTime();
      var endTime = new Date(this.pageInfo.headerAd.endTime).getTime();
      var now = new Date().getTime();
      return now > startTime && now < endTime;
    }
  }, Object(vuex_esm["c" /* mapGetters */])(["user", "unreadMsg", "pageInfo"]), Object(vuex_esm["d" /* mapState */])(["apkUrl"])),
  methods: {
    toggleAccountBox: function toggleAccountBox() {
      this.accountBoxState = !this.accountBoxState;
    },
    showAccount: function showAccount(type) {
      this.accountBoxState = false;
      this.$emit("showAccount", type);
    },
    openGiftList: function openGiftList() {
      this.$store.commit("updateState", {
        action: "giftListPopupState",
        value: true
      });
    },
    toggleFullScreen: function toggleFullScreen() {
      this.$store.commit("toggleFullScreenState");
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-546dbb8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PcHeader.vue
var PcHeader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"pc-header"},[_c('div',{staticClass:"pc-header-wrapper"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"account-wrapper"},[(_vm.pageInfo.headerAd && _vm.pageInfo.headerAd.href)?_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.headerAdState),expression:"headerAdState"}],staticClass:"ad-btn",attrs:{"href":_vm.pageInfo.headerAd.href,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.pageInfo.headerAd.img}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"account-info"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.id),expression:"user.id"}],staticClass:"logined"},[_c('div',{staticClass:"account-box",on:{"click":_vm.toggleAccountBox}},[_c('a',{staticClass:"account-anchor"},[_c('img',{staticClass:"avatar",attrs:{"src":_vm.avatar}})]),_vm._v(" "),_c('span',{staticClass:"user-name showOps"},[_vm._v(_vm._s(_vm.user.name))]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('nav',{directives:[{name:"show",rawName:"v-show",value:(_vm.accountBoxState),expression:"accountBoxState"}],staticClass:"account-opera"},[_vm._m(2),_vm._v(" "),_c('a',{staticClass:"account-message opBtn",attrs:{"href":"//www.gm99.com/center?type=message","target":"blank"}},[_c('i',{staticClass:"account-message-icon icon"}),_vm._v(" "),_c('span',{staticClass:"t"},[_vm._v("\n                消息\n                "),_c('span',{staticClass:"remain-msg"},[_vm._v("("+_vm._s(_vm.unreadMsg)+")")])])]),_vm._v("\n            "+_vm._s(_vm.login_type)+"\n            "),_c('a',{staticClass:"account-switch opBtn",on:{"click":function($event){return _vm.showAccount(_vm.login_type.switchAccount)}}},[_c('i',{staticClass:"account-switch-icon icon"}),_vm._v(" "),_c('span',{staticClass:"t"},[_vm._v("切換帳號")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.user.id),expression:"!user.id"}],staticClass:"beforeLogin"},[_c('button',{staticClass:"beforeLogin-registered account-btn",attrs:{"href":""},on:{"click":function($event){return _vm.showAccount(_vm.login_type.registerAccount)}}},[_c('i',{staticClass:"icon"}),_vm._v("註冊\n          ")]),_vm._v(" "),_c('button',{staticClass:"beforeLogin-login account-btn",attrs:{"href":""},on:{"click":function($event){return _vm.showAccount(_vm.login_type.loginAccount)}}},[_c('i',{staticClass:"icon"}),_vm._v("登入\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"collect-wrapper"},[_c('a',{staticClass:"collect-btn j-favour-btn j-header-favour-btn",attrs:{"href":"javascript:;"},on:{"click":_vm.favourFn}},[_c('i',{staticClass:"like-icon"}),_vm._v(" "),_c('span',{staticClass:"colect-text"},[_vm._v("收藏")])]),_vm._v(" "),(_vm.pageInfo.headerDownload)?_c('a',{staticClass:"collect-btn j-download-btn j-header-download-btn",attrs:{"href":"javascript:;"},on:{"click":_vm.downloadFn}},[_c('i',{staticClass:"download-icon"}),_vm._v(" "),_c('span',{staticClass:"colect-text"},[_vm._v("下載")])]):_vm._e(),_vm._v(" "),(_vm.pageInfo.headerGift)?_c('a',{staticClass:"collect-btn j-gift-list",attrs:{"href":"javascript:;"},on:{"click":_vm.openGiftList}},[_c('i',{staticClass:"gift-icon"}),_vm._v(" "),_c('span',{staticClass:"colect-text"},[_vm._v("禮包")])]):_vm._e(),_vm._v(" "),(_vm.pageInfo.headerQrcode)?_c('a',{staticClass:"collect-btn code-btn",attrs:{"href":"javascript:;"}},[_c('i',{staticClass:"code-icon"}),_vm._v(" "),_c('span',{staticClass:"colect-text"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"code"},[_c('img',{staticClass:"codebg",attrs:{"src":_vm.pageInfo.qrCode.bg}}),_vm._v(" "),_c('p',{style:(_vm.fontColor)},[_vm._v("\n              用手機掃一下也能\n              "),_c('br'),_vm._v("在手機上玩唷~\n            ")]),_vm._v(" "),_c('img',{staticClass:"codeimg",attrs:{"src":_vm.pageInfo.qrCode.img}})])]):_vm._e(),_vm._v(" "),(_vm.pageInfo.headerWebsite)?_c('a',{staticClass:"collect-btn j-website-btn",attrs:{"href":_vm.gameSite,"target":"_blank"}},[_c('i',{staticClass:"website-icon"}),_vm._v(" "),_c('span',{staticClass:"colect-text"},[_vm._v("官網")])]):_vm._e(),_vm._v(" "),(_vm.pageInfo.apkDownload)?_c('a',{staticClass:"collect-btn",attrs:{"href":_vm.apkUrl,"target":"_blank"}},[_c('i',{staticClass:"apk-icon"}),_vm._v(" "),_c('span',{staticClass:"colect-text"},[_vm._v("apk下載")])]):_vm._e(),_vm._v(" "),(_vm.pageInfo.headerScreen)?_c('a',{staticClass:"collect-btn",attrs:{"href":"javascript:;"},on:{"click":_vm.toggleFullScreen}},[_c('i',{staticClass:"fullscreen-icon"}),_vm._v(" "),_c('span',{staticClass:"colect-text"},[_vm._v("全螢幕")])]):_vm._e()])])])])}
var PcHeader_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"pc-logo",attrs:{"href":"//www.gm99.com","target":"_blank"}},[_c('i',{staticClass:"pc-logo-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"select-icon-wrapper"},[_c('i',{staticClass:"select-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"account-center opBtn",attrs:{"href":"//www.gm99.com/center","target":"blank"}},[_c('i',{staticClass:"account-center-icon icon"}),_vm._v(" "),_c('span',{staticClass:"t"},[_vm._v("會員中心")])])}]
var PcHeader_esExports = { render: PcHeader_render, staticRenderFns: PcHeader_staticRenderFns }
/* harmony default export */ var components_PcHeader = (PcHeader_esExports);
// CONCATENATED MODULE: ./src/components/PcHeader.vue
var PcHeader_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PcHeader___vue_template_functional__ = false
/* styles */
var PcHeader___vue_styles__ = null
/* scopeId */
var PcHeader___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PcHeader___vue_module_identifier__ = null
var PcHeader_Component = PcHeader_normalizeComponent(
  PcHeader,
  components_PcHeader,
  PcHeader___vue_template_functional__,
  PcHeader___vue_styles__,
  PcHeader___vue_scopeId__,
  PcHeader___vue_module_identifier__
)

/* harmony default export */ var src_components_PcHeader = (PcHeader_Component.exports);

// EXTERNAL MODULE: ./src/utile/fb.js
var fb = __webpack_require__("Rmiw");

// EXTERNAL MODULE: ./src/utile/index.js
var utile = __webpack_require__("ZCHt");

// EXTERNAL MODULE: ./node_modules/date.str.format/index.js
var date_str_format = __webpack_require__("b7aB");
var date_str_format_default = /*#__PURE__*/__webpack_require__.n(date_str_format);

// EXTERNAL MODULE: ./src/utile/device.js
var device = __webpack_require__("FSl1");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/pc/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ var App = ({
  name: "app",
  data: function data() {
    return {
      srcindex: 0,
      // showFullScreen: false,
      saveState: false,
      popUpShow: false,
      showDesktopTips: false,
      ltIE10: false, //isIE()&&isIE()<11,
      gameName: window.gameName, //  全局smarty 输出
      gameSite: window.gameSite, //  全局smarty 输出
      // 有審查，臨時加的
      isReview: Object(ultile["i" /* getHrefParam */])("game_id") === "44" && Object(ultile["i" /* getHrefParam */])("cid") === "63"
    };
  },

  components: {
    GameIframe: GameIframe["a" /* default */],
    QrCode: src_components_QrCode,
    GiftListPopup: src_components_GiftListPopup,
    GiftGetPopup: src_components_GiftGetPopup,
    PcFooter: src_components_PcFooter,
    PcHeader: src_components_PcHeader
  },

  mixins: [Download, Favour],
  computed: extends_default()({
    bgCss: function bgCss() {
      return "background-image:url(" + this.pageInfo.bg + ");background-position:center;background-size: auto 100%;";
    }
  }, Object(vuex_esm["c" /* mapGetters */])(["user", "pageInfo", "giftListPopupState", "giftNumberGetPopupState", "finishGameConf", "showFullScreen"])),
  directives: {
    resize: resize
  },
  beforeCreate: function beforeCreate() {
    if (Object(device["c" /* isIE */])() && Object(device["c" /* isIE */])() < 11) {
      alert("使用IE11及以上版本瀏覽器就能獲得最佳遊戲體驗噢");
    }
  },
  created: function created() {
    var _this = this;

    // 3分钟后展示提示添加桌面信息
    setTimeout(function () {
      var haveShowReacord = false;
      try {
        haveShowReacord = window.localStorage.getItem("showAddDEskTopReacord");
      } catch (e) {}
      var now = new Date();
      var timeStr = date_str_format_default()(now, "yyyy-mm-dd");
      if (haveShowReacord !== timeStr) {
        _this.showDesktopTips = true;
      }
    }, 1000 * 60 * 3);
    this.getGameConf();
  },

  methods: extends_default()({
    fullScreen: function fullScreen() {
      this.$store.commit("toggleFullScreenState");
      // this.showFullScreen = !this.showFullScreen;
    },
    showAccount: function showAccount(type) {
      this.$refs.gameController.openAccountPopup(type);
    },
    clearAddDeskTopTips: function clearAddDeskTopTips() {
      var now = new Date();
      var timeStr = date_str_format_default()(now, "yyyy-mm-dd");
      try {
        window.localStorage.setItem("showAddDEskTopReacord", timeStr);
      } catch (e) {}

      this.showDesktopTips = false;
    }
  }, Object(vuex_esm["b" /* mapActions */])(["getGameConf"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6add64de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pc/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{class:{
    fillScreenMode: _vm.showFullScreen,
    landscape: _vm.pageInfo.horizontal,
    bigsize: _vm.pageInfo.gameSize == 'big'
  },attrs:{"id":"pc"}},[_c('PcHeader',{on:{"showAccount":_vm.showAccount}}),_vm._v(" "),_c('div',{staticClass:"pc-contianer"},[(_vm.finishGameConf)?_c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.showFullScreen),expression:"showFullScreen"}],staticClass:"game-wrapper",class:{
        jFillScreenPhone: _vm.showFullScreen,
        phone: !_vm.pageInfo.horizontal && _vm.pageInfo.gameSize == 'normal',
        ipad: _vm.pageInfo.horizontal && _vm.pageInfo.gameSize == 'normal'
      }},[(_vm.pageInfo.leftAside)?_c('aside',{staticClass:"platform-operas j-platform-operas"},[_c('div',{staticClass:"operas j-operas"},[_c('div',{staticClass:"ops j-ops-contianer"},[_c('div',{staticClass:"current-game j-current-game"},[_vm._v("\n              您正在玩\n              "),_c('p',{staticClass:"game-name j-game-name"},[_vm._v(_vm._s(_vm.gameName))])]),_vm._v(" "),_c('a',{staticClass:"ops-btn j-ops-btn j-website-btn",attrs:{"href":_vm.gameSite,"target":"blank"}},[_vm._v("遊戲官網")]),_vm._v(" "),_c('a',{staticClass:"ops-btn j-ops-btn j-download-btn",attrs:{"href":"javascript:;"},on:{"click":_vm.downloadFn}},[_vm._v("添加到桌面")]),_vm._v(" "),_c('a',{staticClass:"ops-btn j-ops-btn j-support-btn",attrs:{"href":"https://msupport.gm99.com/#submit","target":"blank"}},[_vm._v("客服工單")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isReview),expression:"!isReview"}],staticClass:"tips j-tips"}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDesktopTips),expression:"showDesktopTips"}],staticClass:"add-desktop j-add-desktop"},[_c('button',{staticClass:"close-add-desktop",on:{"click":_vm.clearAddDeskTopTips}})])])],1):_vm._e(),_vm._v(" "),(_vm.pageInfo.fullscreen || (_vm.pageInfo.headerScreen && _vm.showFullScreen))?_c('button',{staticClass:"fill-screen-btn j-fill-screen-btn j-fullscreen",attrs:{"type":"button"},on:{"click":_vm.fullScreen}}):_vm._e(),_vm._v(" "),(!_vm.isReview && _vm.pageInfo.rightQrcode)?_c('QrCode'):_vm._e(),_vm._v(" "),_c('GameIframe',{ref:"gameController",staticClass:"game-area j-mobile-page"})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bg",style:(_vm.bgCss)})]),_vm._v(" "),_c('PcFooter'),_vm._v(" "),_c('GiftListPopup',{directives:[{name:"show",rawName:"v-show",value:(_vm.giftListPopupState),expression:"giftListPopupState"}]}),_vm._v(" "),_c('GiftGetPopup',{directives:[{name:"show",rawName:"v-show",value:(_vm.giftNumberGetPopupState),expression:"giftNumberGetPopupState"}]})],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var pc_App = (App_esExports);
// CONCATENATED MODULE: ./src/pages/pc/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("D9U6")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  pc_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var pages_pc_App = (App_Component.exports);

// EXTERNAL MODULE: ./src/store/index.js
var store = __webpack_require__("IcnI");

// CONCATENATED MODULE: ./src/pages/pc/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





// import store from "../../../store/sdk/password";

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: "#pc",
  store: store["a" /* default */],
  template: "<App/>",
  components: { App: pages_pc_App }
});

/***/ }),

/***/ "GatL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user__ = __webpack_require__("wMq3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pc__ = __webpack_require__("xBpH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__gamePage__ = __webpack_require__("+S/E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__gift__ = __webpack_require__("MnT7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ga__ = __webpack_require__("lV9K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ultile__ = __webpack_require__("VtGx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_TipPopUpIframe__ = __webpack_require__("9Roz");












/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  strict: "production" !== "production", //在非生产环境下，使用严格模式
  state: {
    role: {
      serverId: "",
      serverName: "",
      roleId: "",
      roleName: ""
    },
    pageInfo: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, window.pageInfo),
    gameId: Object(__WEBPACK_IMPORTED_MODULE_9__ultile__["h" /* getGameId */])(),
    commonTips: "",
    commonTipsStyle: __WEBPACK_IMPORTED_MODULE_10__components_TipPopUpIframe__["a" /* POPUP_STYLE */].good,
    giftState: {
      like_award: false,
      like_award_card: "",
      download_award: false,
      download_award_card: ""
    },
    giftListPopupState: false,
    giftNumberGetPopupState: "",

    finishGameConf: false,
    apkUrl: ""
  },
  getters: {
    pageInfo: function pageInfo(state) {
      return state.pageInfo;
    },
    finishGameConf: function finishGameConf(state) {
      return state.finishGameConf;
    },
    giftListPopupState: function giftListPopupState(state) {
      return state.giftListPopupState;
    },
    giftNumberGetPopupState: function giftNumberGetPopupState(state) {
      return state.giftNumberGetPopupState;
    },
    gameUrl: function gameUrl(state) {
      return state.gamePage.gameUrl ? "//" + state.gamePage.gameUrl : "";
    },
    footerLink: function footerLink(state) {
      return state.pc.footerLink;
    },
    showFullScreen: function showFullScreen(state) {
      return state.pc.showFullScreen;
    },
    user: function user(state) {
      return state.user.user;
    },
    roleInfo: function roleInfo(state) {
      return state.role;
    },
    gameId: function gameId(state) {
      return state.gameId;
    },
    commonTips: function commonTips(state) {
      return state.commonTips;
    },
    commonTipsStyle: function commonTipsStyle(state) {
      return state.commonTipsStyle;
    },
    showShareTipsFistTime: function showShareTipsFistTime(state) {
      return (
        //只显示一次提示
        state.gamePage.showShareTipsFistTime
      );
    },
    unreadMsg: function unreadMsg(state) {
      return state.pc.unreadMsg;
    },
    giftState: function giftState(state) {
      return state.giftState;
    }
  },
  mutations: {
    updateRoleInfo: function updateRoleInfo(state, _ref) {
      var _ref$roleId = _ref.roleId,
          roleId = _ref$roleId === undefined ? "" : _ref$roleId,
          _ref$roleName = _ref.roleName,
          roleName = _ref$roleName === undefined ? "" : _ref$roleName,
          _ref$serverId = _ref.serverId,
          serverId = _ref$serverId === undefined ? "" : _ref$serverId,
          _ref$serverName = _ref.serverName,
          serverName = _ref$serverName === undefined ? "" : _ref$serverName;

      state.role = {
        serverId: serverId,
        serverName: serverName,
        roleId: roleId,
        roleName: roleName
      };
    },
    updateCommonTips: function updateCommonTips(state, _ref2) {
      var msg = _ref2.msg,
          _ref2$style = _ref2.style,
          style = _ref2$style === undefined ? __WEBPACK_IMPORTED_MODULE_10__components_TipPopUpIframe__["a" /* POPUP_STYLE */].good : _ref2$style;

      state.commonTipsStyle = style;
      state.commonTips = msg;
    },
    updateGiftState: function updateGiftState(state, _ref3) {
      var action = _ref3.action,
          value = _ref3.value;

      state.giftState[action + "_award"] = value;
    },
    updateGiftCard: function updateGiftCard(state, _ref4) {
      var action = _ref4.action,
          value = _ref4.value;

      state.giftState[action + "_award_card"] = value;
    },
    updateState: function updateState(state, _ref5) {
      var action = _ref5.action,
          value = _ref5.value;

      state[action] = value;
    },
    updatePageInfo: function updatePageInfo(state, value) {
      state.pageInfo = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.pageInfo, value);
    },
    updateApk: function updateApk(state, value) {
      state.apkUrl = value;
    }
  },
  actions: {
    getGameConf: function getGameConf(_ref6) {
      var state = _ref6.state,
          commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var type = window.isFbCanvas ? "canvas" : "web";
        Object(__WEBPACK_IMPORTED_MODULE_9__ultile__["e" /* get */])("//m.gm99.com/h5GameConfig/" + type + "/" + state.gameId + ".json?v=" + window.now_time, {}).then(function (res) {
          if (res && res.data) {
            for (var key in res.data) {
              window.pageInfo[key] = res.data[key];
            }
            commit("updatePageInfo", res.data);
          }
          dispatch("gaStatisticsCommon", {
            eventName: "json_load_succ"
          });
          commit("updateState", { action: "finishGameConf", value: true });
          resolve();
        }, reject);
      });
    },
    getGiftState: function getGiftState(_ref7) {
      var state = _ref7.state,
          commit = _ref7.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        Object(__WEBPACK_IMPORTED_MODULE_9__ultile__["k" /* getJSON */])("//eventsapi.gm99.com/activity/execute?name=h5cardaward&action=selectAward&params={%22gameId%22:" + state.gameId + "}", {}).then(function (res) {
          if (!res.errmsg) {
            if (res.data.like_award) {
              commit("updateGiftState", {
                action: "like",
                value: res.data.like_award.is_award
              });
              commit("updateGiftCard", {
                action: "like",
                value: res.data.like_award.card
              });
            }
            if (res.data.download_award) {
              commit("updateGiftState", {
                action: "download",
                value: res.data.download_award.is_award
              });

              commit("updateGiftCard", {
                action: "download",
                value: res.data.download_award.card
              });
            }
          }
          resolve();
        });
      });
    },
    get_save_gift: function get_save_gift(_ref8, type) {
      var state = _ref8.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        Object(__WEBPACK_IMPORTED_MODULE_9__ultile__["k" /* getJSON */])("//eventsapi.gm99.com/activity/execute?name=h5cardaward&action=getCardGift&params={%22gameId%22:" + state.gameId + ",%22giftType%22:%22" + type + "%22}", {}).then(function (res) {
          if (!res.errmsg) {
            resolve(res.data);
          } else {
            reject(res.errmsg);
          }
        });
      });
    },
    getWebsiteInfo: function getWebsiteInfo(_ref9) {
      var commit = _ref9.commit,
          state = _ref9.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        Object(__WEBPACK_IMPORTED_MODULE_9__ultile__["k" /* getJSON */])("//m.gm99.com/ajax/get_game_info", {
          gameID: state.gameId
        }).then(function (res) {
          if (!res.errmsg) {
            commit("updateApk", res.data.apkDownLoadURL);
          }
          resolve();
        });
      });
    }
  },
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_4__user__["f" /* default */],
    gamePage: __WEBPACK_IMPORTED_MODULE_6__gamePage__["e" /* default */],
    pc: __WEBPACK_IMPORTED_MODULE_5__pc__["b" /* default */],
    gift: __WEBPACK_IMPORTED_MODULE_7__gift__["a" /* default */],
    ga: __WEBPACK_IMPORTED_MODULE_8__ga__["a" /* default */]
  }
}));

/***/ }),

/***/ "McQA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MnT7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GET_GIFT */
/* unused harmony export GET_GIFT_INFO */
/* unused harmony export CHECK_GIFT */
/* unused harmony export UPDATE_GIFT_DETAIL */
/* unused harmony export UPDATE_GET_GIFT_RESULT */
/* unused harmony export UPDATE_ERROR */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ultile__ = __webpack_require__("VtGx");



var _actions, _mutations;



var GET_GIFT = 'recieveGift';
var GET_GIFT_INFO = 'loadGiftList';
var CHECK_GIFT = 'checkGift';

var GET_GIFT_INF_URL = '//www.gm99.com/mobile_serial/get_mobile_gift_game_id';
var GET_GIFT_PRE_URL = '//www.gm99.com/mobile_serial/get_public_serial_remain';
var GET_GIFT_URL = '//www.gm99.com/mobile_serial/get_mobile_serial';
var CHECK_GIFT_INF_URL = "//www.gm99.com/mobile_serial/get_mobile_serial";

var REQUEST_SUCCESS_CODE = 1;

var UPDATE_GIFT_DETAIL = "updateGiftDetail";
var UPDATE_GET_GIFT_RESULT = "updateGetGiftResult";
var UPDATE_ERROR = 'updateError';

function resetGiftInitData(data) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        var info = [];
        var base = data[0].data.length > 0 ? data[0].data : false;
        var pre = data[1].res.result == 1 ? data[1].data : false;
        if (data.length > 0 && !!base && !!pre) {
            for (var i = 0; i < data.length; i++) {
                info[i] = {
                    type: base[i].TYPE == 5 ? 'novice_gift' : 'member_gift',
                    name: base[i].NAME,
                    totalNum: 100
                };
            }
            info[0].less = pre['novice_gift'];
            info[0].state = pre['novice_log'] == '1' ? 0 : 1;
            info[1].less = pre['member_gift'];
            info[1].state = pre['member_log'] == '1' ? 0 : 1;
        }
        resolve(info);
    });
}

/* harmony default export */ __webpack_exports__["a"] = ({
    strict: "production" !== 'production', //在非生产环境下，使用严格模式
    state: {
        giftList: [],
        getGiftSuccess: '',
        giftInfo: {
            card: '',
            content: ''
        },
        errmsg: ''
    },

    actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, GET_GIFT_INFO, function (_ref) {
        var commit = _ref.commit;

        var data = {
            gameId: Object(__WEBPACK_IMPORTED_MODULE_2__ultile__["h" /* getGameId */])(),
            game_id: Object(__WEBPACK_IMPORTED_MODULE_2__ultile__["h" /* getGameId */])()
        };
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([Object(__WEBPACK_IMPORTED_MODULE_2__ultile__["k" /* getJSON */])(GET_GIFT_INF_URL, data), Object(__WEBPACK_IMPORTED_MODULE_2__ultile__["k" /* getJSON */])(GET_GIFT_PRE_URL, data)]).then(resetGiftInitData).then(function (data) {
                commit(GET_GIFT_INFO, data);
                resolve(data);
            });
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, GET_GIFT, function (_ref2, parma) {
        var commit = _ref2.commit;

        parma.game_id = Object(__WEBPACK_IMPORTED_MODULE_2__ultile__["h" /* getGameId */])();
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            Object(__WEBPACK_IMPORTED_MODULE_2__ultile__["k" /* getJSON */])(GET_GIFT_URL, parma).then(function (_ref3) {
                var data = _ref3.data,
                    res = _ref3.res,
                    errmsg = _ref3.errmsg;

                if (REQUEST_SUCCESS_CODE == res.result) {
                    commit(GET_GIFT, data);
                    commit(UPDATE_GET_GIFT_RESULT, 'successPop');
                    resolve();
                } else {
                    commit(UPDATE_GET_GIFT_RESULT, 'failGiftPop');
                    resolve();
                    //展示用的
                }
            });
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, CHECK_GIFT, function (_ref4, parma) {
        var commit = _ref4.commit;

        var data = {
            game_id: Object(__WEBPACK_IMPORTED_MODULE_2__ultile__["h" /* getGameId */])(),
            type: parma
        };
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            Object(__WEBPACK_IMPORTED_MODULE_2__ultile__["k" /* getJSON */])(CHECK_GIFT_INF_URL, data).then(function (_ref5) {
                var errmsg = _ref5.errmsg,
                    data = _ref5.data,
                    res = _ref5.res;

                if (REQUEST_SUCCESS_CODE == res.result) {
                    commit(GET_GIFT, data);
                    commit(UPDATE_GET_GIFT_RESULT, 'successPop');
                    resolve();
                } else {
                    commit(UPDATE_GET_GIFT_RESULT, 'failCheckPop');
                    commit(UPDATE_ERROR, errmsg);
                    resolve();
                }
            });
        });
    }), _actions),
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, GET_GIFT, function (state, data) {
        state.giftInfo = {
            card: data.card,
            content: data.content
        };
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, GET_GIFT_INFO, function (state, data) {
        state.giftList = data;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, UPDATE_GET_GIFT_RESULT, function (state, result) {
        state.getGiftSuccess = result;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, UPDATE_ERROR, function (state, result) {
        state.errmsg = result;
    }), _mutations)
});

/***/ }),

/***/ "NWIX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PvY0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rmiw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fbSdkLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fbSdkGetState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fbShare; });
/* unused harmony export invite */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fbSdkPay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getFingerprint; });
/* unused harmony export getLoginId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return lineShare; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fingerprintjs2__ = __webpack_require__("CAzn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fingerprintjs2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fingerprintjs2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__("ZCHt");

var id = "150671791714175";
var UUID = "uuid";





var fbSdkLogin = function fbSdkLogin() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    FB.login(function (res) {
      resolve(res);
    });
  });
};

var fbSdkGetState = function fbSdkGetState() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    FB.getLoginStatus(function (res) {
      resolve(res);
    });
  });
};

// let doFbShare = function(href, fbAccount, shareSuccess, shareFail) {
//   FB.ui(
//     {
//       method: "share",
//       href: href
//     },
//     function(response) {
//       if (response && !response.error_message) {
//         shareSuccess(response, fbAccount);
//       } else {
//         shareFail(response, fbAccount);
//       }
//     }
//   );
// };

var fbShare = function fbShare(_ref) {
  var description = _ref.description,
      link = _ref.link,
      title = _ref.title,
      img = _ref.img;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var href = "https://eventsapi.gm99.com/fbShareCustomize/customizeShare/message/" + encodeURIComponent(description) + "/app_id/" + encodeURIComponent(id) + "/redict_url/" + encodeURIComponent(link + "&scid=fbshare") + "/share_title/" + encodeURIComponent(title) + "/pic_url/" + encodeURIComponent(img);

    console.log(href);

    FB.ui({ method: "share", href: href }, function (response) {
      if (response && !response.error_message) {
        resolve();
      } else {
        reject();
      }
    });
  });
};

// 邀請好友功能
var invite = function invite(inviteTitle) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    FB.ui({
      method: "apprequests",
      message: inviteTitle,
      filter: ["app_non_users"]
    }, function (response) {
      if (response && response.hasOwnProperty("request")) {
        var request_id = response["request"];
        var invites = response.hasOwnProperty("to") ? response["to"].join(",") : "";
        resolve(true, {
          request_id: request_id,
          invites: invites
        });
      } else {
        resolve(false, {});
      }
    });
  });
};

var fbSdkPay = function fbSdkPay(order_id) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var obj = {
      method: "pay",
      action: "purchaseitem",
      product: "https://mstore.gm99.com/facebook_local_money/product_items/app_id/" + window.appInfo.appId + "/order_id/" + order_id,
      request_id: order_id
    };

    console.log(obj);

    FB.ui(obj, function (res) {
      if (res && !res["error_code"]) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
};

var getFingerprint = function getFingerprint() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    var locaUUid = Object(__WEBPACK_IMPORTED_MODULE_2__index__["c" /* getLclStorageItem */])(UUID);
    var cookUUid = Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* getCookie */])(UUID);
    var saveUuid = locaUUid || cookUUid;
    if (saveUuid) {
      if (!cookUUid || locaUUid && locaUUid !== cookUUid) {
        Object(__WEBPACK_IMPORTED_MODULE_2__index__["f" /* setCookie */])(UUID, saveUuid);
      }
      if (!locaUUid) {
        Object(__WEBPACK_IMPORTED_MODULE_2__index__["g" /* setLclStorageItem */])(UUID, saveUuid);
      }
      resolve(saveUuid);
    } else {
      __WEBPACK_IMPORTED_MODULE_1_fingerprintjs2___default.a.getV18({
        excludes: {
          language: true
        }
      }, function (result) {
        var timestamp = new Date().valueOf();
        var realUuid = result + timestamp;
        Object(__WEBPACK_IMPORTED_MODULE_2__index__["g" /* setLclStorageItem */])(UUID, realUuid);
        Object(__WEBPACK_IMPORTED_MODULE_2__index__["f" /* setCookie */])(UUID, realUuid);
        resolve(realUuid);
      });
    }
  });
};

var getLoginId = function getLoginId() {
  var locaUUid = Object(__WEBPACK_IMPORTED_MODULE_2__index__["c" /* getLclStorageItem */])(UUID);
  var cookUUid = Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* getCookie */])(UUID);
  return locaUUid || cookUUid || "";
};

var lineShare = function lineShare(_ref2) {
  var link = _ref2.link;

  window.open("https://lineit.line.me/share/ui?url=" + encodeURIComponent(link), "_blank", "toolbar=yes,location=yes,directories=no,status=no,menubar=yes,scrollbars=yes,resizable=no,copyhistory=yes");
};

/***/ }),

/***/ "TBqg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UCuA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VtGx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/jsonp/index.js
var jsonp = __webpack_require__("hU7x");
var jsonp_default = /*#__PURE__*/__webpack_require__.n(jsonp);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./src/store/jsencrypt.js

// Bits per digit
var dbits;

// JavaScript engine analysis
var canary = 0xdeadbeefcafe;
var j_lm = (canary & 0xffffff) == 0xefcafe;

// (public) Constructor
function BigInteger(a, b, c) {
    if (a != null) if ("number" == typeof a) this.fromNumber(a, b, c);else if (b == null && "string" != typeof a) this.fromString(a, 256);else this.fromString(a, b);
}

// return new, unset BigInteger
function nbi() {
    return new BigInteger(null);
}

// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.

// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function am1(i, x, w, j, c, n) {
    while (--n >= 0) {
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff,
        xh = x >> 15;
    while (--n >= 0) {
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff,
        xh = x >> 14;
    while (--n >= 0) {
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
if (j_lm && navigator.appName == "Microsoft Internet Explorer") {
    BigInteger.prototype.am = am2;
    dbits = 30;
} else if (j_lm && navigator.appName != "Netscape") {
    BigInteger.prototype.am = am1;
    dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    BigInteger.prototype.am = am3;
    dbits = 28;
}

BigInteger.prototype.DB = dbits;
BigInteger.prototype.DM = (1 << dbits) - 1;
BigInteger.prototype.DV = 1 << dbits;

var BI_FP = 52;
BigInteger.prototype.FV = Math.pow(2, BI_FP);
BigInteger.prototype.F1 = BI_FP - dbits;
BigInteger.prototype.F2 = 2 * dbits - BI_FP;

// Digit conversions
var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var BI_RC = new Array();
var rr, vv;
rr = "0".charCodeAt(0);
for (vv = 0; vv <= 9; ++vv) {
    BI_RC[rr++] = vv;
}rr = "a".charCodeAt(0);
for (vv = 10; vv < 36; ++vv) {
    BI_RC[rr++] = vv;
}rr = "A".charCodeAt(0);
for (vv = 10; vv < 36; ++vv) {
    BI_RC[rr++] = vv;
}function int2char(n) {
    return BI_RM.charAt(n);
}

function intAt(s, i) {
    var c = BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}

// (protected) copy this to r
function bnpCopyTo(r) {
    for (var i = this.t - 1; i >= 0; --i) {
        r[i] = this[i];
    }r.t = this.t;
    r.s = this.s;
}

// (protected) set from integer value x, -DV <= x < DV
function bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;else if (x < -1) this[0] = x + this.DV;else this.t = 0;
}

// return bigint initialized to value
function nbv(i) {
    var r = nbi();
    r.fromInt(i);
    return r;
}

// (protected) set from string and radix
function bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;else if (b == 8) k = 3;else if (b == 256) k = 8; // byte array
    else if (b == 2) k = 1;else if (b == 32) k = 5;else if (b == 4) k = 2;else {
            this.fromRadix(s, b);return;
        }
    this.t = 0;
    this.s = 0;
    var i = s.length,
        mi = false,
        sh = 0;
    while (--i >= 0) {
        var x = k == 8 ? s[i] & 0xff : intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-") mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this[this.t++] = x;else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    if (k == 8 && (s[0] & 0x80) != 0) {
        this.s = -1;
        if (sh > 0) this[this.t - 1] |= (1 << this.DB - sh) - 1 << sh;
    }
    this.clamp();
    if (mi) BigInteger.ZERO.subTo(this, this);
}

// (protected) clamp off excess high words
function bnpClamp() {
    var c = this.s & this.DM;
    while (this.t > 0 && this[this.t - 1] == c) {
        --this.t;
    }
}

// (public) return string representation in given radix
function bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;else if (b == 8) k = 3;else if (b == 2) k = 1;else if (b == 32) k = 5;else if (b == 4) k = 2;else return this.toRadix(b);
    var km = (1 << k) - 1,
        d,
        m = false,
        r = "",
        i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = int2char(d);
        }
        while (i >= 0) {
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;--i;
                }
            }
            if (d > 0) m = true;
            if (m) r += int2char(d);
        }
    }
    return m ? r : "0";
}

// (public) -this
function bnNegate() {
    var r = nbi();
    BigInteger.ZERO.subTo(this, r);
    return r;
}

// (public) |this|
function bnAbs() {
    return this.s < 0 ? this.negate() : this;
}

// (public) return + if this > a, - if this < a, 0 if equal
function bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while (--i >= 0) {
        if ((r = this[i] - a[i]) != 0) return r;
    }return 0;
}

// returns bit length of the integer x
function nbits(x) {
    var r = 1,
        t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}

// (public) return the number of bits in "this"
function bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
}

// (protected) r = this << n*DB
function bnpDLShiftTo(n, r) {
    var i;
    for (i = this.t - 1; i >= 0; --i) {
        r[i + n] = this[i];
    }for (i = n - 1; i >= 0; --i) {
        r[i] = 0;
    }r.t = this.t + n;
    r.s = this.s;
}

// (protected) r = this >> n*DB
function bnpDRShiftTo(n, r) {
    for (var i = n; i < this.t; ++i) {
        r[i - n] = this[i];
    }r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}

// (protected) r = this << n
function bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB),
        c = this.s << bs & this.DM,
        i;
    for (i = this.t - 1; i >= 0; --i) {
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for (i = ds - 1; i >= 0; --i) {
        r[i] = 0;
    }r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}

// (protected) r = this >> n
function bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for (var i = ds + 1; i < this.t; ++i) {
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}

// (protected) r = this - a
function bnpSubTo(a, r) {
    var i = 0,
        c = 0,
        m = Math.min(a.t, this.t);
    while (i < m) {
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while (i < this.t) {
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while (i < a.t) {
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}

// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function bnpMultiplyTo(a, r) {
    var x = this.abs(),
        y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while (--i >= 0) {
        r[i] = 0;
    }for (i = 0; i < y.t; ++i) {
        r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    }r.s = 0;
    r.clamp();
    if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
}

// (protected) r = this^2, r != this (HAC 14.16)
function bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while (--i >= 0) {
        r[i] = 0;
    }for (i = 0; i < x.t - 1; ++i) {
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}

// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = nbi();
    var y = nbi(),
        ts = this.s,
        ms = m.s;
    var nsh = this.DB - nbits(pm[pm.t - 1]); // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt,
        d2 = (1 << this.F1) / yt,
        e = 1 << this.F2;
    var i = r.t,
        j = i - ys,
        t = q == null ? nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y); // "negative" y so we can replace sub with am later
    while (y.t < ys) {
        y[y.t++] = 0;
    }while (--j >= 0) {
        // Estimate quotient digit
        var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while (r[i] < --qd) {
                r.subTo(t, r);
            }
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
    if (ts < 0) BigInteger.ZERO.subTo(r, r);
}

// (public) this mod a
function bnMod(a) {
    var r = nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
}

// Modular reduction using "classic" algorithm
function Classic(m) {
    this.m = m;
}

function cConvert(x) {
    if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);else return x;
}

function cRevert(x) {
    return x;
}

function cReduce(x) {
    x.divRemTo(this.m, null, x);
}

function cMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}

function cSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}

Classic.prototype.convert = cConvert;
Classic.prototype.revert = cRevert;
Classic.prototype.reduce = cReduce;
Classic.prototype.mulTo = cMulTo;
Classic.prototype.sqrTo = cSqrTo;

// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3; // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}

// Montgomery reduction
function Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}

// xR mod m
function montConvert(x) {
    var r = nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
}

// x/R mod m
function montRevert(x) {
    var r = nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}

// x = x/R mod m (HAC 14.32)
function montReduce(x) {
    while (x.t <= this.mt2) {
        // pad x so am has enough room later
        x[x.t++] = 0;
    }for (var i = 0; i < this.m.t; ++i) {
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while (x[j] >= x.DV) {
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}

// r = "x^2/R mod m"; x != r
function montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}

// r = "xy/R mod m"; x,y != r
function montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}

Montgomery.prototype.convert = montConvert;
Montgomery.prototype.revert = montRevert;
Montgomery.prototype.reduce = montReduce;
Montgomery.prototype.mulTo = montMulTo;
Montgomery.prototype.sqrTo = montSqrTo;

// (protected) true iff this is even
function bnpIsEven() {
    return (this.t > 0 ? this[0] & 1 : this.s) == 0;
}

// (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
function bnpExp(e, z) {
    if (e > 0xffffffff || e < 1) return BigInteger.ONE;
    var r = nbi(),
        r2 = nbi(),
        g = z.convert(this),
        i = nbits(e) - 1;
    g.copyTo(r);
    while (--i >= 0) {
        z.sqrTo(r, r2);
        if ((e & 1 << i) > 0) z.mulTo(r2, g, r);else {
            var t = r;
            r = r2;
            r2 = t;
        }
    }
    return z.revert(r);
}

// (public) this^e % m, 0 <= e < 2^32
function bnModPowInt(e, m) {
    var z;
    if (e < 256 || m.isEven()) z = new Classic(m);else z = new Montgomery(m);
    return this.exp(e, z);
}

// protected
BigInteger.prototype.copyTo = bnpCopyTo;
BigInteger.prototype.fromInt = bnpFromInt;
BigInteger.prototype.fromString = bnpFromString;
BigInteger.prototype.clamp = bnpClamp;
BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
BigInteger.prototype.drShiftTo = bnpDRShiftTo;
BigInteger.prototype.lShiftTo = bnpLShiftTo;
BigInteger.prototype.rShiftTo = bnpRShiftTo;
BigInteger.prototype.subTo = bnpSubTo;
BigInteger.prototype.multiplyTo = bnpMultiplyTo;
BigInteger.prototype.squareTo = bnpSquareTo;
BigInteger.prototype.divRemTo = bnpDivRemTo;
BigInteger.prototype.invDigit = bnpInvDigit;
BigInteger.prototype.isEven = bnpIsEven;
BigInteger.prototype.exp = bnpExp;

// public
BigInteger.prototype.toString = bnToString;
BigInteger.prototype.negate = bnNegate;
BigInteger.prototype.abs = bnAbs;
BigInteger.prototype.compareTo = bnCompareTo;
BigInteger.prototype.bitLength = bnBitLength;
BigInteger.prototype.mod = bnMod;
BigInteger.prototype.modPowInt = bnModPowInt;

// "constants"
BigInteger.ZERO = nbv(0);
BigInteger.ONE = nbv(1);

// Copyright (c) 2005-2009  Tom Wu
// All Rights Reserved.
// See "LICENSE" for details.

// Extended JavaScript BN functions, required for RSA private ops.

// Version 1.1: new BigInteger("0", 10) returns "proper" zero
// Version 1.2: square() API, isProbablePrime fix

// (public)
function bnClone() {
    var r = nbi();
    this.copyTo(r);
    return r;
}

// (public) return value as integer
function bnIntValue() {
    if (this.s < 0) {
        if (this.t == 1) return this[0] - this.DV;else if (this.t == 0) return -1;
    } else if (this.t == 1) return this[0];else if (this.t == 0) return 0;
    // assumes 16 < DB < 32
    return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
}

// (public) return value as byte
function bnByteValue() {
    return this.t == 0 ? this.s : this[0] << 24 >> 24;
}

// (public) return value as short (assumes DB>=16)
function bnShortValue() {
    return this.t == 0 ? this.s : this[0] << 16 >> 16;
}

// (protected) return x s.t. r^x < DV
function bnpChunkSize(r) {
    return Math.floor(Math.LN2 * this.DB / Math.log(r));
}

// (public) 0 if this == 0, 1 if this > 0
function bnSigNum() {
    if (this.s < 0) return -1;else if (this.t <= 0 || this.t == 1 && this[0] <= 0) return 0;else return 1;
}

// (protected) convert to radix string
function bnpToRadix(b) {
    if (b == null) b = 10;
    if (this.signum() == 0 || b < 2 || b > 36) return "0";
    var cs = this.chunkSize(b);
    var a = Math.pow(b, cs);
    var d = nbv(a),
        y = nbi(),
        z = nbi(),
        r = "";
    this.divRemTo(d, y, z);
    while (y.signum() > 0) {
        r = (a + z.intValue()).toString(b).substr(1) + r;
        y.divRemTo(d, y, z);
    }
    return z.intValue().toString(b) + r;
}

// (protected) convert from radix string
function bnpFromRadix(s, b) {
    this.fromInt(0);
    if (b == null) b = 10;
    var cs = this.chunkSize(b);
    var d = Math.pow(b, cs),
        mi = false,
        j = 0,
        w = 0;
    for (var i = 0; i < s.length; ++i) {
        var x = intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-" && this.signum() == 0) mi = true;
            continue;
        }
        w = b * w + x;
        if (++j >= cs) {
            this.dMultiply(d);
            this.dAddOffset(w, 0);
            j = 0;
            w = 0;
        }
    }
    if (j > 0) {
        this.dMultiply(Math.pow(b, j));
        this.dAddOffset(w, 0);
    }
    if (mi) BigInteger.ZERO.subTo(this, this);
}

// (protected) alternate constructor
function bnpFromNumber(a, b, c) {
    if ("number" == typeof b) {
        // new BigInteger(int,int,RNG)
        if (a < 2) this.fromInt(1);else {
            this.fromNumber(a, c);
            if (!this.testBit(a - 1)) // force MSB set
                this.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), op_or, this);
            if (this.isEven()) this.dAddOffset(1, 0); // force odd
            while (!this.isProbablePrime(b)) {
                this.dAddOffset(2, 0);
                if (this.bitLength() > a) this.subTo(BigInteger.ONE.shiftLeft(a - 1), this);
            }
        }
    } else {
        // new BigInteger(int,RNG)
        var x = new Array(),
            t = a & 7;
        x.length = (a >> 3) + 1;
        b.nextBytes(x);
        if (t > 0) x[0] &= (1 << t) - 1;else x[0] = 0;
        this.fromString(x, 256);
    }
}

// (public) convert to bigendian byte array
function bnToByteArray() {
    var i = this.t,
        r = new Array();
    r[0] = this.s;
    var p = this.DB - i * this.DB % 8,
        d,
        k = 0;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) != (this.s & this.DM) >> p) r[k++] = d | this.s << this.DB - p;
        while (i >= 0) {
            if (p < 8) {
                d = (this[i] & (1 << p) - 1) << 8 - p;
                d |= this[--i] >> (p += this.DB - 8);
            } else {
                d = this[i] >> (p -= 8) & 0xff;
                if (p <= 0) {
                    p += this.DB;--i;
                }
            }
            if ((d & 0x80) != 0) d |= -256;
            if (k == 0 && (this.s & 0x80) != (d & 0x80)) ++k;
            if (k > 0 || d != this.s) r[k++] = d;
        }
    }
    return r;
}

function bnEquals(a) {
    return this.compareTo(a) == 0;
}

function bnMin(a) {
    return this.compareTo(a) < 0 ? this : a;
}

function bnMax(a) {
    return this.compareTo(a) > 0 ? this : a;
}

// (protected) r = this op a (bitwise)
function bnpBitwiseTo(a, op, r) {
    var i,
        f,
        m = Math.min(a.t, this.t);
    for (i = 0; i < m; ++i) {
        r[i] = op(this[i], a[i]);
    }if (a.t < this.t) {
        f = a.s & this.DM;
        for (i = m; i < this.t; ++i) {
            r[i] = op(this[i], f);
        }r.t = this.t;
    } else {
        f = this.s & this.DM;
        for (i = m; i < a.t; ++i) {
            r[i] = op(f, a[i]);
        }r.t = a.t;
    }
    r.s = op(this.s, a.s);
    r.clamp();
}

// (public) this & a
function op_and(x, y) {
    return x & y;
}

function bnAnd(a) {
    var r = nbi();
    this.bitwiseTo(a, op_and, r);
    return r;
}

// (public) this | a
function op_or(x, y) {
    return x | y;
}

function bnOr(a) {
    var r = nbi();
    this.bitwiseTo(a, op_or, r);
    return r;
}

// (public) this ^ a
function op_xor(x, y) {
    return x ^ y;
}

function bnXor(a) {
    var r = nbi();
    this.bitwiseTo(a, op_xor, r);
    return r;
}

// (public) this & ~a
function op_andnot(x, y) {
    return x & ~y;
}

function bnAndNot(a) {
    var r = nbi();
    this.bitwiseTo(a, op_andnot, r);
    return r;
}

// (public) ~this
function bnNot() {
    var r = nbi();
    for (var i = 0; i < this.t; ++i) {
        r[i] = this.DM & ~this[i];
    }r.t = this.t;
    r.s = ~this.s;
    return r;
}

// (public) this << n
function bnShiftLeft(n) {
    var r = nbi();
    if (n < 0) this.rShiftTo(-n, r);else this.lShiftTo(n, r);
    return r;
}

// (public) this >> n
function bnShiftRight(n) {
    var r = nbi();
    if (n < 0) this.lShiftTo(-n, r);else this.rShiftTo(n, r);
    return r;
}

// return index of lowest 1-bit in x, x < 2^31
function lbit(x) {
    if (x == 0) return -1;
    var r = 0;
    if ((x & 0xffff) == 0) {
        x >>= 16;
        r += 16;
    }
    if ((x & 0xff) == 0) {
        x >>= 8;
        r += 8;
    }
    if ((x & 0xf) == 0) {
        x >>= 4;
        r += 4;
    }
    if ((x & 3) == 0) {
        x >>= 2;
        r += 2;
    }
    if ((x & 1) == 0) ++r;
    return r;
}

// (public) returns index of lowest 1-bit (or -1 if none)
function bnGetLowestSetBit() {
    for (var i = 0; i < this.t; ++i) {
        if (this[i] != 0) return i * this.DB + lbit(this[i]);
    }if (this.s < 0) return this.t * this.DB;
    return -1;
}

// return number of 1 bits in x
function cbit(x) {
    var r = 0;
    while (x != 0) {
        x &= x - 1;++r;
    }
    return r;
}

// (public) return number of set bits
function bnBitCount() {
    var r = 0,
        x = this.s & this.DM;
    for (var i = 0; i < this.t; ++i) {
        r += cbit(this[i] ^ x);
    }return r;
}

// (public) true iff nth bit is set
function bnTestBit(n) {
    var j = Math.floor(n / this.DB);
    if (j >= this.t) return this.s != 0;
    return (this[j] & 1 << n % this.DB) != 0;
}

// (protected) this op (1<<n)
function bnpChangeBit(n, op) {
    var r = BigInteger.ONE.shiftLeft(n);
    this.bitwiseTo(r, op, r);
    return r;
}

// (public) this | (1<<n)
function bnSetBit(n) {
    return this.changeBit(n, op_or);
}

// (public) this & ~(1<<n)
function bnClearBit(n) {
    return this.changeBit(n, op_andnot);
}

// (public) this ^ (1<<n)
function bnFlipBit(n) {
    return this.changeBit(n, op_xor);
}

// (protected) r = this + a
function bnpAddTo(a, r) {
    var i = 0,
        c = 0,
        m = Math.min(a.t, this.t);
    while (i < m) {
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while (i < this.t) {
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while (i < a.t) {
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}

// (public) this + a
function bnAdd(a) {
    var r = nbi();
    this.addTo(a, r);
    return r;
}

// (public) this - a
function bnSubtract(a) {
    var r = nbi();
    this.subTo(a, r);
    return r;
}

// (public) this * a
function bnMultiply(a) {
    var r = nbi();
    this.multiplyTo(a, r);
    return r;
}

// (public) this^2
function bnSquare() {
    var r = nbi();
    this.squareTo(r);
    return r;
}

// (public) this / a
function bnDivide(a) {
    var r = nbi();
    this.divRemTo(a, r, null);
    return r;
}

// (public) this % a
function bnRemainder(a) {
    var r = nbi();
    this.divRemTo(a, null, r);
    return r;
}

// (public) [this/a,this%a]
function bnDivideAndRemainder(a) {
    var q = nbi(),
        r = nbi();
    this.divRemTo(a, q, r);
    return new Array(q, r);
}

// (protected) this *= n, this >= 0, 1 < n < DV
function bnpDMultiply(n) {
    this[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
    ++this.t;
    this.clamp();
}

// (protected) this += n << w words, this >= 0
function bnpDAddOffset(n, w) {
    if (n == 0) return;
    while (this.t <= w) {
        this[this.t++] = 0;
    }this[w] += n;
    while (this[w] >= this.DV) {
        this[w] -= this.DV;
        if (++w >= this.t) this[this.t++] = 0;
        ++this[w];
    }
}

// A "null" reducer
function NullExp() {}

function nNop(x) {
    return x;
}

function nMulTo(x, y, r) {
    x.multiplyTo(y, r);
}

function nSqrTo(x, r) {
    x.squareTo(r);
}

NullExp.prototype.convert = nNop;
NullExp.prototype.revert = nNop;
NullExp.prototype.mulTo = nMulTo;
NullExp.prototype.sqrTo = nSqrTo;

// (public) this^e
function bnPow(e) {
    return this.exp(e, new NullExp());
}

// (protected) r = lower n words of "this * a", a.t <= n
// "this" should be the larger one if appropriate.
function bnpMultiplyLowerTo(a, n, r) {
    var i = Math.min(this.t + a.t, n);
    r.s = 0; // assumes a,this >= 0
    r.t = i;
    while (i > 0) {
        r[--i] = 0;
    }var j;
    for (j = r.t - this.t; i < j; ++i) {
        r[i + this.t] = this.am(0, a[i], r, i, 0, this.t);
    }for (j = Math.min(a.t, n); i < j; ++i) {
        this.am(0, a[i], r, i, 0, n - i);
    }r.clamp();
}

// (protected) r = "this * a" without lower n words, n > 0
// "this" should be the larger one if appropriate.
function bnpMultiplyUpperTo(a, n, r) {
    --n;
    var i = r.t = this.t + a.t - n;
    r.s = 0; // assumes a,this >= 0
    while (--i >= 0) {
        r[i] = 0;
    }for (i = Math.max(n - this.t, 0); i < a.t; ++i) {
        r[this.t + i - n] = this.am(n - i, a[i], r, 0, 0, this.t + i - n);
    }r.clamp();
    r.drShiftTo(1, r);
}

// Barrett modular reduction
function Barrett(m) {
    // setup Barrett
    this.r2 = nbi();
    this.q3 = nbi();
    BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
    this.mu = this.r2.divide(m);
    this.m = m;
}

function barrettConvert(x) {
    if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m);else if (x.compareTo(this.m) < 0) return x;else {
        var r = nbi();
        x.copyTo(r);
        this.reduce(r);
        return r;
    }
}

function barrettRevert(x) {
    return x;
}

// x = x mod m (HAC 14.42)
function barrettReduce(x) {
    x.drShiftTo(this.m.t - 1, this.r2);
    if (x.t > this.m.t + 1) {
        x.t = this.m.t + 1;
        x.clamp();
    }
    this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
    this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
    while (x.compareTo(this.r2) < 0) {
        x.dAddOffset(1, this.m.t + 1);
    }x.subTo(this.r2, x);
    while (x.compareTo(this.m) >= 0) {
        x.subTo(this.m, x);
    }
}

// r = x^2 mod m; x != r
function barrettSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}

// r = x*y mod m; x,y != r
function barrettMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}

Barrett.prototype.convert = barrettConvert;
Barrett.prototype.revert = barrettRevert;
Barrett.prototype.reduce = barrettReduce;
Barrett.prototype.mulTo = barrettMulTo;
Barrett.prototype.sqrTo = barrettSqrTo;

// (public) this^e % m (HAC 14.85)
function bnModPow(e, m) {
    var i = e.bitLength(),
        k,
        r = nbv(1),
        z;
    if (i <= 0) return r;else if (i < 18) k = 1;else if (i < 48) k = 3;else if (i < 144) k = 4;else if (i < 768) k = 5;else k = 6;
    if (i < 8) z = new Classic(m);else if (m.isEven()) z = new Barrett(m);else z = new Montgomery(m);

    // precomputation
    var g = new Array(),
        n = 3,
        k1 = k - 1,
        km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = nbi();
        z.sqrTo(g[1], g2);
        while (n <= km) {
            g[n] = nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }

    var j = e.t - 1,
        w,
        is1 = true,
        r2 = nbi(),
        t;
    i = nbits(e[j]) - 1;
    while (j >= 0) {
        if (i >= k1) w = e[j] >> i - k1 & km;else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }

        n = k;
        while ((w & 1) == 0) {
            w >>= 1;--n;
        }
        if ((i -= n) < 0) {
            i += this.DB;--j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while (n > 1) {
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }

        while (j >= 0 && (e[j] & 1 << i) == 0) {
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;--j;
            }
        }
    }
    return z.revert(r);
}

// (public) gcd(this,a) (HAC 14.54)
function bnGCD(a) {
    var x = this.s < 0 ? this.negate() : this.clone();
    var y = a.s < 0 ? a.negate() : a.clone();
    if (x.compareTo(y) < 0) {
        var t = x;
        x = y;
        y = t;
    }
    var i = x.getLowestSetBit(),
        g = y.getLowestSetBit();
    if (g < 0) return x;
    if (i < g) g = i;
    if (g > 0) {
        x.rShiftTo(g, x);
        y.rShiftTo(g, y);
    }
    while (x.signum() > 0) {
        if ((i = x.getLowestSetBit()) > 0) x.rShiftTo(i, x);
        if ((i = y.getLowestSetBit()) > 0) y.rShiftTo(i, y);
        if (x.compareTo(y) >= 0) {
            x.subTo(y, x);
            x.rShiftTo(1, x);
        } else {
            y.subTo(x, y);
            y.rShiftTo(1, y);
        }
    }
    if (g > 0) y.lShiftTo(g, y);
    return y;
}

// (protected) this % n, n < 2^26
function bnpModInt(n) {
    if (n <= 0) return 0;
    var d = this.DV % n,
        r = this.s < 0 ? n - 1 : 0;
    if (this.t > 0) if (d == 0) r = this[0] % n;else for (var i = this.t - 1; i >= 0; --i) {
        r = (d * r + this[i]) % n;
    }return r;
}

// (public) 1/this % m (HAC 14.61)
function bnModInverse(m) {
    var ac = m.isEven();
    if (this.isEven() && ac || m.signum() == 0) return BigInteger.ZERO;
    var u = m.clone(),
        v = this.clone();
    var a = nbv(1),
        b = nbv(0),
        c = nbv(0),
        d = nbv(1);
    while (u.signum() != 0) {
        while (u.isEven()) {
            u.rShiftTo(1, u);
            if (ac) {
                if (!a.isEven() || !b.isEven()) {
                    a.addTo(this, a);
                    b.subTo(m, b);
                }
                a.rShiftTo(1, a);
            } else if (!b.isEven()) b.subTo(m, b);
            b.rShiftTo(1, b);
        }
        while (v.isEven()) {
            v.rShiftTo(1, v);
            if (ac) {
                if (!c.isEven() || !d.isEven()) {
                    c.addTo(this, c);
                    d.subTo(m, d);
                }
                c.rShiftTo(1, c);
            } else if (!d.isEven()) d.subTo(m, d);
            d.rShiftTo(1, d);
        }
        if (u.compareTo(v) >= 0) {
            u.subTo(v, u);
            if (ac) a.subTo(c, a);
            b.subTo(d, b);
        } else {
            v.subTo(u, v);
            if (ac) c.subTo(a, c);
            d.subTo(b, d);
        }
    }
    if (v.compareTo(BigInteger.ONE) != 0) return BigInteger.ZERO;
    if (d.compareTo(m) >= 0) return d.subtract(m);
    if (d.signum() < 0) d.addTo(m, d);else return d;
    if (d.signum() < 0) return d.add(m);else return d;
}

var lowprimes = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997];
var lplim = (1 << 26) / lowprimes[lowprimes.length - 1];

// (public) test primality with certainty >= 1-.5^t
function bnIsProbablePrime(t) {
    var i,
        x = this.abs();
    if (x.t == 1 && x[0] <= lowprimes[lowprimes.length - 1]) {
        for (i = 0; i < lowprimes.length; ++i) {
            if (x[0] == lowprimes[i]) return true;
        }return false;
    }
    if (x.isEven()) return false;
    i = 1;
    while (i < lowprimes.length) {
        var m = lowprimes[i],
            j = i + 1;
        while (j < lowprimes.length && m < lplim) {
            m *= lowprimes[j++];
        }m = x.modInt(m);
        while (i < j) {
            if (m % lowprimes[i++] == 0) return false;
        }
    }
    return x.millerRabin(t);
}

// (protected) true if probably prime (HAC 4.24, Miller-Rabin)
function bnpMillerRabin(t) {
    var n1 = this.subtract(BigInteger.ONE);
    var k = n1.getLowestSetBit();
    if (k <= 0) return false;
    var r = n1.shiftRight(k);
    t = t + 1 >> 1;
    if (t > lowprimes.length) t = lowprimes.length;
    var a = nbi();
    for (var i = 0; i < t; ++i) {
        //Pick bases at random, instead of starting at 2
        a.fromInt(lowprimes[Math.floor(Math.random() * lowprimes.length)]);
        var y = a.modPow(r, this);
        if (y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
            var j = 1;
            while (j++ < k && y.compareTo(n1) != 0) {
                y = y.modPowInt(2, this);
                if (y.compareTo(BigInteger.ONE) == 0) return false;
            }
            if (y.compareTo(n1) != 0) return false;
        }
    }
    return true;
}

// protected
BigInteger.prototype.chunkSize = bnpChunkSize;
BigInteger.prototype.toRadix = bnpToRadix;
BigInteger.prototype.fromRadix = bnpFromRadix;
BigInteger.prototype.fromNumber = bnpFromNumber;
BigInteger.prototype.bitwiseTo = bnpBitwiseTo;
BigInteger.prototype.changeBit = bnpChangeBit;
BigInteger.prototype.addTo = bnpAddTo;
BigInteger.prototype.dMultiply = bnpDMultiply;
BigInteger.prototype.dAddOffset = bnpDAddOffset;
BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
BigInteger.prototype.modInt = bnpModInt;
BigInteger.prototype.millerRabin = bnpMillerRabin;

// public
BigInteger.prototype.clone = bnClone;
BigInteger.prototype.intValue = bnIntValue;
BigInteger.prototype.byteValue = bnByteValue;
BigInteger.prototype.shortValue = bnShortValue;
BigInteger.prototype.signum = bnSigNum;
BigInteger.prototype.toByteArray = bnToByteArray;
BigInteger.prototype.equals = bnEquals;
BigInteger.prototype.min = bnMin;
BigInteger.prototype.max = bnMax;
BigInteger.prototype.and = bnAnd;
BigInteger.prototype.or = bnOr;
BigInteger.prototype.xor = bnXor;
BigInteger.prototype.andNot = bnAndNot;
BigInteger.prototype.not = bnNot;
BigInteger.prototype.shiftLeft = bnShiftLeft;
BigInteger.prototype.shiftRight = bnShiftRight;
BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;
BigInteger.prototype.bitCount = bnBitCount;
BigInteger.prototype.testBit = bnTestBit;
BigInteger.prototype.setBit = bnSetBit;
BigInteger.prototype.clearBit = bnClearBit;
BigInteger.prototype.flipBit = bnFlipBit;
BigInteger.prototype.add = bnAdd;
BigInteger.prototype.subtract = bnSubtract;
BigInteger.prototype.multiply = bnMultiply;
BigInteger.prototype.divide = bnDivide;
BigInteger.prototype.remainder = bnRemainder;
BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;
BigInteger.prototype.modPow = bnModPow;
BigInteger.prototype.modInverse = bnModInverse;
BigInteger.prototype.pow = bnPow;
BigInteger.prototype.gcd = bnGCD;
BigInteger.prototype.isProbablePrime = bnIsProbablePrime;

// JSBN-specific extension
BigInteger.prototype.square = bnSquare;

// BigInteger interfaces not implemented in jsbn:

// BigInteger(int signum, byte[] magnitude)
// double doubleValue()
// float floatValue()
// int hashCode()
// long longValue()
// static BigInteger valueOf(long val)

// prng4.js - uses Arcfour as a PRNG

function Arcfour() {
    this.i = 0;
    this.j = 0;
    this.S = new Array();
}

// Initialize arcfour context from key, an array of ints, each from [0..255]
function ARC4init(key) {
    var i, j, t;
    for (i = 0; i < 256; ++i) {
        this.S[i] = i;
    }j = 0;
    for (i = 0; i < 256; ++i) {
        j = j + this.S[i] + key[i % key.length] & 255;
        t = this.S[i];
        this.S[i] = this.S[j];
        this.S[j] = t;
    }
    this.i = 0;
    this.j = 0;
}

function ARC4next() {
    var t;
    this.i = this.i + 1 & 255;
    this.j = this.j + this.S[this.i] & 255;
    t = this.S[this.i];
    this.S[this.i] = this.S[this.j];
    this.S[this.j] = t;
    return this.S[t + this.S[this.i] & 255];
}

Arcfour.prototype.init = ARC4init;
Arcfour.prototype.next = ARC4next;

// Plug in your RNG constructor here
function prng_newstate() {
    return new Arcfour();
}

// Pool size must be a multiple of 4 and greater than 32.
// An array of bytes the size of the pool will be passed to init()
var rng_psize = 256;

// Random number generator - requires a PRNG backend, e.g. prng4.js
var rng_state;
var rng_pool;
var rng_pptr;

// Initialize the pool with junk if needed.
if (rng_pool == null) {
    rng_pool = new Array();
    rng_pptr = 0;
    var t;
    if (window.crypto && window.crypto.getRandomValues) {
        // Extract entropy (2048 bits) from RNG if available
        var z = new Uint32Array(256);
        window.crypto.getRandomValues(z);
        for (t = 0; t < z.length; ++t) {
            rng_pool[rng_pptr++] = z[t] & 255;
        }
    }

    // Use mouse events for entropy, if we do not have enough entropy by the time
    // we need it, entropy will be generated by Math.random.
    var onMouseMoveListener = function onMouseMoveListener(ev) {
        this.count = this.count || 0;
        if (this.count >= 256 || rng_pptr >= rng_psize) {
            if (window.removeEventListener) window.removeEventListener("mousemove", onMouseMoveListener, false);else if (window.detachEvent) window.detachEvent("onmousemove", onMouseMoveListener);
            return;
        }
        try {
            var mouseCoordinates = ev.x + ev.y;
            rng_pool[rng_pptr++] = mouseCoordinates & 255;
            this.count += 1;
        } catch (e) {
            // Sometimes Firefox will deny permission to access event properties for some reason. Ignore.
        }
    };
    if (window.addEventListener) window.addEventListener("mousemove", onMouseMoveListener, false);else if (window.attachEvent) window.attachEvent("onmousemove", onMouseMoveListener);
}

function rng_get_byte() {
    if (rng_state == null) {
        rng_state = prng_newstate();
        // At this point, we may not have collected enough entropy.  If not, fall back to Math.random
        while (rng_pptr < rng_psize) {
            var random = Math.floor(65536 * Math.random());
            rng_pool[rng_pptr++] = random & 255;
        }
        rng_state.init(rng_pool);
        for (rng_pptr = 0; rng_pptr < rng_pool.length; ++rng_pptr) {
            rng_pool[rng_pptr] = 0;
        }rng_pptr = 0;
    }
    // TODO: allow reseeding after first request
    return rng_state.next();
}

function rng_get_bytes(ba) {
    var i;
    for (i = 0; i < ba.length; ++i) {
        ba[i] = rng_get_byte();
    }
}

function SecureRandom() {}

SecureRandom.prototype.nextBytes = rng_get_bytes;

// Depends on jsbn.js and rng.js

// Version 1.1: support utf-8 encoding in pkcs1pad2

// convert a (hex) string to a bignum object
function parseBigInt(str, r) {
    return new BigInteger(str, r);
}

function linebrk(s, n) {
    var ret = "";
    var i = 0;
    while (i + n < s.length) {
        ret += s.substring(i, i + n) + "\n";
        i += n;
    }
    return ret + s.substring(i, s.length);
}

function byte2Hex(b) {
    if (b < 0x10) return "0" + b.toString(16);else return b.toString(16);
}

// PKCS#1 (type 2, random) pad input string s to n bytes, and return a bigint
function pkcs1pad2(s, n) {
    if (n < s.length + 11) {
        // TODO: fix for utf-8
        console.error("Message too long for RSA");
        return null;
    }
    var ba = new Array();
    var i = s.length - 1;
    while (i >= 0 && n > 0) {
        var c = s.charCodeAt(i--);
        if (c < 128) {
            // encode using utf-8
            ba[--n] = c;
        } else if (c > 127 && c < 2048) {
            ba[--n] = c & 63 | 128;
            ba[--n] = c >> 6 | 192;
        } else {
            ba[--n] = c & 63 | 128;
            ba[--n] = c >> 6 & 63 | 128;
            ba[--n] = c >> 12 | 224;
        }
    }
    ba[--n] = 0;
    var rng = new SecureRandom();
    var x = new Array();
    while (n > 2) {
        // random non-zero pad
        x[0] = 0;
        while (x[0] == 0) {
            rng.nextBytes(x);
        }ba[--n] = x[0];
    }
    ba[--n] = 2;
    ba[--n] = 0;
    return new BigInteger(ba);
}

// "empty" RSA key constructor
function RSAKey() {
    this.n = null;
    this.e = 0;
    this.d = null;
    this.p = null;
    this.q = null;
    this.dmp1 = null;
    this.dmq1 = null;
    this.coeff = null;
}

// Set the public key fields N and e from hex strings
function RSASetPublic(N, E) {
    if (N != null && E != null && N.length > 0 && E.length > 0) {
        this.n = parseBigInt(N, 16);
        this.e = parseInt(E, 16);
    } else console.error("Invalid RSA public key");
}

// Perform raw public operation on "x": return x^e (mod n)
function RSADoPublic(x) {
    return x.modPowInt(this.e, this.n);
}

// Return the PKCS#1 RSA encryption of "text" as an even-length hex string
function RSAEncrypt(text) {
    var m = pkcs1pad2(text, this.n.bitLength() + 7 >> 3);
    if (m == null) return null;
    var c = this.doPublic(m);
    if (c == null) return null;
    var h = c.toString(16);
    if ((h.length & 1) == 0) return h;else return "0" + h;
}

// Return the PKCS#1 RSA encryption of "text" as a Base64-encoded string
//function RSAEncryptB64(text) {
//  var h = this.encrypt(text);
//  if(h) return hex2b64(h); else return null;
//}

// protected
RSAKey.prototype.doPublic = RSADoPublic;

// public
RSAKey.prototype.setPublic = RSASetPublic;
RSAKey.prototype.encrypt = RSAEncrypt;
//RSAKey.prototype.encrypt_b64 = RSAEncryptB64;

// Depends on rsa.js and jsbn2.js

// Version 1.1: support utf-8 decoding in pkcs1unpad2

// Undo PKCS#1 (type 2, random) padding and, if valid, return the plaintext
function pkcs1unpad2(d, n) {
    var b = d.toByteArray();
    var i = 0;
    while (i < b.length && b[i] == 0) {
        ++i;
    }if (b.length - i != n - 1 || b[i] != 2) return null;
    ++i;
    while (b[i] != 0) {
        if (++i >= b.length) return null;
    }var ret = "";
    while (++i < b.length) {
        var c = b[i] & 255;
        if (c < 128) {
            // utf-8 decode
            ret += String.fromCharCode(c);
        } else if (c > 191 && c < 224) {
            ret += String.fromCharCode((c & 31) << 6 | b[i + 1] & 63);
            ++i;
        } else {
            ret += String.fromCharCode((c & 15) << 12 | (b[i + 1] & 63) << 6 | b[i + 2] & 63);
            i += 2;
        }
    }
    return ret;
}

// Set the private key fields N, e, and d from hex strings
function RSASetPrivate(N, E, D) {
    if (N != null && E != null && N.length > 0 && E.length > 0) {
        this.n = parseBigInt(N, 16);
        this.e = parseInt(E, 16);
        this.d = parseBigInt(D, 16);
    } else console.error("Invalid RSA private key");
}

// Set the private key fields N, e, d and CRT params from hex strings
function RSASetPrivateEx(N, E, D, P, Q, DP, DQ, C) {
    if (N != null && E != null && N.length > 0 && E.length > 0) {
        this.n = parseBigInt(N, 16);
        this.e = parseInt(E, 16);
        this.d = parseBigInt(D, 16);
        this.p = parseBigInt(P, 16);
        this.q = parseBigInt(Q, 16);
        this.dmp1 = parseBigInt(DP, 16);
        this.dmq1 = parseBigInt(DQ, 16);
        this.coeff = parseBigInt(C, 16);
    } else console.error("Invalid RSA private key");
}

// Generate a new random private key B bits long, using public expt E
function RSAGenerate(B, E) {
    var rng = new SecureRandom();
    var qs = B >> 1;
    this.e = parseInt(E, 16);
    var ee = new BigInteger(E, 16);
    for (;;) {
        for (;;) {
            this.p = new BigInteger(B - qs, 1, rng);
            if (this.p.subtract(BigInteger.ONE).gcd(ee).compareTo(BigInteger.ONE) == 0 && this.p.isProbablePrime(10)) break;
        }
        for (;;) {
            this.q = new BigInteger(qs, 1, rng);
            if (this.q.subtract(BigInteger.ONE).gcd(ee).compareTo(BigInteger.ONE) == 0 && this.q.isProbablePrime(10)) break;
        }
        if (this.p.compareTo(this.q) <= 0) {
            var t = this.p;
            this.p = this.q;
            this.q = t;
        }
        var p1 = this.p.subtract(BigInteger.ONE);
        var q1 = this.q.subtract(BigInteger.ONE);
        var phi = p1.multiply(q1);
        if (phi.gcd(ee).compareTo(BigInteger.ONE) == 0) {
            this.n = this.p.multiply(this.q);
            this.d = ee.modInverse(phi);
            this.dmp1 = this.d.mod(p1);
            this.dmq1 = this.d.mod(q1);
            this.coeff = this.q.modInverse(this.p);
            break;
        }
    }
}

// Perform raw private operation on "x": return x^d (mod n)
function RSADoPrivate(x) {
    if (this.p == null || this.q == null) return x.modPow(this.d, this.n);

    // TODO: re-calculate any missing CRT params
    var xp = x.mod(this.p).modPow(this.dmp1, this.p);
    var xq = x.mod(this.q).modPow(this.dmq1, this.q);

    while (xp.compareTo(xq) < 0) {
        xp = xp.add(this.p);
    }return xp.subtract(xq).multiply(this.coeff).mod(this.p).multiply(this.q).add(xq);
}

// Return the PKCS#1 RSA decryption of "ctext".
// "ctext" is an even-length hex string and the output is a plain string.
function RSADecrypt(ctext) {
    var c = parseBigInt(ctext, 16);
    var m = this.doPrivate(c);
    if (m == null) return null;
    return pkcs1unpad2(m, this.n.bitLength() + 7 >> 3);
}

// Return the PKCS#1 RSA decryption of "ctext".
// "ctext" is a Base64-encoded string and the output is a plain string.
//function RSAB64Decrypt(ctext) {
//  var h = b64tohex(ctext);
//  if(h) return this.decrypt(h); else return null;
//}

// protected
RSAKey.prototype.doPrivate = RSADoPrivate;

// public
RSAKey.prototype.setPrivate = RSASetPrivate;
RSAKey.prototype.setPrivateEx = RSASetPrivateEx;
RSAKey.prototype.generate = RSAGenerate;
RSAKey.prototype.decrypt = RSADecrypt;
//RSAKey.prototype.b64_decrypt = RSAB64Decrypt;

// Copyright (c) 2011  Kevin M Burns Jr.
// All Rights Reserved.
// See "LICENSE" for details.
//
// Extension to jsbn which adds facilities for asynchronous RSA key generation
// Primarily created to avoid execution timeout on mobile devices
//
// //www-cs-students.stanford.edu/~tjw/jsbn/
//
// ---

(function () {

    // Generate a new random private key B bits long, using public expt E
    var RSAGenerateAsync = function RSAGenerateAsync(B, E, callback) {
        //var rng = new SeededRandom();
        var rng = new SecureRandom();
        var qs = B >> 1;
        this.e = parseInt(E, 16);
        var ee = new BigInteger(E, 16);
        var rsa = this;
        // These functions have non-descript names because they were originally for(;;) loops.
        // I don't know about cryptography to give them better names than loop1-4.
        var loop1 = function loop1() {
            var loop4 = function loop4() {
                if (rsa.p.compareTo(rsa.q) <= 0) {
                    var t = rsa.p;
                    rsa.p = rsa.q;
                    rsa.q = t;
                }
                var p1 = rsa.p.subtract(BigInteger.ONE);
                var q1 = rsa.q.subtract(BigInteger.ONE);
                var phi = p1.multiply(q1);
                if (phi.gcd(ee).compareTo(BigInteger.ONE) == 0) {
                    rsa.n = rsa.p.multiply(rsa.q);
                    rsa.d = ee.modInverse(phi);
                    rsa.dmp1 = rsa.d.mod(p1);
                    rsa.dmq1 = rsa.d.mod(q1);
                    rsa.coeff = rsa.q.modInverse(rsa.p);
                    setTimeout(function () {
                        callback();
                    }, 0); // escape
                } else {
                    setTimeout(loop1, 0);
                }
            };
            var loop3 = function loop3() {
                rsa.q = nbi();
                rsa.q.fromNumberAsync(qs, 1, rng, function () {
                    rsa.q.subtract(BigInteger.ONE).gcda(ee, function (r) {
                        if (r.compareTo(BigInteger.ONE) == 0 && rsa.q.isProbablePrime(10)) {
                            setTimeout(loop4, 0);
                        } else {
                            setTimeout(loop3, 0);
                        }
                    });
                });
            };
            var loop2 = function loop2() {
                rsa.p = nbi();
                rsa.p.fromNumberAsync(B - qs, 1, rng, function () {
                    rsa.p.subtract(BigInteger.ONE).gcda(ee, function (r) {
                        if (r.compareTo(BigInteger.ONE) == 0 && rsa.p.isProbablePrime(10)) {
                            setTimeout(loop3, 0);
                        } else {
                            setTimeout(loop2, 0);
                        }
                    });
                });
            };
            setTimeout(loop2, 0);
        };
        setTimeout(loop1, 0);
    };
    RSAKey.prototype.generateAsync = RSAGenerateAsync;

    // Public API method
    var bnGCDAsync = function bnGCDAsync(a, callback) {
        var x = this.s < 0 ? this.negate() : this.clone();
        var y = a.s < 0 ? a.negate() : a.clone();
        if (x.compareTo(y) < 0) {
            var t = x;
            x = y;
            y = t;
        }
        var i = x.getLowestSetBit(),
            g = y.getLowestSetBit();
        if (g < 0) {
            callback(x);
            return;
        }
        if (i < g) g = i;
        if (g > 0) {
            x.rShiftTo(g, x);
            y.rShiftTo(g, y);
        }
        // Workhorse of the algorithm, gets called 200 - 800 times per 512 bit keygen.
        var gcda1 = function gcda1() {
            if ((i = x.getLowestSetBit()) > 0) {
                x.rShiftTo(i, x);
            }
            if ((i = y.getLowestSetBit()) > 0) {
                y.rShiftTo(i, y);
            }
            if (x.compareTo(y) >= 0) {
                x.subTo(y, x);
                x.rShiftTo(1, x);
            } else {
                y.subTo(x, y);
                y.rShiftTo(1, y);
            }
            if (!(x.signum() > 0)) {
                if (g > 0) y.lShiftTo(g, y);
                setTimeout(function () {
                    callback(y);
                }, 0); // escape
            } else {
                setTimeout(gcda1, 0);
            }
        };
        setTimeout(gcda1, 10);
    };
    BigInteger.prototype.gcda = bnGCDAsync;

    // (protected) alternate constructor
    var bnpFromNumberAsync = function bnpFromNumberAsync(a, b, c, callback) {
        if ("number" == typeof b) {
            if (a < 2) {
                this.fromInt(1);
            } else {
                this.fromNumber(a, c);
                if (!this.testBit(a - 1)) {
                    this.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), op_or, this);
                }
                if (this.isEven()) {
                    this.dAddOffset(1, 0);
                }
                var bnp = this;
                var bnpfn1 = function bnpfn1() {
                    bnp.dAddOffset(2, 0);
                    if (bnp.bitLength() > a) bnp.subTo(BigInteger.ONE.shiftLeft(a - 1), bnp);
                    if (bnp.isProbablePrime(b)) {
                        setTimeout(function () {
                            callback();
                        }, 0); // escape
                    } else {
                        setTimeout(bnpfn1, 0);
                    }
                };
                setTimeout(bnpfn1, 0);
            }
        } else {
            var x = new Array(),
                t = a & 7;
            x.length = (a >> 3) + 1;
            b.nextBytes(x);
            if (t > 0) x[0] &= (1 << t) - 1;else x[0] = 0;
            this.fromString(x, 256);
        }
    };
    BigInteger.prototype.fromNumberAsync = bnpFromNumberAsync;
})();
var b64map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var b64pad = "=";

function hex2b64(h) {
    var i;
    var c;
    var ret = "";
    for (i = 0; i + 3 <= h.length; i += 3) {
        c = parseInt(h.substring(i, i + 3), 16);
        ret += b64map.charAt(c >> 6) + b64map.charAt(c & 63);
    }
    if (i + 1 == h.length) {
        c = parseInt(h.substring(i, i + 1), 16);
        ret += b64map.charAt(c << 2);
    } else if (i + 2 == h.length) {
        c = parseInt(h.substring(i, i + 2), 16);
        ret += b64map.charAt(c >> 2) + b64map.charAt((c & 3) << 4);
    }
    while ((ret.length & 3) > 0) {
        ret += b64pad;
    }return ret;
}

// convert a base64 string to hex
function b64tohex(s) {
    var ret = "";
    var i;
    var k = 0; // b64 state, 0-3
    var slop;
    for (i = 0; i < s.length; ++i) {
        if (s.charAt(i) == b64pad) break;
        v = b64map.indexOf(s.charAt(i));
        if (v < 0) continue;
        if (k == 0) {
            ret += int2char(v >> 2);
            slop = v & 3;
            k = 1;
        } else if (k == 1) {
            ret += int2char(slop << 2 | v >> 4);
            slop = v & 0xf;
            k = 2;
        } else if (k == 2) {
            ret += int2char(slop);
            ret += int2char(v >> 2);
            slop = v & 3;
            k = 3;
        } else {
            ret += int2char(slop << 2 | v >> 4);
            ret += int2char(v & 0xf);
            k = 0;
        }
    }
    if (k == 1) ret += int2char(slop << 2);
    return ret;
}

// convert a base64 string to a byte/number array
function b64toBA(s) {
    //piggyback on b64tohex for now, optimize later
    var h = b64tohex(s);
    var i;
    var a = new Array();
    for (i = 0; 2 * i < h.length; ++i) {
        a[i] = parseInt(h.substring(2 * i, 2 * i + 2), 16);
    }
    return a;
}

/*! asn1-1.0.2.js (c) 2013 Kenji Urushima | kjur.github.com/jsrsasign/license
 */

var JSX = JSX || {};
JSX.env = JSX.env || {};

var L = JSX,
    OP = Object.prototype,
    FUNCTION_TOSTRING = '[object Function]',
    ADD = ["toString", "valueOf"];

JSX.env.parseUA = function (agent) {

    var numberify = function numberify(s) {
        var c = 0;
        return parseFloat(s.replace(/\./g, function () {
            return c++ == 1 ? '' : '.';
        }));
    },
        nav = navigator,
        o = {
        ie: 0,
        opera: 0,
        gecko: 0,
        webkit: 0,
        chrome: 0,
        mobile: null,
        air: 0,
        ipad: 0,
        iphone: 0,
        ipod: 0,
        ios: null,
        android: 0,
        webos: 0,
        caja: nav && nav.cajaVersion,
        secure: false,
        os: null

    },
        ua = agent || navigator && navigator.userAgent,
        loc = window && window.location,
        href = loc && loc.href,
        m;

    o.secure = href && href.toLowerCase().indexOf("https") === 0;

    if (ua) {

        if (/windows|win32/i.test(ua)) {
            o.os = 'windows';
        } else if (/macintosh/i.test(ua)) {
            o.os = 'macintosh';
        } else if (/rhino/i.test(ua)) {
            o.os = 'rhino';
        }
        if (/KHTML/.test(ua)) {
            o.webkit = 1;
        }
        m = ua.match(/AppleWebKit\/([^\s]*)/);
        if (m && m[1]) {
            o.webkit = numberify(m[1]);
            if (/ Mobile\//.test(ua)) {
                o.mobile = 'Apple'; // iPhone or iPod Touch
                m = ua.match(/OS ([^\s]*)/);
                if (m && m[1]) {
                    m = numberify(m[1].replace('_', '.'));
                }
                o.ios = m;
                o.ipad = o.ipod = o.iphone = 0;
                m = ua.match(/iPad|iPod|iPhone/);
                if (m && m[0]) {
                    o[m[0].toLowerCase()] = o.ios;
                }
            } else {
                m = ua.match(/NokiaN[^\/]*|Android \d\.\d|webOS\/\d\.\d/);
                if (m) {
                    o.mobile = m[0];
                }
                if (/webOS/.test(ua)) {
                    o.mobile = 'WebOS';
                    m = ua.match(/webOS\/([^\s]*);/);
                    if (m && m[1]) {
                        o.webos = numberify(m[1]);
                    }
                }
                if (/ Android/.test(ua)) {
                    o.mobile = 'Android';
                    m = ua.match(/Android ([^\s]*);/);
                    if (m && m[1]) {
                        o.android = numberify(m[1]);
                    }
                }
            }
            m = ua.match(/Chrome\/([^\s]*)/);
            if (m && m[1]) {
                o.chrome = numberify(m[1]); // Chrome
            } else {
                m = ua.match(/AdobeAIR\/([^\s]*)/);
                if (m) {
                    o.air = m[0]; // Adobe AIR 1.0 or better
                }
            }
        }
        if (!o.webkit) {
            m = ua.match(/Opera[\s\/]([^\s]*)/);
            if (m && m[1]) {
                o.opera = numberify(m[1]);
                m = ua.match(/Version\/([^\s]*)/);
                if (m && m[1]) {
                    o.opera = numberify(m[1]); // opera 10+
                }
                m = ua.match(/Opera Mini[^;]*/);
                if (m) {
                    o.mobile = m[0]; // ex: Opera Mini/2.0.4509/1316
                }
            } else {
                // not opera or webkit
                m = ua.match(/MSIE\s([^;]*)/);
                if (m && m[1]) {
                    o.ie = numberify(m[1]);
                } else {
                    // not opera, webkit, or ie
                    m = ua.match(/Gecko\/([^\s]*)/);
                    if (m) {
                        o.gecko = 1; // Gecko detected, look for revision
                        m = ua.match(/rv:([^\s\)]*)/);
                        if (m && m[1]) {
                            o.gecko = numberify(m[1]);
                        }
                    }
                }
            }
        }
    }
    return o;
};

JSX.env.ua = JSX.env.parseUA();

JSX.isFunction = function (o) {
    return typeof o === 'function' || OP.toString.apply(o) === FUNCTION_TOSTRING;
};

JSX._IEEnumFix = JSX.env.ua.ie ? function (r, s) {
    var i, fname, f;
    for (i = 0; i < ADD.length; i = i + 1) {

        fname = ADD[i];
        f = s[fname];

        if (L.isFunction(f) && f != OP[fname]) {
            r[fname] = f;
        }
    }
} : function () {};

JSX.extend = function (subc, superc, overrides) {
    if (!superc || !subc) {
        throw new Error("extend failed, please check that " + "all dependencies are included.");
    }
    var F = function F() {},
        i;
    F.prototype = superc.prototype;
    subc.prototype = new F();
    subc.prototype.constructor = subc;
    subc.superclass = superc.prototype;
    if (superc.prototype.constructor == OP.constructor) {
        superc.prototype.constructor = superc;
    }

    if (overrides) {
        for (i in overrides) {
            if (L.hasOwnProperty(overrides, i)) {
                subc.prototype[i] = overrides[i];
            }
        }

        L._IEEnumFix(subc.prototype, overrides);
    }
};

/*
 * asn1.js - ASN.1 DER encoder classes
 *
 * Copyright (c) 2013 Kenji Urushima (kenji.urushima@gmail.com)
 *
 * This software is licensed under the terms of the MIT License.
 * //kjur.github.com/jsrsasign/license
 *
 * The above copyright and license notice shall be 
 * included in all copies or substantial portions of the Software.
 */

/**
 * @fileOverview
 * @name asn1-1.0.js
 * @author Kenji Urushima kenji.urushima@gmail.com
 * @version 1.0.2 (2013-May-30)
 * @since 2.1
 * @license <a href="//kjur.github.io/jsrsasign/license/">MIT License</a>
 */

/** 
 * kjur's class library name space
 * <p>
 * This name space provides following name spaces:
 * <ul>
 * <li>{@link KJUR.asn1} - ASN.1 primitive hexadecimal encoder</li>
 * <li>{@link KJUR.asn1.x509} - ASN.1 structure for X.509 certificate and CRL</li>
 * <li>{@link KJUR.crypto} - Java Cryptographic Extension(JCE) style MessageDigest/Signature 
 * class and utilities</li>
 * </ul>
 * </p> 
 * NOTE: Please ignore method summary and document of this namespace. This caused by a bug of jsdoc2.
 * @name KJUR
 * @namespace kjur's class library name space
 */
var KJUR = KJUR || {};

/**
 * kjur's ASN.1 class library name space
 * <p>
 * This is ITU-T X.690 ASN.1 DER encoder class library and
 * class structure and methods is very similar to 
 * org.bouncycastle.asn1 package of 
 * well known BouncyCaslte Cryptography Library.
 *
 * <h4>PROVIDING ASN.1 PRIMITIVES</h4>
 * Here are ASN.1 DER primitive classes.
 * <ul>
 * <li>{@link KJUR.asn1.DERBoolean}</li>
 * <li>{@link KJUR.asn1.DERInteger}</li>
 * <li>{@link KJUR.asn1.DERBitString}</li>
 * <li>{@link KJUR.asn1.DEROctetString}</li>
 * <li>{@link KJUR.asn1.DERNull}</li>
 * <li>{@link KJUR.asn1.DERObjectIdentifier}</li>
 * <li>{@link KJUR.asn1.DERUTF8String}</li>
 * <li>{@link KJUR.asn1.DERNumericString}</li>
 * <li>{@link KJUR.asn1.DERPrintableString}</li>
 * <li>{@link KJUR.asn1.DERTeletexString}</li>
 * <li>{@link KJUR.asn1.DERIA5String}</li>
 * <li>{@link KJUR.asn1.DERUTCTime}</li>
 * <li>{@link KJUR.asn1.DERGeneralizedTime}</li>
 * <li>{@link KJUR.asn1.DERSequence}</li>
 * <li>{@link KJUR.asn1.DERSet}</li>
 * </ul>
 *
 * <h4>OTHER ASN.1 CLASSES</h4>
 * <ul>
 * <li>{@link KJUR.asn1.ASN1Object}</li>
 * <li>{@link KJUR.asn1.DERAbstractString}</li>
 * <li>{@link KJUR.asn1.DERAbstractTime}</li>
 * <li>{@link KJUR.asn1.DERAbstractStructured}</li>
 * <li>{@link KJUR.asn1.DERTaggedObject}</li>
 * </ul>
 * </p>
 * NOTE: Please ignore method summary and document of this namespace. This caused by a bug of jsdoc2.
 * @name KJUR.asn1
 * @namespace
 */
if (typeof KJUR.asn1 == "undefined" || !KJUR.asn1) KJUR.asn1 = {};

/**
 * ASN1 utilities class
 * @name KJUR.asn1.ASN1Util
 * @classs ASN1 utilities class
 * @since asn1 1.0.2
 */
KJUR.asn1.ASN1Util = new function () {
    this.integerToByteHex = function (i) {
        var h = i.toString(16);
        if (h.length % 2 == 1) h = '0' + h;
        return h;
    };
    this.bigIntToMinTwosComplementsHex = function (bigIntegerValue) {
        var h = bigIntegerValue.toString(16);
        if (h.substr(0, 1) != '-') {
            if (h.length % 2 == 1) {
                h = '0' + h;
            } else {
                if (!h.match(/^[0-7]/)) {
                    h = '00' + h;
                }
            }
        } else {
            var hPos = h.substr(1);
            var xorLen = hPos.length;
            if (xorLen % 2 == 1) {
                xorLen += 1;
            } else {
                if (!h.match(/^[0-7]/)) {
                    xorLen += 2;
                }
            }
            var hMask = '';
            for (var i = 0; i < xorLen; i++) {
                hMask += 'f';
            }
            var biMask = new BigInteger(hMask, 16);
            var biNeg = biMask.xor(bigIntegerValue).add(BigInteger.ONE);
            h = biNeg.toString(16).replace(/^-/, '');
        }
        return h;
    };
    /**
     * get PEM string from hexadecimal data and header string
     * @name getPEMStringFromHex
     * @memberOf KJUR.asn1.ASN1Util
     * @function
     * @param {String} dataHex hexadecimal string of PEM body
     * @param {String} pemHeader PEM header string (ex. 'RSA PRIVATE KEY')
     * @return {String} PEM formatted string of input data
     * @description
     * @example
     * var pem  = KJUR.asn1.ASN1Util.getPEMStringFromHex('616161', 'RSA PRIVATE KEY');
     * // value of pem will be:
     * -----BEGIN PRIVATE KEY-----
     * YWFh
     * -----END PRIVATE KEY-----
     */
    this.getPEMStringFromHex = function (dataHex, pemHeader) {
        var dataWA = CryptoJS.enc.Hex.parse(dataHex);
        var dataB64 = CryptoJS.enc.Base64.stringify(dataWA);
        var pemBody = dataB64.replace(/(.{64})/g, "$1\r\n");
        pemBody = pemBody.replace(/\r\n$/, '');
        return "-----BEGIN " + pemHeader + "-----\r\n" + pemBody + "\r\n-----END " + pemHeader + "-----\r\n";
    };
}();

// ********************************************************************
//  Abstract ASN.1 Classes
// ********************************************************************

// ********************************************************************

/**
 * base class for ASN.1 DER encoder object
 * @name KJUR.asn1.ASN1Object
 * @class base class for ASN.1 DER encoder object
 * @property {Boolean} isModified flag whether internal data was changed
 * @property {String} hTLV hexadecimal string of ASN.1 TLV
 * @property {String} hT hexadecimal string of ASN.1 TLV tag(T)
 * @property {String} hL hexadecimal string of ASN.1 TLV length(L)
 * @property {String} hV hexadecimal string of ASN.1 TLV value(V)
 * @description
 */
KJUR.asn1.ASN1Object = function () {
    var isModified = true;
    var hTLV = null;
    var hT = '00';
    var hL = '00';
    var hV = '';

    /**
     * get hexadecimal ASN.1 TLV length(L) bytes from TLV value(V)
     * @name getLengthHexFromValue
     * @memberOf KJUR.asn1.ASN1Object
     * @function
     * @return {String} hexadecimal string of ASN.1 TLV length(L)
     */
    this.getLengthHexFromValue = function () {
        if (typeof this.hV == "undefined" || this.hV == null) {
            throw "this.hV is null or undefined.";
        }
        if (this.hV.length % 2 == 1) {
            throw "value hex must be even length: n=" + hV.length + ",v=" + this.hV;
        }
        var n = this.hV.length / 2;
        var hN = n.toString(16);
        if (hN.length % 2 == 1) {
            hN = "0" + hN;
        }
        if (n < 128) {
            return hN;
        } else {
            var hNlen = hN.length / 2;
            if (hNlen > 15) {
                throw "ASN.1 length too long to represent by 8x: n = " + n.toString(16);
            }
            var head = 128 + hNlen;
            return head.toString(16) + hN;
        }
    };

    /**
     * get hexadecimal string of ASN.1 TLV bytes
     * @name getEncodedHex
     * @memberOf KJUR.asn1.ASN1Object
     * @function
     * @return {String} hexadecimal string of ASN.1 TLV
     */
    this.getEncodedHex = function () {
        if (this.hTLV == null || this.isModified) {
            this.hV = this.getFreshValueHex();
            this.hL = this.getLengthHexFromValue();
            this.hTLV = this.hT + this.hL + this.hV;
            this.isModified = false;
            //console.error("first time: " + this.hTLV);
        }
        return this.hTLV;
    };

    /**
     * get hexadecimal string of ASN.1 TLV value(V) bytes
     * @name getValueHex
     * @memberOf KJUR.asn1.ASN1Object
     * @function
     * @return {String} hexadecimal string of ASN.1 TLV value(V) bytes
     */
    this.getValueHex = function () {
        this.getEncodedHex();
        return this.hV;
    };

    this.getFreshValueHex = function () {
        return '';
    };
};

// == BEGIN DERAbstractString ================================================
/**
 * base class for ASN.1 DER string classes
 * @name KJUR.asn1.DERAbstractString
 * @class base class for ASN.1 DER string classes
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @property {String} s internal string of value
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>str - specify initial ASN.1 value(V) by a string</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 */
KJUR.asn1.DERAbstractString = function (params) {
    KJUR.asn1.DERAbstractString.superclass.constructor.call(this);
    var s = null;
    var hV = null;

    /**
     * get string value of this string object
     * @name getString
     * @memberOf KJUR.asn1.DERAbstractString
     * @function
     * @return {String} string value of this string object
     */
    this.getString = function () {
        return this.s;
    };

    /**
     * set value by a string
     * @name setString
     * @memberOf KJUR.asn1.DERAbstractString
     * @function
     * @param {String} newS value by a string to set
     */
    this.setString = function (newS) {
        this.hTLV = null;
        this.isModified = true;
        this.s = newS;
        this.hV = stohex(this.s);
    };

    /**
     * set value by a hexadecimal string
     * @name setStringHex
     * @memberOf KJUR.asn1.DERAbstractString
     * @function
     * @param {String} newHexString value by a hexadecimal string to set
     */
    this.setStringHex = function (newHexString) {
        this.hTLV = null;
        this.isModified = true;
        this.s = null;
        this.hV = newHexString;
    };

    this.getFreshValueHex = function () {
        return this.hV;
    };

    if (typeof params != "undefined") {
        if (typeof params['str'] != "undefined") {
            this.setString(params['str']);
        } else if (typeof params['hex'] != "undefined") {
            this.setStringHex(params['hex']);
        }
    }
};
JSX.extend(KJUR.asn1.DERAbstractString, KJUR.asn1.ASN1Object);
// == END   DERAbstractString ================================================

// == BEGIN DERAbstractTime ==================================================
/**
 * base class for ASN.1 DER Generalized/UTCTime class
 * @name KJUR.asn1.DERAbstractTime
 * @class base class for ASN.1 DER Generalized/UTCTime class
 * @param {Array} params associative array of parameters (ex. {'str': '130430235959Z'})
 * @extends KJUR.asn1.ASN1Object
 * @description
 * @see KJUR.asn1.ASN1Object - superclass
 */
KJUR.asn1.DERAbstractTime = function (params) {
    KJUR.asn1.DERAbstractTime.superclass.constructor.call(this);
    var s = null;
    var date = null;

    // --- PRIVATE METHODS --------------------
    this.localDateToUTC = function (d) {
        utc = d.getTime() + d.getTimezoneOffset() * 60000;
        var utcDate = new Date(utc);
        return utcDate;
    };

    this.formatDate = function (dateObject, type) {
        var pad = this.zeroPadding;
        var d = this.localDateToUTC(dateObject);
        var year = String(d.getFullYear());
        if (type == 'utc') year = year.substr(2, 2);
        var month = pad(String(d.getMonth() + 1), 2);
        var day = pad(String(d.getDate()), 2);
        var hour = pad(String(d.getHours()), 2);
        var min = pad(String(d.getMinutes()), 2);
        var sec = pad(String(d.getSeconds()), 2);
        return year + month + day + hour + min + sec + 'Z';
    };

    this.zeroPadding = function (s, len) {
        if (s.length >= len) return s;
        return new Array(len - s.length + 1).join('0') + s;
    };

    // --- PUBLIC METHODS --------------------
    /**
     * get string value of this string object
     * @name getString
     * @memberOf KJUR.asn1.DERAbstractTime
     * @function
     * @return {String} string value of this time object
     */
    this.getString = function () {
        return this.s;
    };

    /**
     * set value by a string
     * @name setString
     * @memberOf KJUR.asn1.DERAbstractTime
     * @function
     * @param {String} newS value by a string to set such like "130430235959Z"
     */
    this.setString = function (newS) {
        this.hTLV = null;
        this.isModified = true;
        this.s = newS;
        this.hV = stohex(this.s);
    };

    /**
     * set value by a Date object
     * @name setByDateValue
     * @memberOf KJUR.asn1.DERAbstractTime
     * @function
     * @param {Integer} year year of date (ex. 2013)
     * @param {Integer} month month of date between 1 and 12 (ex. 12)
     * @param {Integer} day day of month
     * @param {Integer} hour hours of date
     * @param {Integer} min minutes of date
     * @param {Integer} sec seconds of date
     */
    this.setByDateValue = function (year, month, day, hour, min, sec) {
        var dateObject = new Date(Date.UTC(year, month - 1, day, hour, min, sec, 0));
        this.setByDate(dateObject);
    };

    this.getFreshValueHex = function () {
        return this.hV;
    };
};
JSX.extend(KJUR.asn1.DERAbstractTime, KJUR.asn1.ASN1Object);
// == END   DERAbstractTime ==================================================

// == BEGIN DERAbstractStructured ============================================
/**
 * base class for ASN.1 DER structured class
 * @name KJUR.asn1.DERAbstractStructured
 * @class base class for ASN.1 DER structured class
 * @property {Array} asn1Array internal array of ASN1Object
 * @extends KJUR.asn1.ASN1Object
 * @description
 * @see KJUR.asn1.ASN1Object - superclass
 */
KJUR.asn1.DERAbstractStructured = function (params) {
    KJUR.asn1.DERAbstractString.superclass.constructor.call(this);
    var asn1Array = null;

    /**
     * set value by array of ASN1Object
     * @name setByASN1ObjectArray
     * @memberOf KJUR.asn1.DERAbstractStructured
     * @function
     * @param {array} asn1ObjectArray array of ASN1Object to set
     */
    this.setByASN1ObjectArray = function (asn1ObjectArray) {
        this.hTLV = null;
        this.isModified = true;
        this.asn1Array = asn1ObjectArray;
    };

    /**
     * append an ASN1Object to internal array
     * @name appendASN1Object
     * @memberOf KJUR.asn1.DERAbstractStructured
     * @function
     * @param {ASN1Object} asn1Object to add
     */
    this.appendASN1Object = function (asn1Object) {
        this.hTLV = null;
        this.isModified = true;
        this.asn1Array.push(asn1Object);
    };

    this.asn1Array = new Array();
    if (typeof params != "undefined") {
        if (typeof params['array'] != "undefined") {
            this.asn1Array = params['array'];
        }
    }
};
JSX.extend(KJUR.asn1.DERAbstractStructured, KJUR.asn1.ASN1Object);

// ********************************************************************
//  ASN.1 Object Classes
// ********************************************************************

// ********************************************************************
/**
 * class for ASN.1 DER Boolean
 * @name KJUR.asn1.DERBoolean
 * @class class for ASN.1 DER Boolean
 * @extends KJUR.asn1.ASN1Object
 * @description
 * @see KJUR.asn1.ASN1Object - superclass
 */
KJUR.asn1.DERBoolean = function () {
    KJUR.asn1.DERBoolean.superclass.constructor.call(this);
    this.hT = "01";
    this.hTLV = "0101ff";
};
JSX.extend(KJUR.asn1.DERBoolean, KJUR.asn1.ASN1Object);

// ********************************************************************
/**
 * class for ASN.1 DER Integer
 * @name KJUR.asn1.DERInteger
 * @class class for ASN.1 DER Integer
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>int - specify initial ASN.1 value(V) by integer value</li>
 * <li>bigint - specify initial ASN.1 value(V) by BigInteger object</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 */
KJUR.asn1.DERInteger = function (params) {
    KJUR.asn1.DERInteger.superclass.constructor.call(this);
    this.hT = "02";

    /**
     * set value by Tom Wu's BigInteger object
     * @name setByBigInteger
     * @memberOf KJUR.asn1.DERInteger
     * @function
     * @param {BigInteger} bigIntegerValue to set
     */
    this.setByBigInteger = function (bigIntegerValue) {
        this.hTLV = null;
        this.isModified = true;
        this.hV = KJUR.asn1.ASN1Util.bigIntToMinTwosComplementsHex(bigIntegerValue);
    };

    /**
     * set value by integer value
     * @name setByInteger
     * @memberOf KJUR.asn1.DERInteger
     * @function
     * @param {Integer} integer value to set
     */
    this.setByInteger = function (intValue) {
        var bi = new BigInteger(String(intValue), 10);
        this.setByBigInteger(bi);
    };

    /**
     * set value by integer value
     * @name setValueHex
     * @memberOf KJUR.asn1.DERInteger
     * @function
     * @param {String} hexadecimal string of integer value
     * @description
     * <br/>
     * NOTE: Value shall be represented by minimum octet length of
     * two's complement representation.
     */
    this.setValueHex = function (newHexString) {
        this.hV = newHexString;
    };

    this.getFreshValueHex = function () {
        return this.hV;
    };

    if (typeof params != "undefined") {
        if (typeof params['bigint'] != "undefined") {
            this.setByBigInteger(params['bigint']);
        } else if (typeof params['int'] != "undefined") {
            this.setByInteger(params['int']);
        } else if (typeof params['hex'] != "undefined") {
            this.setValueHex(params['hex']);
        }
    }
};
JSX.extend(KJUR.asn1.DERInteger, KJUR.asn1.ASN1Object);

// ********************************************************************
/**
 * class for ASN.1 DER encoded BitString primitive
 * @name KJUR.asn1.DERBitString
 * @class class for ASN.1 DER encoded BitString primitive
 * @extends KJUR.asn1.ASN1Object
 * @description 
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>bin - specify binary string (ex. '10111')</li>
 * <li>array - specify array of boolean (ex. [true,false,true,true])</li>
 * <li>hex - specify hexadecimal string of ASN.1 value(V) including unused bits</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 */
KJUR.asn1.DERBitString = function (params) {
    KJUR.asn1.DERBitString.superclass.constructor.call(this);
    this.hT = "03";

    /**
     * set ASN.1 value(V) by a hexadecimal string including unused bits
     * @name setHexValueIncludingUnusedBits
     * @memberOf KJUR.asn1.DERBitString
     * @function
     * @param {String} newHexStringIncludingUnusedBits
     */
    this.setHexValueIncludingUnusedBits = function (newHexStringIncludingUnusedBits) {
        this.hTLV = null;
        this.isModified = true;
        this.hV = newHexStringIncludingUnusedBits;
    };

    /**
     * set ASN.1 value(V) by unused bit and hexadecimal string of value
     * @name setUnusedBitsAndHexValue
     * @memberOf KJUR.asn1.DERBitString
     * @function
     * @param {Integer} unusedBits
     * @param {String} hValue
     */
    this.setUnusedBitsAndHexValue = function (unusedBits, hValue) {
        if (unusedBits < 0 || 7 < unusedBits) {
            throw "unused bits shall be from 0 to 7: u = " + unusedBits;
        }
        var hUnusedBits = "0" + unusedBits;
        this.hTLV = null;
        this.isModified = true;
        this.hV = hUnusedBits + hValue;
    };

    /**
     * set ASN.1 DER BitString by binary string
     * @name setByBinaryString
     * @memberOf KJUR.asn1.DERBitString
     * @function
     * @param {String} binaryString binary value string (i.e. '10111')
     * @description
     * Its unused bits will be calculated automatically by length of 
     * 'binaryValue'. <br/>
     * NOTE: Trailing zeros '0' will be ignored.
     */
    this.setByBinaryString = function (binaryString) {
        binaryString = binaryString.replace(/0+$/, '');
        var unusedBits = 8 - binaryString.length % 8;
        if (unusedBits == 8) unusedBits = 0;
        for (var i = 0; i <= unusedBits; i++) {
            binaryString += '0';
        }
        var h = '';
        for (var i = 0; i < binaryString.length - 1; i += 8) {
            var b = binaryString.substr(i, 8);
            var x = parseInt(b, 2).toString(16);
            if (x.length == 1) x = '0' + x;
            h += x;
        }
        this.hTLV = null;
        this.isModified = true;
        this.hV = '0' + unusedBits + h;
    };

    /**
     * set ASN.1 TLV value(V) by an array of boolean
     * @name setByBooleanArray
     * @memberOf KJUR.asn1.DERBitString
     * @function
     * @param {array} booleanArray array of boolean (ex. [true, false, true])
     * @description
     * NOTE: Trailing falses will be ignored.
     */
    this.setByBooleanArray = function (booleanArray) {
        var s = '';
        for (var i = 0; i < booleanArray.length; i++) {
            if (booleanArray[i] == true) {
                s += '1';
            } else {
                s += '0';
            }
        }
        this.setByBinaryString(s);
    };

    /**
     * generate an array of false with specified length
     * @name newFalseArray
     * @memberOf KJUR.asn1.DERBitString
     * @function
     * @param {Integer} nLength length of array to generate
     * @return {array} array of boolean faluse
     * @description
     * This static method may be useful to initialize boolean array.
     */
    this.newFalseArray = function (nLength) {
        var a = new Array(nLength);
        for (var i = 0; i < nLength; i++) {
            a[i] = false;
        }
        return a;
    };

    this.getFreshValueHex = function () {
        return this.hV;
    };

    if (typeof params != "undefined") {
        if (typeof params['hex'] != "undefined") {
            this.setHexValueIncludingUnusedBits(params['hex']);
        } else if (typeof params['bin'] != "undefined") {
            this.setByBinaryString(params['bin']);
        } else if (typeof params['array'] != "undefined") {
            this.setByBooleanArray(params['array']);
        }
    }
};
JSX.extend(KJUR.asn1.DERBitString, KJUR.asn1.ASN1Object);

// ********************************************************************
/**
 * class for ASN.1 DER OctetString
 * @name KJUR.asn1.DEROctetString
 * @class class for ASN.1 DER OctetString
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */
KJUR.asn1.DEROctetString = function (params) {
    KJUR.asn1.DEROctetString.superclass.constructor.call(this, params);
    this.hT = "04";
};
JSX.extend(KJUR.asn1.DEROctetString, KJUR.asn1.DERAbstractString);

// ********************************************************************
/**
 * class for ASN.1 DER Null
 * @name KJUR.asn1.DERNull
 * @class class for ASN.1 DER Null
 * @extends KJUR.asn1.ASN1Object
 * @description
 * @see KJUR.asn1.ASN1Object - superclass
 */
KJUR.asn1.DERNull = function () {
    KJUR.asn1.DERNull.superclass.constructor.call(this);
    this.hT = "05";
    this.hTLV = "0500";
};
JSX.extend(KJUR.asn1.DERNull, KJUR.asn1.ASN1Object);

// ********************************************************************
/**
 * class for ASN.1 DER ObjectIdentifier
 * @name KJUR.asn1.DERObjectIdentifier
 * @class class for ASN.1 DER ObjectIdentifier
 * @param {Array} params associative array of parameters (ex. {'oid': '2.5.4.5'})
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>oid - specify initial ASN.1 value(V) by a oid string (ex. 2.5.4.13)</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 */
KJUR.asn1.DERObjectIdentifier = function (params) {
    var itox = function itox(i) {
        var h = i.toString(16);
        if (h.length == 1) h = '0' + h;
        return h;
    };
    var roidtox = function roidtox(roid) {
        var h = '';
        var bi = new BigInteger(roid, 10);
        var b = bi.toString(2);
        var padLen = 7 - b.length % 7;
        if (padLen == 7) padLen = 0;
        var bPad = '';
        for (var i = 0; i < padLen; i++) {
            bPad += '0';
        }b = bPad + b;
        for (var i = 0; i < b.length - 1; i += 7) {
            var b8 = b.substr(i, 7);
            if (i != b.length - 7) b8 = '1' + b8;
            h += itox(parseInt(b8, 2));
        }
        return h;
    };

    KJUR.asn1.DERObjectIdentifier.superclass.constructor.call(this);
    this.hT = "06";

    /**
     * set value by a hexadecimal string
     * @name setValueHex
     * @memberOf KJUR.asn1.DERObjectIdentifier
     * @function
     * @param {String} newHexString hexadecimal value of OID bytes
     */
    this.setValueHex = function (newHexString) {
        this.hTLV = null;
        this.isModified = true;
        this.s = null;
        this.hV = newHexString;
    };

    /**
     * set value by a OID string
     * @name setValueOidString
     * @memberOf KJUR.asn1.DERObjectIdentifier
     * @function
     * @param {String} oidString OID string (ex. 2.5.4.13)
     */
    this.setValueOidString = function (oidString) {
        if (!oidString.match(/^[0-9.]+$/)) {
            throw "malformed oid string: " + oidString;
        }
        var h = '';
        var a = oidString.split('.');
        var i0 = parseInt(a[0]) * 40 + parseInt(a[1]);
        h += itox(i0);
        a.splice(0, 2);
        for (var i = 0; i < a.length; i++) {
            h += roidtox(a[i]);
        }
        this.hTLV = null;
        this.isModified = true;
        this.s = null;
        this.hV = h;
    };

    /**
     * set value by a OID name
     * @name setValueName
     * @memberOf KJUR.asn1.DERObjectIdentifier
     * @function
     * @param {String} oidName OID name (ex. 'serverAuth')
     * @since 1.0.1
     * @description
     * OID name shall be defined in 'KJUR.asn1.x509.OID.name2oidList'.
     * Otherwise raise error.
     */
    this.setValueName = function (oidName) {
        if (typeof KJUR.asn1.x509.OID.name2oidList[oidName] != "undefined") {
            var oid = KJUR.asn1.x509.OID.name2oidList[oidName];
            this.setValueOidString(oid);
        } else {
            throw "DERObjectIdentifier oidName undefined: " + oidName;
        }
    };

    this.getFreshValueHex = function () {
        return this.hV;
    };

    if (typeof params != "undefined") {
        if (typeof params['oid'] != "undefined") {
            this.setValueOidString(params['oid']);
        } else if (typeof params['hex'] != "undefined") {
            this.setValueHex(params['hex']);
        } else if (typeof params['name'] != "undefined") {
            this.setValueName(params['name']);
        }
    }
};
JSX.extend(KJUR.asn1.DERObjectIdentifier, KJUR.asn1.ASN1Object);

// ********************************************************************
/**
 * class for ASN.1 DER UTF8String
 * @name KJUR.asn1.DERUTF8String
 * @class class for ASN.1 DER UTF8String
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */
KJUR.asn1.DERUTF8String = function (params) {
    KJUR.asn1.DERUTF8String.superclass.constructor.call(this, params);
    this.hT = "0c";
};
JSX.extend(KJUR.asn1.DERUTF8String, KJUR.asn1.DERAbstractString);

// ********************************************************************
/**
 * class for ASN.1 DER NumericString
 * @name KJUR.asn1.DERNumericString
 * @class class for ASN.1 DER NumericString
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */
KJUR.asn1.DERNumericString = function (params) {
    KJUR.asn1.DERNumericString.superclass.constructor.call(this, params);
    this.hT = "12";
};
JSX.extend(KJUR.asn1.DERNumericString, KJUR.asn1.DERAbstractString);

// ********************************************************************
/**
 * class for ASN.1 DER PrintableString
 * @name KJUR.asn1.DERPrintableString
 * @class class for ASN.1 DER PrintableString
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */
KJUR.asn1.DERPrintableString = function (params) {
    KJUR.asn1.DERPrintableString.superclass.constructor.call(this, params);
    this.hT = "13";
};
JSX.extend(KJUR.asn1.DERPrintableString, KJUR.asn1.DERAbstractString);

// ********************************************************************
/**
 * class for ASN.1 DER TeletexString
 * @name KJUR.asn1.DERTeletexString
 * @class class for ASN.1 DER TeletexString
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */
KJUR.asn1.DERTeletexString = function (params) {
    KJUR.asn1.DERTeletexString.superclass.constructor.call(this, params);
    this.hT = "14";
};
JSX.extend(KJUR.asn1.DERTeletexString, KJUR.asn1.DERAbstractString);

// ********************************************************************
/**
 * class for ASN.1 DER IA5String
 * @name KJUR.asn1.DERIA5String
 * @class class for ASN.1 DER IA5String
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */
KJUR.asn1.DERIA5String = function (params) {
    KJUR.asn1.DERIA5String.superclass.constructor.call(this, params);
    this.hT = "16";
};
JSX.extend(KJUR.asn1.DERIA5String, KJUR.asn1.DERAbstractString);

// ********************************************************************
/**
 * class for ASN.1 DER UTCTime
 * @name KJUR.asn1.DERUTCTime
 * @class class for ASN.1 DER UTCTime
 * @param {Array} params associative array of parameters (ex. {'str': '130430235959Z'})
 * @extends KJUR.asn1.DERAbstractTime
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>str - specify initial ASN.1 value(V) by a string (ex.'130430235959Z')</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * <li>date - specify Date object.</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 * <h4>EXAMPLES</h4>
 * @example
 * var d1 = new KJUR.asn1.DERUTCTime();
 * d1.setString('130430125959Z');
 *
 * var d2 = new KJUR.asn1.DERUTCTime({'str': '130430125959Z'});
 *
 * var d3 = new KJUR.asn1.DERUTCTime({'date': new Date(Date.UTC(2015, 0, 31, 0, 0, 0, 0))});
 */
KJUR.asn1.DERUTCTime = function (params) {
    KJUR.asn1.DERUTCTime.superclass.constructor.call(this, params);
    this.hT = "17";

    /**
     * set value by a Date object
     * @name setByDate
     * @memberOf KJUR.asn1.DERUTCTime
     * @function
     * @param {Date} dateObject Date object to set ASN.1 value(V)
     */
    this.setByDate = function (dateObject) {
        this.hTLV = null;
        this.isModified = true;
        this.date = dateObject;
        this.s = this.formatDate(this.date, 'utc');
        this.hV = stohex(this.s);
    };

    if (typeof params != "undefined") {
        if (typeof params['str'] != "undefined") {
            this.setString(params['str']);
        } else if (typeof params['hex'] != "undefined") {
            this.setStringHex(params['hex']);
        } else if (typeof params['date'] != "undefined") {
            this.setByDate(params['date']);
        }
    }
};
JSX.extend(KJUR.asn1.DERUTCTime, KJUR.asn1.DERAbstractTime);

// ********************************************************************
/**
 * class for ASN.1 DER GeneralizedTime
 * @name KJUR.asn1.DERGeneralizedTime
 * @class class for ASN.1 DER GeneralizedTime
 * @param {Array} params associative array of parameters (ex. {'str': '20130430235959Z'})
 * @extends KJUR.asn1.DERAbstractTime
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>str - specify initial ASN.1 value(V) by a string (ex.'20130430235959Z')</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * <li>date - specify Date object.</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 */
KJUR.asn1.DERGeneralizedTime = function (params) {
    KJUR.asn1.DERGeneralizedTime.superclass.constructor.call(this, params);
    this.hT = "18";

    /**
     * set value by a Date object
     * @name setByDate
     * @memberOf KJUR.asn1.DERGeneralizedTime
     * @function
     * @param {Date} dateObject Date object to set ASN.1 value(V)
     * @example
     * When you specify UTC time, use 'Date.UTC' method like this:<br/>
     * var o = new DERUTCTime();
     * var date = new Date(Date.UTC(2015, 0, 31, 23, 59, 59, 0)); #2015JAN31 23:59:59
     * o.setByDate(date);
     */
    this.setByDate = function (dateObject) {
        this.hTLV = null;
        this.isModified = true;
        this.date = dateObject;
        this.s = this.formatDate(this.date, 'gen');
        this.hV = stohex(this.s);
    };

    if (typeof params != "undefined") {
        if (typeof params['str'] != "undefined") {
            this.setString(params['str']);
        } else if (typeof params['hex'] != "undefined") {
            this.setStringHex(params['hex']);
        } else if (typeof params['date'] != "undefined") {
            this.setByDate(params['date']);
        }
    }
};
JSX.extend(KJUR.asn1.DERGeneralizedTime, KJUR.asn1.DERAbstractTime);

// ********************************************************************
/**
 * class for ASN.1 DER Sequence
 * @name KJUR.asn1.DERSequence
 * @class class for ASN.1 DER Sequence
 * @extends KJUR.asn1.DERAbstractStructured
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>array - specify array of ASN1Object to set elements of content</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 */
KJUR.asn1.DERSequence = function (params) {
    KJUR.asn1.DERSequence.superclass.constructor.call(this, params);
    this.hT = "30";
    this.getFreshValueHex = function () {
        var h = '';
        for (var i = 0; i < this.asn1Array.length; i++) {
            var asn1Obj = this.asn1Array[i];
            h += asn1Obj.getEncodedHex();
        }
        this.hV = h;
        return this.hV;
    };
};
JSX.extend(KJUR.asn1.DERSequence, KJUR.asn1.DERAbstractStructured);

// ********************************************************************
/**
 * class for ASN.1 DER Set
 * @name KJUR.asn1.DERSet
 * @class class for ASN.1 DER Set
 * @extends KJUR.asn1.DERAbstractStructured
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>array - specify array of ASN1Object to set elements of content</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 */
KJUR.asn1.DERSet = function (params) {
    KJUR.asn1.DERSet.superclass.constructor.call(this, params);
    this.hT = "31";
    this.getFreshValueHex = function () {
        var a = new Array();
        for (var i = 0; i < this.asn1Array.length; i++) {
            var asn1Obj = this.asn1Array[i];
            a.push(asn1Obj.getEncodedHex());
        }
        a.sort();
        this.hV = a.join('');
        return this.hV;
    };
};
JSX.extend(KJUR.asn1.DERSet, KJUR.asn1.DERAbstractStructured);

// ********************************************************************
/**
 * class for ASN.1 DER TaggedObject
 * @name KJUR.asn1.DERTaggedObject
 * @class class for ASN.1 DER TaggedObject
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * Parameter 'tagNoNex' is ASN.1 tag(T) value for this object.
 * For example, if you find '[1]' tag in a ASN.1 dump, 
 * 'tagNoHex' will be 'a1'.
 * <br/>
 * As for optional argument 'params' for constructor, you can specify *ANY* of
 * following properties:
 * <ul>
 * <li>explicit - specify true if this is explicit tag otherwise false 
 *     (default is 'true').</li>
 * <li>tag - specify tag (default is 'a0' which means [0])</li>
 * <li>obj - specify ASN1Object which is tagged</li>
 * </ul>
 * @example
 * d1 = new KJUR.asn1.DERUTF8String({'str':'a'});
 * d2 = new KJUR.asn1.DERTaggedObject({'obj': d1});
 * hex = d2.getEncodedHex();
 */
KJUR.asn1.DERTaggedObject = function (params) {
    KJUR.asn1.DERTaggedObject.superclass.constructor.call(this);
    this.hT = "a0";
    this.hV = '';
    this.isExplicit = true;
    this.asn1Object = null;

    /**
     * set value by an ASN1Object
     * @name setString
     * @memberOf KJUR.asn1.DERTaggedObject
     * @function
     * @param {Boolean} isExplicitFlag flag for explicit/implicit tag
     * @param {Integer} tagNoHex hexadecimal string of ASN.1 tag
     * @param {ASN1Object} asn1Object ASN.1 to encapsulate
     */
    this.setASN1Object = function (isExplicitFlag, tagNoHex, asn1Object) {
        this.hT = tagNoHex;
        this.isExplicit = isExplicitFlag;
        this.asn1Object = asn1Object;
        if (this.isExplicit) {
            this.hV = this.asn1Object.getEncodedHex();
            this.hTLV = null;
            this.isModified = true;
        } else {
            this.hV = null;
            this.hTLV = asn1Object.getEncodedHex();
            this.hTLV = this.hTLV.replace(/^../, tagNoHex);
            this.isModified = false;
        }
    };

    this.getFreshValueHex = function () {
        return this.hV;
    };

    if (typeof params != "undefined") {
        if (typeof params['tag'] != "undefined") {
            this.hT = params['tag'];
        }
        if (typeof params['explicit'] != "undefined") {
            this.isExplicit = params['explicit'];
        }
        if (typeof params['obj'] != "undefined") {
            this.asn1Object = params['obj'];
            this.setASN1Object(this.isExplicit, this.hT, this.asn1Object);
        }
    }
};
JSX.extend(KJUR.asn1.DERTaggedObject, KJUR.asn1.ASN1Object);
// Hex JavaScript decoder
// Copyright (c) 2008-2013 Lapo Luchini <lapo@lapo.it>

// Permission to use, copy, modify, and/or distribute this software for any
// purpose with or without fee is hereby granted, provided that the above
// copyright notice and this permission notice appear in all copies.
// 
// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
// WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
// ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
// WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
// ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
// OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.

/*jshint browser: true, strict: true, immed: true, latedef: true, undef: true, regexdash: false */
(function (undefined) {
    "use strict";

    var Hex = {},
        decoder;

    Hex.decode = function (a) {
        var i;
        if (decoder === undefined) {
            var hex = "0123456789ABCDEF",
                ignore = " \f\n\r\t\xA0\u2028\u2029";
            decoder = [];
            for (i = 0; i < 16; ++i) {
                decoder[hex.charAt(i)] = i;
            }hex = hex.toLowerCase();
            for (i = 10; i < 16; ++i) {
                decoder[hex.charAt(i)] = i;
            }for (i = 0; i < ignore.length; ++i) {
                decoder[ignore.charAt(i)] = -1;
            }
        }
        var out = [],
            bits = 0,
            char_count = 0;
        for (i = 0; i < a.length; ++i) {
            var c = a.charAt(i);
            if (c == '=') break;
            c = decoder[c];
            if (c == -1) continue;
            if (c === undefined) throw 'Illegal character at offset ' + i;
            bits |= c;
            if (++char_count >= 2) {
                out[out.length] = bits;
                bits = 0;
                char_count = 0;
            } else {
                bits <<= 4;
            }
        }
        if (char_count) throw "Hex encoding incomplete: 4 bits missing";
        return out;
    };

    // export globals
    window.Hex = Hex;
})();
// Base64 JavaScript decoder
// Copyright (c) 2008-2013 Lapo Luchini <lapo@lapo.it>

// Permission to use, copy, modify, and/or distribute this software for any
// purpose with or without fee is hereby granted, provided that the above
// copyright notice and this permission notice appear in all copies.
// 
// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
// WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
// ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
// WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
// ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
// OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.

/*jshint browser: true, strict: true, immed: true, latedef: true, undef: true, regexdash: false */
(function (undefined) {
    "use strict";

    var Base64 = {},
        decoder;

    Base64.decode = function (a) {
        var i;
        if (decoder === undefined) {
            var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
                ignore = "= \f\n\r\t\xA0\u2028\u2029";
            decoder = [];
            for (i = 0; i < 64; ++i) {
                decoder[b64.charAt(i)] = i;
            }for (i = 0; i < ignore.length; ++i) {
                decoder[ignore.charAt(i)] = -1;
            }
        }
        var out = [];
        var bits = 0,
            char_count = 0;
        for (i = 0; i < a.length; ++i) {
            var c = a.charAt(i);
            if (c == '=') break;
            c = decoder[c];
            if (c == -1) continue;
            if (c === undefined) throw 'Illegal character at offset ' + i;
            bits |= c;
            if (++char_count >= 4) {
                out[out.length] = bits >> 16;
                out[out.length] = bits >> 8 & 0xFF;
                out[out.length] = bits & 0xFF;
                bits = 0;
                char_count = 0;
            } else {
                bits <<= 6;
            }
        }
        switch (char_count) {
            case 1:
                throw "Base64 encoding incomplete: at least 2 bits missing";
            case 2:
                out[out.length] = bits >> 10;
                break;
            case 3:
                out[out.length] = bits >> 16;
                out[out.length] = bits >> 8 & 0xFF;
                break;
        }
        return out;
    };

    Base64.re = /-----BEGIN [^-]+-----([A-Za-z0-9+\/=\s]+)-----END [^-]+-----|begin-base64[^\n]+\n([A-Za-z0-9+\/=\s]+)====/;
    Base64.unarmor = function (a) {
        var m = Base64.re.exec(a);
        if (m) {
            if (m[1]) a = m[1];else if (m[2]) a = m[2];else throw "RegExp out of sync";
        }
        return Base64.decode(a);
    };

    // export globals
    window.Base64 = Base64;
})();
// ASN.1 JavaScript decoder
// Copyright (c) 2008-2013 Lapo Luchini <lapo@lapo.it>

// Permission to use, copy, modify, and/or distribute this software for any
// purpose with or without fee is hereby granted, provided that the above
// copyright notice and this permission notice appear in all copies.
// 
// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
// WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
// ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
// WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
// ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
// OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.

/*jshint browser: true, strict: true, immed: true, latedef: true, undef: true, regexdash: false */
/*global oids */
(function (undefined) {
    "use strict";

    var hardLimit = 100,
        ellipsis = "\u2026",
        DOM = {
        tag: function tag(tagName, className) {
            var t = document.createElement(tagName);
            t.className = className;
            return t;
        },
        text: function text(str) {
            return document.createTextNode(str);
        }
    };

    function Stream(enc, pos) {
        if (enc instanceof Stream) {
            this.enc = enc.enc;
            this.pos = enc.pos;
        } else {
            this.enc = enc;
            this.pos = pos;
        }
    }
    Stream.prototype.get = function (pos) {
        if (pos === undefined) pos = this.pos++;
        if (pos >= this.enc.length) throw 'Requesting byte offset ' + pos + ' on a stream of length ' + this.enc.length;
        return this.enc[pos];
    };
    Stream.prototype.hexDigits = "0123456789ABCDEF";
    Stream.prototype.hexByte = function (b) {
        return this.hexDigits.charAt(b >> 4 & 0xF) + this.hexDigits.charAt(b & 0xF);
    };
    Stream.prototype.hexDump = function (start, end, raw) {
        var s = "";
        for (var i = start; i < end; ++i) {
            s += this.hexByte(this.get(i));
            if (raw !== true) switch (i & 0xF) {
                case 0x7:
                    s += "  ";
                    break;
                case 0xF:
                    s += "\n";
                    break;
                default:
                    s += " ";
            }
        }
        return s;
    };
    Stream.prototype.parseStringISO = function (start, end) {
        var s = "";
        for (var i = start; i < end; ++i) {
            s += String.fromCharCode(this.get(i));
        }return s;
    };
    Stream.prototype.parseStringUTF = function (start, end) {
        var s = "";
        for (var i = start; i < end;) {
            var c = this.get(i++);
            if (c < 128) s += String.fromCharCode(c);else if (c > 191 && c < 224) s += String.fromCharCode((c & 0x1F) << 6 | this.get(i++) & 0x3F);else s += String.fromCharCode((c & 0x0F) << 12 | (this.get(i++) & 0x3F) << 6 | this.get(i++) & 0x3F);
        }
        return s;
    };
    Stream.prototype.parseStringBMP = function (start, end) {
        var str = "";
        for (var i = start; i < end; i += 2) {
            var high_byte = this.get(i);
            var low_byte = this.get(i + 1);
            str += String.fromCharCode((high_byte << 8) + low_byte);
        }

        return str;
    };
    Stream.prototype.reTime = /^((?:1[89]|2\d)?\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/;
    Stream.prototype.parseTime = function (start, end) {
        var s = this.parseStringISO(start, end),
            m = this.reTime.exec(s);
        if (!m) return "Unrecognized time: " + s;
        s = m[1] + "-" + m[2] + "-" + m[3] + " " + m[4];
        if (m[5]) {
            s += ":" + m[5];
            if (m[6]) {
                s += ":" + m[6];
                if (m[7]) s += "." + m[7];
            }
        }
        if (m[8]) {
            s += " UTC";
            if (m[8] != 'Z') {
                s += m[8];
                if (m[9]) s += ":" + m[9];
            }
        }
        return s;
    };
    Stream.prototype.parseInteger = function (start, end) {
        //TODO support negative numbers
        var len = end - start;
        if (len > 4) {
            len <<= 3;
            var s = this.get(start);
            if (s === 0) len -= 8;else while (s < 128) {
                s <<= 1;
                --len;
            }
            return "(" + len + " bit)";
        }
        var n = 0;
        for (var i = start; i < end; ++i) {
            n = n << 8 | this.get(i);
        }return n;
    };
    Stream.prototype.parseBitString = function (start, end) {
        var unusedBit = this.get(start),
            lenBit = (end - start - 1 << 3) - unusedBit,
            s = "(" + lenBit + " bit)";
        if (lenBit <= 20) {
            var skip = unusedBit;
            s += " ";
            for (var i = end - 1; i > start; --i) {
                var b = this.get(i);
                for (var j = skip; j < 8; ++j) {
                    s += b >> j & 1 ? "1" : "0";
                }skip = 0;
            }
        }
        return s;
    };
    Stream.prototype.parseOctetString = function (start, end) {
        var len = end - start,
            s = "(" + len + " byte) ";
        if (len > hardLimit) end = start + hardLimit;
        for (var i = start; i < end; ++i) {
            s += this.hexByte(this.get(i));
        } //TODO: also try Latin1?
        if (len > hardLimit) s += ellipsis;
        return s;
    };
    Stream.prototype.parseOID = function (start, end) {
        var s = '',
            n = 0,
            bits = 0;
        for (var i = start; i < end; ++i) {
            var v = this.get(i);
            n = n << 7 | v & 0x7F;
            bits += 7;
            if (!(v & 0x80)) {
                // finished
                if (s === '') {
                    var m = n < 80 ? n < 40 ? 0 : 1 : 2;
                    s = m + "." + (n - m * 40);
                } else s += "." + (bits >= 31 ? "bigint" : n);
                n = bits = 0;
            }
        }
        return s;
    };

    function ASN1(stream, header, length, tag, sub) {
        this.stream = stream;
        this.header = header;
        this.length = length;
        this.tag = tag;
        this.sub = sub;
    }
    ASN1.prototype.typeName = function () {
        if (this.tag === undefined) return "unknown";
        var tagClass = this.tag >> 6,
            tagConstructed = this.tag >> 5 & 1,
            tagNumber = this.tag & 0x1F;
        switch (tagClass) {
            case 0:
                // universal
                switch (tagNumber) {
                    case 0x00:
                        return "EOC";
                    case 0x01:
                        return "BOOLEAN";
                    case 0x02:
                        return "INTEGER";
                    case 0x03:
                        return "BIT_STRING";
                    case 0x04:
                        return "OCTET_STRING";
                    case 0x05:
                        return "NULL";
                    case 0x06:
                        return "OBJECT_IDENTIFIER";
                    case 0x07:
                        return "ObjectDescriptor";
                    case 0x08:
                        return "EXTERNAL";
                    case 0x09:
                        return "REAL";
                    case 0x0A:
                        return "ENUMERATED";
                    case 0x0B:
                        return "EMBEDDED_PDV";
                    case 0x0C:
                        return "UTF8String";
                    case 0x10:
                        return "SEQUENCE";
                    case 0x11:
                        return "SET";
                    case 0x12:
                        return "NumericString";
                    case 0x13:
                        return "PrintableString"; // ASCII subset
                    case 0x14:
                        return "TeletexString"; // aka T61String
                    case 0x15:
                        return "VideotexString";
                    case 0x16:
                        return "IA5String"; // ASCII
                    case 0x17:
                        return "UTCTime";
                    case 0x18:
                        return "GeneralizedTime";
                    case 0x19:
                        return "GraphicString";
                    case 0x1A:
                        return "VisibleString"; // ASCII subset
                    case 0x1B:
                        return "GeneralString";
                    case 0x1C:
                        return "UniversalString";
                    case 0x1E:
                        return "BMPString";
                    default:
                        return "Universal_" + tagNumber.toString(16);
                }
            case 1:
                return "Application_" + tagNumber.toString(16);
            case 2:
                return "[" + tagNumber + "]"; // Context
            case 3:
                return "Private_" + tagNumber.toString(16);
        }
    };
    ASN1.prototype.reSeemsASCII = /^[ -~]+$/;
    ASN1.prototype.content = function () {
        if (this.tag === undefined) return null;
        var tagClass = this.tag >> 6,
            tagNumber = this.tag & 0x1F,
            content = this.posContent(),
            len = Math.abs(this.length);
        if (tagClass !== 0) {
            // universal
            if (this.sub !== null) return "(" + this.sub.length + " elem)";
            //TODO: TRY TO PARSE ASCII STRING
            var s = this.stream.parseStringISO(content, content + Math.min(len, hardLimit));
            if (this.reSeemsASCII.test(s)) return s.substring(0, 2 * hardLimit) + (s.length > 2 * hardLimit ? ellipsis : "");else return this.stream.parseOctetString(content, content + len);
        }
        switch (tagNumber) {
            case 0x01:
                // BOOLEAN
                return this.stream.get(content) === 0 ? "false" : "true";
            case 0x02:
                // INTEGER
                return this.stream.parseInteger(content, content + len);
            case 0x03:
                // BIT_STRING
                return this.sub ? "(" + this.sub.length + " elem)" : this.stream.parseBitString(content, content + len);
            case 0x04:
                // OCTET_STRING
                return this.sub ? "(" + this.sub.length + " elem)" : this.stream.parseOctetString(content, content + len);
            //case 0x05: // NULL
            case 0x06:
                // OBJECT_IDENTIFIER
                return this.stream.parseOID(content, content + len);
            //case 0x07: // ObjectDescriptor
            //case 0x08: // EXTERNAL
            //case 0x09: // REAL
            //case 0x0A: // ENUMERATED
            //case 0x0B: // EMBEDDED_PDV
            case 0x10: // SEQUENCE
            case 0x11:
                // SET
                return "(" + this.sub.length + " elem)";
            case 0x0C:
                // UTF8String
                return this.stream.parseStringUTF(content, content + len);
            case 0x12: // NumericString
            case 0x13: // PrintableString
            case 0x14: // TeletexString
            case 0x15: // VideotexString
            case 0x16: // IA5String
            //case 0x19: // GraphicString
            case 0x1A:
                // VisibleString
                //case 0x1B: // GeneralString
                //case 0x1C: // UniversalString
                return this.stream.parseStringISO(content, content + len);
            case 0x1E:
                // BMPString
                return this.stream.parseStringBMP(content, content + len);
            case 0x17: // UTCTime
            case 0x18:
                // GeneralizedTime
                return this.stream.parseTime(content, content + len);
        }
        return null;
    };
    ASN1.prototype.toString = function () {
        return this.typeName() + "@" + this.stream.pos + "[header:" + this.header + ",length:" + this.length + ",sub:" + (this.sub === null ? 'null' : this.sub.length) + "]";
    };
    ASN1.prototype.print = function (indent) {
        if (indent === undefined) indent = '';
        document.writeln(indent + this);
        if (this.sub !== null) {
            indent += '  ';
            for (var i = 0, max = this.sub.length; i < max; ++i) {
                this.sub[i].print(indent);
            }
        }
    };
    ASN1.prototype.toPrettyString = function (indent) {
        if (indent === undefined) indent = '';
        var s = indent + this.typeName() + " @" + this.stream.pos;
        if (this.length >= 0) s += "+";
        s += this.length;
        if (this.tag & 0x20) s += " (constructed)";else if ((this.tag == 0x03 || this.tag == 0x04) && this.sub !== null) s += " (encapsulates)";
        s += "\n";
        if (this.sub !== null) {
            indent += '  ';
            for (var i = 0, max = this.sub.length; i < max; ++i) {
                s += this.sub[i].toPrettyString(indent);
            }
        }
        return s;
    };
    ASN1.prototype.toDOM = function () {
        var node = DOM.tag("div", "node");
        node.asn1 = this;
        var head = DOM.tag("div", "head");
        var s = this.typeName().replace(/_/g, " ");
        head.innerHTML = s;
        var content = this.content();
        if (content !== null) {
            content = String(content).replace(/</g, "&lt;");
            var preview = DOM.tag("span", "preview");
            preview.appendChild(DOM.text(content));
            head.appendChild(preview);
        }
        node.appendChild(head);
        this.node = node;
        this.head = head;
        var value = DOM.tag("div", "value");
        s = "Offset: " + this.stream.pos + "<br/>";
        s += "Length: " + this.header + "+";
        if (this.length >= 0) s += this.length;else s += -this.length + " (undefined)";
        if (this.tag & 0x20) s += "<br/>(constructed)";else if ((this.tag == 0x03 || this.tag == 0x04) && this.sub !== null) s += "<br/>(encapsulates)";
        //TODO if (this.tag == 0x03) s += "Unused bits: "
        if (content !== null) {
            s += "<br/>Value:<br/><b>" + content + "</b>";
            if ((typeof oids === "undefined" ? "undefined" : typeof_default()(oids)) === 'object' && this.tag == 0x06) {
                var oid = oids[content];
                if (oid) {
                    if (oid.d) s += "<br/>" + oid.d;
                    if (oid.c) s += "<br/>" + oid.c;
                    if (oid.w) s += "<br/>(warning!)";
                }
            }
        }
        value.innerHTML = s;
        node.appendChild(value);
        var sub = DOM.tag("div", "sub");
        if (this.sub !== null) {
            for (var i = 0, max = this.sub.length; i < max; ++i) {
                sub.appendChild(this.sub[i].toDOM());
            }
        }
        node.appendChild(sub);
        head.onclick = function () {
            node.className = node.className == "node collapsed" ? "node" : "node collapsed";
        };
        return node;
    };
    ASN1.prototype.posStart = function () {
        return this.stream.pos;
    };
    ASN1.prototype.posContent = function () {
        return this.stream.pos + this.header;
    };
    ASN1.prototype.posEnd = function () {
        return this.stream.pos + this.header + Math.abs(this.length);
    };
    ASN1.prototype.fakeHover = function (current) {
        this.node.className += " hover";
        if (current) this.head.className += " hover";
    };
    ASN1.prototype.fakeOut = function (current) {
        var re = / ?hover/;
        this.node.className = this.node.className.replace(re, "");
        if (current) this.head.className = this.head.className.replace(re, "");
    };
    ASN1.prototype.toHexDOM_sub = function (node, className, stream, start, end) {
        if (start >= end) return;
        var sub = DOM.tag("span", className);
        sub.appendChild(DOM.text(stream.hexDump(start, end)));
        node.appendChild(sub);
    };
    ASN1.prototype.toHexDOM = function (root) {
        var node = DOM.tag("span", "hex");
        if (root === undefined) root = node;
        this.head.hexNode = node;
        this.head.onmouseover = function () {
            this.hexNode.className = "hexCurrent";
        };
        this.head.onmouseout = function () {
            this.hexNode.className = "hex";
        };
        node.asn1 = this;
        node.onmouseover = function () {
            var current = !root.selected;
            if (current) {
                root.selected = this.asn1;
                this.className = "hexCurrent";
            }
            this.asn1.fakeHover(current);
        };
        node.onmouseout = function () {
            var current = root.selected == this.asn1;
            this.asn1.fakeOut(current);
            if (current) {
                root.selected = null;
                this.className = "hex";
            }
        };
        this.toHexDOM_sub(node, "tag", this.stream, this.posStart(), this.posStart() + 1);
        this.toHexDOM_sub(node, this.length >= 0 ? "dlen" : "ulen", this.stream, this.posStart() + 1, this.posContent());
        if (this.sub === null) node.appendChild(DOM.text(this.stream.hexDump(this.posContent(), this.posEnd())));else if (this.sub.length > 0) {
            var first = this.sub[0];
            var last = this.sub[this.sub.length - 1];
            this.toHexDOM_sub(node, "intro", this.stream, this.posContent(), first.posStart());
            for (var i = 0, max = this.sub.length; i < max; ++i) {
                node.appendChild(this.sub[i].toHexDOM(root));
            }this.toHexDOM_sub(node, "outro", this.stream, last.posEnd(), this.posEnd());
        }
        return node;
    };
    ASN1.prototype.toHexString = function (root) {
        return this.stream.hexDump(this.posStart(), this.posEnd(), true);
    };
    ASN1.decodeLength = function (stream) {
        var buf = stream.get(),
            len = buf & 0x7F;
        if (len == buf) return len;
        if (len > 3) throw "Length over 24 bits not supported at position " + (stream.pos - 1);
        if (len === 0) return -1; // undefined
        buf = 0;
        for (var i = 0; i < len; ++i) {
            buf = buf << 8 | stream.get();
        }return buf;
    };
    ASN1.hasContent = function (tag, len, stream) {
        if (tag & 0x20) // constructed
            return true;
        if (tag < 0x03 || tag > 0x04) return false;
        var p = new Stream(stream);
        if (tag == 0x03) p.get(); // BitString unused bits, must be in [0, 7]
        var subTag = p.get();
        if (subTag >> 6 & 0x01) // not (universal or context)
            return false;
        try {
            var subLength = ASN1.decodeLength(p);
            return p.pos - stream.pos + subLength == len;
        } catch (exception) {
            return false;
        }
    };
    ASN1.decode = function (stream) {
        if (!(stream instanceof Stream)) stream = new Stream(stream, 0);
        var streamStart = new Stream(stream),
            tag = stream.get(),
            len = ASN1.decodeLength(stream),
            header = stream.pos - streamStart.pos,
            sub = null;
        if (ASN1.hasContent(tag, len, stream)) {
            // it has content, so we decode it
            var start = stream.pos;
            if (tag == 0x03) stream.get(); // skip BitString unused bits, must be in [0, 7]
            sub = [];
            if (len >= 0) {
                // definite length
                var end = start + len;
                while (stream.pos < end) {
                    sub[sub.length] = ASN1.decode(stream);
                }if (stream.pos != end) throw "Content size is not correct for container starting at offset " + start;
            } else {
                // undefined length
                try {
                    for (;;) {
                        var s = ASN1.decode(stream);
                        if (s.tag === 0) break;
                        sub[sub.length] = s;
                    }
                    len = start - stream.pos;
                } catch (e) {
                    throw "Exception while decoding undefined length content: " + e;
                }
            }
        } else stream.pos += len; // skip content
        return new ASN1(streamStart, header, len, tag, sub);
    };
    ASN1.test = function () {
        var test = [{ value: [0x27], expected: 0x27 }, { value: [0x81, 0xC9], expected: 0xC9 }, { value: [0x83, 0xFE, 0xDC, 0xBA], expected: 0xFEDCBA }];
        for (var i = 0, max = test.length; i < max; ++i) {
            var pos = 0,
                stream = new Stream(test[i].value, 0),
                res = ASN1.decodeLength(stream);
            if (res != test[i].expected) document.write("In test[" + i + "] expected " + test[i].expected + " got " + res + "\n");
        }
    };

    // export globals
    window.ASN1 = ASN1;
})();
/**
 * Retrieve the hexadecimal value (as a string) of the current ASN.1 element
 * @returns {string}
 * @public
 */
ASN1.prototype.getHexStringValue = function () {
    var hexString = this.toHexString();
    var offset = this.header * 2;
    var length = this.length * 2;
    return hexString.substr(offset, length);
};

/**
 * Method to parse a pem encoded string containing both a public or private key.
 * The method will translate the pem encoded string in a der encoded string and
 * will parse private key and public key parameters. This method accepts public key
 * in the rsaencryption pkcs #1 format (oid: 1.2.840.113549.1.1.1).
 *
 * @todo Check how many rsa formats use the same format of pkcs #1.
 *
 * The format is defined as:
 * PublicKeyInfo ::= SEQUENCE {
 *   algorithm       AlgorithmIdentifier,
 *   PublicKey       BIT STRING
 * }
 * Where AlgorithmIdentifier is:
 * AlgorithmIdentifier ::= SEQUENCE {
 *   algorithm       OBJECT IDENTIFIER,     the OID of the enc algorithm
 *   parameters      ANY DEFINED BY algorithm OPTIONAL (NULL for PKCS #1)
 * }
 * and PublicKey is a SEQUENCE encapsulated in a BIT STRING
 * RSAPublicKey ::= SEQUENCE {
 *   modulus           INTEGER,  -- n
 *   publicExponent    INTEGER   -- e
 * }
 * it's possible to examine the structure of the keys obtained from openssl using
 * an asn.1 dumper as the one used here to parse the components: //lapo.it/asn1js/
 * @argument {string} pem the pem encoded string, can include the BEGIN/END header/footer
 * @private
 */
RSAKey.prototype.parseKey = function (pem) {
    try {
        var modulus = 0;
        var public_exponent = 0;
        var reHex = /^\s*(?:[0-9A-Fa-f][0-9A-Fa-f]\s*)+$/;
        var der = reHex.test(pem) ? Hex.decode(pem) : Base64.unarmor(pem);
        var asn1 = ASN1.decode(der);

        //Fixes a bug with OpenSSL 1.0+ private keys
        if (asn1.sub.length === 3) {
            asn1 = asn1.sub[2].sub[0];
        }
        if (asn1.sub.length === 9) {

            // Parse the private key.
            modulus = asn1.sub[1].getHexStringValue(); //bigint
            this.n = parseBigInt(modulus, 16);

            public_exponent = asn1.sub[2].getHexStringValue(); //int
            this.e = parseInt(public_exponent, 16);

            var private_exponent = asn1.sub[3].getHexStringValue(); //bigint
            this.d = parseBigInt(private_exponent, 16);

            var prime1 = asn1.sub[4].getHexStringValue(); //bigint
            this.p = parseBigInt(prime1, 16);

            var prime2 = asn1.sub[5].getHexStringValue(); //bigint
            this.q = parseBigInt(prime2, 16);

            var exponent1 = asn1.sub[6].getHexStringValue(); //bigint
            this.dmp1 = parseBigInt(exponent1, 16);

            var exponent2 = asn1.sub[7].getHexStringValue(); //bigint
            this.dmq1 = parseBigInt(exponent2, 16);

            var coefficient = asn1.sub[8].getHexStringValue(); //bigint
            this.coeff = parseBigInt(coefficient, 16);
        } else if (asn1.sub.length === 2) {

            // Parse the public key.
            var bit_string = asn1.sub[1];
            var sequence = bit_string.sub[0];

            modulus = sequence.sub[0].getHexStringValue();
            this.n = parseBigInt(modulus, 16);
            public_exponent = sequence.sub[1].getHexStringValue();
            this.e = parseInt(public_exponent, 16);
        } else {
            return false;
        }
        return true;
    } catch (ex) {
        return false;
    }
};

/**
 * Translate rsa parameters in a hex encoded string representing the rsa key.
 *
 * The translation follow the ASN.1 notation :
 * RSAPrivateKey ::= SEQUENCE {
 *   version           Version,
 *   modulus           INTEGER,  -- n
 *   publicExponent    INTEGER,  -- e
 *   privateExponent   INTEGER,  -- d
 *   prime1            INTEGER,  -- p
 *   prime2            INTEGER,  -- q
 *   exponent1         INTEGER,  -- d mod (p1)
 *   exponent2         INTEGER,  -- d mod (q-1)
 *   coefficient       INTEGER,  -- (inverse of q) mod p
 * }
 * @returns {string}  DER Encoded String representing the rsa private key
 * @private
 */
RSAKey.prototype.getPrivateBaseKey = function () {
    var options = {
        'array': [new KJUR.asn1.DERInteger({ 'int': 0 }), new KJUR.asn1.DERInteger({ 'bigint': this.n }), new KJUR.asn1.DERInteger({ 'int': this.e }), new KJUR.asn1.DERInteger({ 'bigint': this.d }), new KJUR.asn1.DERInteger({ 'bigint': this.p }), new KJUR.asn1.DERInteger({ 'bigint': this.q }), new KJUR.asn1.DERInteger({ 'bigint': this.dmp1 }), new KJUR.asn1.DERInteger({ 'bigint': this.dmq1 }), new KJUR.asn1.DERInteger({ 'bigint': this.coeff })]
    };
    var seq = new KJUR.asn1.DERSequence(options);
    return seq.getEncodedHex();
};

/**
 * base64 (pem) encoded version of the DER encoded representation
 * @returns {string} pem encoded representation without header and footer
 * @public
 */
RSAKey.prototype.getPrivateBaseKeyB64 = function () {
    return hex2b64(this.getPrivateBaseKey());
};

/**
 * Translate rsa parameters in a hex encoded string representing the rsa public key.
 * The representation follow the ASN.1 notation :
 * PublicKeyInfo ::= SEQUENCE {
 *   algorithm       AlgorithmIdentifier,
 *   PublicKey       BIT STRING
 * }
 * Where AlgorithmIdentifier is:
 * AlgorithmIdentifier ::= SEQUENCE {
 *   algorithm       OBJECT IDENTIFIER,     the OID of the enc algorithm
 *   parameters      ANY DEFINED BY algorithm OPTIONAL (NULL for PKCS #1)
 * }
 * and PublicKey is a SEQUENCE encapsulated in a BIT STRING
 * RSAPublicKey ::= SEQUENCE {
 *   modulus           INTEGER,  -- n
 *   publicExponent    INTEGER   -- e
 * }
 * @returns {string} DER Encoded String representing the rsa public key
 * @private
 */
RSAKey.prototype.getPublicBaseKey = function () {
    var options = {
        'array': [new KJUR.asn1.DERObjectIdentifier({ 'oid': '1.2.840.113549.1.1.1' }), //RSA Encryption pkcs #1 oid
        new KJUR.asn1.DERNull()]
    };
    var first_sequence = new KJUR.asn1.DERSequence(options);

    options = {
        'array': [new KJUR.asn1.DERInteger({ 'bigint': this.n }), new KJUR.asn1.DERInteger({ 'int': this.e })]
    };
    var second_sequence = new KJUR.asn1.DERSequence(options);

    options = {
        'hex': '00' + second_sequence.getEncodedHex()
    };
    var bit_string = new KJUR.asn1.DERBitString(options);

    options = {
        'array': [first_sequence, bit_string]
    };
    var seq = new KJUR.asn1.DERSequence(options);
    return seq.getEncodedHex();
};

/**
 * base64 (pem) encoded version of the DER encoded representation
 * @returns {string} pem encoded representation without header and footer
 * @public
 */
RSAKey.prototype.getPublicBaseKeyB64 = function () {
    return hex2b64(this.getPublicBaseKey());
};

/**
 * wrap the string in block of width chars. The default value for rsa keys is 64
 * characters.
 * @param {string} str the pem encoded string without header and footer
 * @param {Number} [width=64] - the length the string has to be wrapped at
 * @returns {string}
 * @private
 */
RSAKey.prototype.wordwrap = function (str, width) {
    width = width || 64;
    if (!str) {
        return str;
    }
    var regex = '(.{1,' + width + '})( +|$\n?)|(.{1,' + width + '})';
    return str.match(RegExp(regex, 'g')).join('\n');
};

/**
 * Retrieve the pem encoded private key
 * @returns {string} the pem encoded private key with header/footer
 * @public
 */
RSAKey.prototype.getPrivateKey = function () {
    var key = "-----BEGIN RSA PRIVATE KEY-----\n";
    key += this.wordwrap(this.getPrivateBaseKeyB64()) + "\n";
    key += "-----END RSA PRIVATE KEY-----";
    return key;
};

/**
 * Retrieve the pem encoded public key
 * @returns {string} the pem encoded public key with header/footer
 * @public
 */
RSAKey.prototype.getPublicKey = function () {
    var key = "-----BEGIN PUBLIC KEY-----\n";
    key += this.wordwrap(this.getPublicBaseKeyB64()) + "\n";
    key += "-----END PUBLIC KEY-----";
    return key;
};

/**
 * Check if the object contains the necessary parameters to populate the rsa modulus
 * and public exponent parameters.
 * @param {Object} [obj={}] - An object that may contain the two public key
 * parameters
 * @returns {boolean} true if the object contains both the modulus and the public exponent
 * properties (n and e)
 * @todo check for types of n and e. N should be a parseable bigInt object, E should
 * be a parseable integer number
 * @private
 */
RSAKey.prototype.hasPublicKeyProperty = function (obj) {
    obj = obj || {};
    return obj.hasOwnProperty('n') && obj.hasOwnProperty('e');
};

/**
 * Check if the object contains ALL the parameters of an RSA key.
 * @param {Object} [obj={}] - An object that may contain nine rsa key
 * parameters
 * @returns {boolean} true if the object contains all the parameters needed
 * @todo check for types of the parameters all the parameters but the public exponent
 * should be parseable bigint objects, the public exponent should be a parseable integer number
 * @private
 */
RSAKey.prototype.hasPrivateKeyProperty = function (obj) {
    obj = obj || {};
    return obj.hasOwnProperty('n') && obj.hasOwnProperty('e') && obj.hasOwnProperty('d') && obj.hasOwnProperty('p') && obj.hasOwnProperty('q') && obj.hasOwnProperty('dmp1') && obj.hasOwnProperty('dmq1') && obj.hasOwnProperty('coeff');
};

/**
 * Parse the properties of obj in the current rsa object. Obj should AT LEAST
 * include the modulus and public exponent (n, e) parameters.
 * @param {Object} obj - the object containing rsa parameters
 * @private
 */
RSAKey.prototype.parsePropertiesFrom = function (obj) {
    this.n = obj.n;
    this.e = obj.e;

    if (obj.hasOwnProperty('d')) {
        this.d = obj.d;
        this.p = obj.p;
        this.q = obj.q;
        this.dmp1 = obj.dmp1;
        this.dmq1 = obj.dmq1;
        this.coeff = obj.coeff;
    }
};

/**
 * Create a new JSEncryptRSAKey that extends Tom Wu's RSA key object.
 * This object is just a decorator for parsing the key parameter
 * @param {string|Object} key - The key in string format, or an object containing
 * the parameters needed to build a RSAKey object.
 * @constructor
 */
var JSEncryptRSAKey = function JSEncryptRSAKey(key) {
    // Call the super constructor.
    RSAKey.call(this);
    // If a key key was provided.
    if (key) {
        // If this is a string...
        if (typeof key === 'string') {
            this.parseKey(key);
        } else if (this.hasPrivateKeyProperty(key) || this.hasPublicKeyProperty(key)) {
            // Set the values for the key.
            this.parsePropertiesFrom(key);
        }
    }
};

// Derive from RSAKey.
JSEncryptRSAKey.prototype = new RSAKey();

// Reset the contructor.
JSEncryptRSAKey.prototype.constructor = JSEncryptRSAKey;

/**
 *
 * @param {Object} [options = {}] - An object to customize JSEncrypt behaviour
 * possible parameters are:
 * - default_key_size        {number}  default: 1024 the key size in bit
 * - default_public_exponent {string}  default: '010001' the hexadecimal representation of the public exponent
 * - log                     {boolean} default: false whether log warn/error or not
 * @constructor
 */
var JSEncrypt = function JSEncrypt(options) {
    options = options || {};
    this.default_key_size = parseInt(options.default_key_size) || 1024;
    this.default_public_exponent = options.default_public_exponent || '010001'; //65537 default openssl public exponent for rsa key type
    this.log = options.log || false;
    // The private and public key.
    this.key = null;
};

/**
 * Method to set the rsa key parameter (one method is enough to set both the public
 * and the private key, since the private key contains the public key paramenters)
 * Log a warning if logs are enabled
 * @param {Object|string} key the pem encoded string or an object (with or without header/footer)
 * @public
 */
JSEncrypt.prototype.setKey = function (key) {
    if (this.log && this.key) {
        console.warn('A key was already set, overriding existing.');
    }
    this.key = new JSEncryptRSAKey(key);
};

/**
 * Proxy method for setKey, for api compatibility
 * @see setKey
 * @public
 */
JSEncrypt.prototype.setPrivateKey = function (privkey) {
    // Create the key.
    this.setKey(privkey);
};

/**
 * Proxy method for setKey, for api compatibility
 * @see setKey
 * @public
 */
JSEncrypt.prototype.setPublicKey = function (pubkey) {
    // Sets the public key.
    this.setKey(pubkey);
};

/**
 * Proxy method for RSAKey object's decrypt, decrypt the string using the private
 * components of the rsa key object. Note that if the object was not set will be created
 * on the fly (by the getKey method) using the parameters passed in the JSEncrypt constructor
 * @param {string} string base64 encoded crypted string to decrypt
 * @return {string} the decrypted string
 * @public
 */
JSEncrypt.prototype.decrypt = function (string) {
    // Return the decrypted string.
    try {
        return this.getKey().decrypt(b64tohex(string));
    } catch (ex) {
        return false;
    }
};

/**
 * Proxy method for RSAKey object's encrypt, encrypt the string using the public
 * components of the rsa key object. Note that if the object was not set will be created
 * on the fly (by the getKey method) using the parameters passed in the JSEncrypt constructor
 * @param {string} string the string to encrypt
 * @return {string} the encrypted string encoded in base64
 * @public
 */
JSEncrypt.prototype.encrypt = function (string) {
    // Return the encrypted string.
    try {
        return hex2b64(this.getKey().encrypt(string));
    } catch (ex) {
        return false;
    }
};

/**
 * Getter for the current JSEncryptRSAKey object. If it doesn't exists a new object
 * will be created and returned
 * @param {callback} [cb] the callback to be called if we want the key to be generated
 * in an async fashion
 * @returns {JSEncryptRSAKey} the JSEncryptRSAKey object
 * @public
 */
JSEncrypt.prototype.getKey = function (cb) {
    // Only create new if it does not exist.
    if (!this.key) {
        // Get a new private key.
        this.key = new JSEncryptRSAKey();
        if (cb && {}.toString.call(cb) === '[object Function]') {
            this.key.generateAsync(this.default_key_size, this.default_public_exponent, cb);
            return;
        }
        // Generate the key.
        this.key.generate(this.default_key_size, this.default_public_exponent);
    }
    return this.key;
};

/**
 * Returns the pem encoded representation of the private key
 * If the key doesn't exists a new key will be created
 * @returns {string} pem encoded representation of the private key WITH header and footer
 * @public
 */
JSEncrypt.prototype.getPrivateKey = function () {
    // Return the private representation of this key.
    return this.getKey().getPrivateKey();
};

/**
 * Returns the pem encoded representation of the private key
 * If the key doesn't exists a new key will be created
 * @returns {string} pem encoded representation of the private key WITHOUT header and footer
 * @public
 */
JSEncrypt.prototype.getPrivateKeyB64 = function () {
    // Return the private representation of this key.
    return this.getKey().getPrivateBaseKeyB64();
};

/**
 * Returns the pem encoded representation of the public key
 * If the key doesn't exists a new key will be created
 * @returns {string} pem encoded representation of the public key WITH header and footer
 * @public
 */
JSEncrypt.prototype.getPublicKey = function () {
    // Return the private representation of this key.
    return this.getKey().getPublicKey();
};

/**
 * Returns the pem encoded representation of the public key
 * If the key doesn't exists a new key will be created
 * @returns {string} pem encoded representation of the public key WITHOUT header and footer
 * @public
 */
JSEncrypt.prototype.getPublicKeyB64 = function () {
    // Return the private representation of this key.
    return this.getKey().getPublicBaseKeyB64();
};

JSEncrypt.version = '2.3.1';
/* harmony default export */ var jsencrypt = (JSEncrypt);
// CONCATENATED MODULE: ./src/store/Rsa.js




var Rsa_Rsa = function () {
    function Rsa() {
        classCallCheck_default()(this, Rsa);

        this.jsencrypt = new jsencrypt();
        // 设置公钥
        this.jsencrypt.setPublicKey("-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDq04c6My441Gj0UFKgrqUhAUg+kQZeUeWSPlAU9fr4HBPDldAeqzx1UR92KJHuQh/zs1HOamE2dgX9z/2oXcJaqoRIA/FXysx+z2YlJkSk8XQLcQ8EBOkp//MZrixam7lCYpNOjadQBb2Ot0U/Ky+jF2p+Ie8gSZ7/u+Wnr5grywIDAQAB-----END PUBLIC KEY-----");
    }

    createClass_default()(Rsa, [{
        key: "encode",
        value: function encode(str, confuse) {
            var timestamp = new Date().getTime();
            var enStr = timestamp ? timestamp + "|" + str : str;
            var enCode = this.jsencrypt.encrypt(enStr);
            enCode = encodeURIComponent(enCode); // rsa+uri编码
            return encodeURIComponent(enCode);
        }
    }]);

    return Rsa;
}();

/* harmony default export */ var store_Rsa = (Rsa_Rsa);
// CONCATENATED MODULE: ./src/store/ultile.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PASSPORT_HOST; });
/* unused harmony export STORE_HOST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GMMOBILE_HOST; });
/* unused harmony export PLATFORM_HOST */
/* unused harmony export ACHIEVEMENT_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APP_ID; });
/* unused harmony export CURRENCY */
/* unused harmony export convertParamToString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ultile_post; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ultile_getJSON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ultile_get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getHrefParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return loadConverstData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return encryption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getGameId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getFbParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getLineParam; });
/* unused harmony export getShareContent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAllParamsFromHref; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getHrefParamObj; });




var PASSPORT_HOST = "//passport.gm99.com/";
var STORE_HOST = "//mstore.gm99.com/";
var GMMOBILE_HOST = "//m.gm99.com/";
var PLATFORM_HOST = "";
var ACHIEVEMENT_ID = 9999;
var APP_ID = 2377606282463331;
var CURRENCY = "TWD";
var SUCCESS_RESULT_CODE = 1;

var rsa = new store_Rsa();

var convertParamToString = function convertParamToString(params) {
  var str = "?";
  var paramArray = [];
  for (var key in params) {
    var param = key + "=" + params[key];
    paramArray.push(param);
  }
  paramArray.push("callback");
  if (paramArray.length > 0) {
    return paramArray.join("&");
  }
  return "";
};

var ultile_post = function post(action, params) {
  return new promise_default.a(function (resolve, reject) {
    axios_default.a.post(action, params).then(function (response) {
      var res = response.data;
      if (SUCCESS_RESULT_CODE != res.result) {
        var errmsg = res && res.msg && res.msg.replace(/\[\-\d*\]/, "") || "";
        resolve({
          errmsg: errmsg,
          data: [],
          res: response
        });
      } else {
        resolve({
          errmsg: "",
          data: res.data,
          res: res
        });
      }
    }).catch(function (error) {
      console.log(error);
    });
  });
};

var ultile_getJSON = function getJSON(action, params) {
  return new promise_default.a(function (resolve, reject) {
    var paramStr = convertParamToString(params || {});
    jsonp_default()(action, {
      prefix: "jsonpCallback",
      param: paramStr
    }, function (err, response) {
      if (err || SUCCESS_RESULT_CODE != response.result) {
        var errmsg = response && response.msg && response.msg.replace(/\[\-\d*\]/, "");
        resolve({
          errmsg: errmsg,
          data: [],
          res: response
        });
      } else {
        resolve({
          errmsg: "",
          data: response.data,
          res: response
        });
      }
    });
  });
};

var ultile_get = function get(action, params) {
  return new promise_default.a(function (resolve) {
    axios_default.a.get(action, {
      params: params
    }).then(function (response) {
      resolve(response);
    }).catch(function (e) {
      console.log(e);
    });
  });
};

var getHrefParam = function getHrefParam(paramName, newHref) {
  var href = newHref || window.location.search.substr(1);
  var reg = new RegExp("(^|&)" + paramName + "=([^&]*)(&|$)");
  var matchResult = href.match(reg);
  var param = matchResult ? decodeURI(matchResult[2]) : "";
  return param;
};

var loadConverstData = function loadConverstData(loadData, map) {
  var result = {};
  for (var key in map) {
    var mapKey = map[key];
    var val = loadData[mapKey] || "";
    result[key] = val;
  }
  return result;
};

var encryption = function encryption(text) {
  //todo encryption the text
  return rsa.encode(text);
};

var getGameId = function getGameId() {
  return getHrefParam("game_id") || getHrefParam("gameid");
};
var getFbParam = function getFbParam(config) {
  var action = "//m.gm99.com/h5/page/get_share_content";
  return ultile_getShareContent(config, action);
};

var getLineParam = function getLineParam(config) {
  var action = "//m.gm99.com/h5/page/get_line_content";
  return ultile_getShareContent(config, action);
};

var ultile_getShareContent = function getShareContent(config, action) {
  return new promise_default.a(function (resolve, reject) {
    ultile_post(action, {
      achievementId: config.achievementId,
      appId: APP_ID,
      gameId: getGameId(),
      serverId: config.serverId,
      fbid: config.fbid || "",
      loginAccount: config.name,
      timestamp: new Date().getTime(),
      roleId: config.roleId,
      roleName: config.roleName,
      devicePlate: "pc",
      pic: ""
    }).then(function (_ref) {
      var errmsg = _ref.errmsg,
          data = _ref.data;

      if (errmsg) {
        resolve({
          errmsg: errmsg
        });
      } else {
        resolve({
          title: data.TITLE || "",
          description: data.DESCRIPTION || "",
          img: data.THUMB || "",
          link: data.LINK,
          token: data.TOKEN,
          errmsg: ""
        });
      }
    });
  });
};

var getAllParamsFromHref = function getAllParamsFromHref(isAdd) {
  var res = window.location.search;
  return res.length > 0 ? isAdd ? "&" + res.substr(1) : res.substr(1) : "";
};

var getHrefParamObj = function getHrefParamObj() {
  var paramsStr = window.location.search.substr(1) || window.location.hash.replace(/^#\/\??/, "").replace(/(\?)|(%3F)/g, "&").replace(/%3D/g, "=");
  var res = {};
  var paramsArr = [];
  if (paramsStr.indexOf("&") >= 0) {
    paramsArr = paramsStr.split("&");
  } else if (paramsStr) {
    paramsArr = [paramsStr];
  }

  paramsArr.map(function (item) {
    var result = item.split("=");
    res[result[0]] = result[1];
  });

  return res;
};

/***/ }),

/***/ "YAvk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZCHt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bus */
/* unused harmony export CURRENCY */
/* unused harmony export isAndroid */
/* unused harmony export isIOS */
/* unused harmony export isWinPhone */
/* unused harmony export isIpad */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentDay; });
/* unused harmony export generateFbHref */
/* unused harmony export horizontalScreen */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isFBApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getLclStorageItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setLclStorageItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCookie; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");


var bus = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]();
// export const SUCEESSS_POPUP = "successPop";
// export const FAIL_GIFT_POPUP = "failGiftPop";
// export const FAIL_CHECK_POPUP = "failCheckPop";
var userAgent = window.navigator.userAgent;
var ua = userAgent.toLowerCase();
var CURRENCY = "TWD";

var isAndroid = function isAndroid() {
  return ua.indexOf("android") > -1;
};
var isIOS = function isIOS() {
  // return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
  return ua.indexOf("iphone") > -1;
};
var isWinPhone = function isWinPhone() {
  return !!navigator.userAgent.match(/Windows Phone/i);
};
var isIpad = function isIpad() {
  return ua.indexOf("iPad") > -1;
};
var isPhone = function isPhone() {
  return isAndroid() || isIOS() || isWinPhone() || isIpad();
};

var getCurrentDay = function getCurrentDay() {
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  month = month > 9 ? month : "0" + month;
  var day = date.getDate();
  day = day > 9 ? day : "0" + day;
  return year + "/" + month + "/" + day;
};

var generateFbHref = function generateFbHref(gameId) {
  return "https://mfbapps.gm99.com/fb_share_resource/get_ingame_resource/game/" + gameId + "/achievement/9999/";
};

var horizontalScreen = function horizontalScreen() {
  return (/90/.test(window.orientation)
  );
};

var isFBApp = function isFBApp() {
  var ua = navigator.userAgent || navigator.vendor || window.opera;
  return ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1;
};

var getLclStorageItem = function getLclStorageItem(name) {
  var res = null;
  if ("undefined" != typeof window.localStorage) {
    res = JSON.parse(window.localStorage.getItem(name));
    return res;
  }
  return res;
};
var setLclStorageItem = function setLclStorageItem(name, val) {
  if (window.localStorage) {
    return window.localStorage.setItem(name, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
  }
};
var setCookie = function setCookie(name, value, time) {
  var foreverTime = new Date();
  foreverTime.setFullYear(foreverTime.getFullYear() + 3000);
  document.cookie = name + "=" + value + ";domain=gm99.com;expires=" + (time || foreverTime.toGMTString());
};
var getCookie = function getCookie(name) {
  var arr,
      reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
};

/***/ }),

/***/ "akf/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export validateEmpty */
/* unused harmony export validateValueFormat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loginValidate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return registValidate; });
var validateEmpty = function validateEmpty(txt, fieldName) {
    var result = {
        dirty: false,
        msg: ""
    };
    if ("" === txt) {
        result.dirty = true;
        result.msg = fieldName + "不能為空";
    }
    return result;
};

var validateValueFormat = function validateValueFormat(txt, fieldName) {
    var result = {
        dirty: false,
        msg: ""
    };
    if (/\#/.test(txt)) {
        result.dirty = true;
        result.msg = fieldName + "不能包含特殊字符#";
    }
    return result;
};

var validateUserName = function validateUserName(currentUser, name) {
    if (currentUser.name == name) {
        return {
            dirty: true,
            msg: "您正在切換同一個賬號哦"
        };
    }
    return {
        dirty: false,
        msg: ""
    };
};

var loginValidate = function loginValidate(account, user) {

    var userNameValidateRes = validateEmpty(account.uname, "用戶名");
    var passwordValidateRes = validateEmpty(account.password, "密碼");
    var switchSameAccountRes = validateUserName(user.user, account.uname);
    var userNameFromatRes = validateValueFormat(account.uname, "用戶名");
    if (account.is_change && switchSameAccountRes.dirty) {
        return switchSameAccountRes;
    }
    if (userNameValidateRes.dirty) {
        userNameValidateRes.msg = "6-16位字元，區分大小寫";
        return userNameValidateRes;
    }
    if (userNameFromatRes.dirty) {
        userNameFromatRes.msg = "用戶名6-16位字元，區分大小寫";
        return userNameFromatRes;
    }
    if (passwordValidateRes.dirty) {
        passwordValidateRes.msg = "密碼6-16個字元，不能與帳號相同";
        return passwordValidateRes;
    }
    return {
        dirty: false,
        msg: ""
    };
};

var registValidate = function registValidate(account) {
    var userNameValidateRes = validateEmpty(account.uname, "用戶名");
    var passwordValidateRes = validateEmpty(account.password, "密碼");
    var repasswordValidateRes = validateEmpty(account.repassword, "確認密碼");
    var userNameFromatRes = validateValueFormat(account.uname, "用戶名");
    if (userNameValidateRes.dirty) {
        userNameValidateRes.msg = "6-16位字元，區分大小寫";
        return userNameValidateRes;
    }
    if (userNameFromatRes.dirty) {
        userNameFromatRes.msg = "6-16位字元，區分大小寫";
        return userNameFromatRes;
    }
    if (passwordValidateRes.dirty) {
        passwordValidateRes.msg = "密碼6-16個字元，不能與帳號相同";
        return passwordValidateRes;
    }
    if (repasswordValidateRes.dirty) {
        repasswordValidateRes.msg = "6-16個字元，不能與帳號相同";
        return repasswordValidateRes;
    }
    if (account.password != account.repassword) {
        repasswordValidateRes.dirty = true;
        repasswordValidateRes.msg = "兩次輸入不一致，請重新確認密碼哦！";
    }
    return {
        dirty: false,
        msg: ""
    };
};

/***/ }),

/***/ "ep7n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gRuC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kBHO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCOUNT_LOGIN; });
/* unused harmony export ACCOUNT_REGIST */
/* unused harmony export SWITCH_ACCOUNT */
/* unused harmony export LOGIN_ACCOUNT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MESSAG_REGIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MESSAG_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MESSAG_SWITCH; });
/* unused harmony export LOGIN_SUCCESS */
/* unused harmony export REGIST_SUCCESS */
/* unused harmony export POP_HITORY */
/* unused harmony export SWITCH_URL */
/* unused harmony export LOAD_USER_INFO */
/* unused harmony export GAME_ID */
/* unused harmony export MOBILE_LOGIN_PAGE_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MOBILE_GAME_PAGE_URL; });
/* unused harmony export desktopUrl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_ultile__ = __webpack_require__("VtGx");

var ACCOUNT_LOGIN = "login";
var ACCOUNT_REGIST = "regist";
var SWITCH_ACCOUNT = 1;
var LOGIN_ACCOUNT = 0;

var MESSAG_REGIST = "messageRegist";
var MESSAG_LOGIN = "messageLogin";
var MESSAG_SWITCH = "messageSwitch";
var LOGIN_SUCCESS = "logonSuccess";
var REGIST_SUCCESS = "registSuccess";
var POP_HITORY = "popHistory";
var SWITCH_URL = "switchUrl";
var LOAD_USER_INFO = "loadUserInfo";
// export const MOBILE_LOGIN_PAGE_URL = "//m.gm99.com/h5Game/h5_game_page/mobile";
// export const MOBILE_GAME_PAGE_URL = "//m.gm99.com/h5Game/h5_game_page/gamepage";
var anylyzeParam = "&cid=" + (Object(__WEBPACK_IMPORTED_MODULE_0__store_ultile__["i" /* getHrefParam */])("cid") || "") + "&scid=" + (Object(__WEBPACK_IMPORTED_MODULE_0__store_ultile__["i" /* getHrefParam */])("scid") || "") + "&ad_id=" + (Object(__WEBPACK_IMPORTED_MODULE_0__store_ultile__["i" /* getHrefParam */])("ad_id") || "") + "&link_id" + (Object(__WEBPACK_IMPORTED_MODULE_0__store_ultile__["i" /* getHrefParam */])("link_id") || "") + "&uri=" + (Object(__WEBPACK_IMPORTED_MODULE_0__store_ultile__["i" /* getHrefParam */])("uri") || "") + "&channel=" + (Object(__WEBPACK_IMPORTED_MODULE_0__store_ultile__["i" /* getHrefParam */])("channel") || "") + "&sub_channel=" + (Object(__WEBPACK_IMPORTED_MODULE_0__store_ultile__["i" /* getHrefParam */])("sub_channel") || "") + "&sub_id=" + (Object(__WEBPACK_IMPORTED_MODULE_0__store_ultile__["i" /* getHrefParam */])("sub_id") || "") + "&subid=" + (Object(__WEBPACK_IMPORTED_MODULE_0__store_ultile__["i" /* getHrefParam */])("subid") || "") + "&pid=" + (Object(__WEBPACK_IMPORTED_MODULE_0__store_ultile__["i" /* getHrefParam */])("pid") || "") + "&app_id=" + (Object(__WEBPACK_IMPORTED_MODULE_0__store_ultile__["i" /* getHrefParam */])("app_id") || "") + "&fb_source=" + (Object(__WEBPACK_IMPORTED_MODULE_0__store_ultile__["i" /* getHrefParam */])("fb_source") || "") + "&auth_uid=" + (Object(__WEBPACK_IMPORTED_MODULE_0__store_ultile__["i" /* getHrefParam */])("auth_uid") || "") + "&register=" + (Object(__WEBPACK_IMPORTED_MODULE_0__store_ultile__["i" /* getHrefParam */])("register") || "") + "&forward=" + (Object(__WEBPACK_IMPORTED_MODULE_0__store_ultile__["i" /* getHrefParam */])("forward") || "");

var GAME_ID = Object(__WEBPACK_IMPORTED_MODULE_0__store_ultile__["h" /* getGameId */])();
var MOBILE_LOGIN_PAGE_URL = ( false ? "http://mlocal.gm99.com/html/mobile.html" : "//m.gm99.com/h5/page/mobile") + "?game_id=" + GAME_ID + anylyzeParam;
var MOBILE_GAME_PAGE_URL = ( false ? "http://mlocal.gm99.com/html/gamePage.html" : "//m.gm99.com/h5/page/gamepage") + "?game_id=" + GAME_ID + anylyzeParam;
var desktopUrl = "//m.gm99.com/desktop.php";

/***/ }),

/***/ "lV9K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return judgeIsNewUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__("2aIq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);



var prevAction = "init";
var staticEventLists = [];
var sendImmediate = false;
var immediateSendEvent = ["login_fail"];

var judgeIsNewUser = function judgeIsNewUser(id) {
  if (!id) {
    return true;
  }
  var firstPlayObj = JSON.parse(window.localStorage.getItem("firstPlayObj") || "{}");
  var playerInfo = firstPlayObj[id];
  var firstTime = Date.now();
  if (playerInfo) {
    firstTime = playerInfo.firstPlayTime;
  }
  var date = new Date(firstTime);
  var now = Date.now();
  var playTime = Math.floor((now - date.getTime()) / (60 * 60 * 1000));
  var isNew = playTime < 48 ? true : false;
  return isNew;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {},
  actions: {
    gaStatistics: function gaStatistics(_ref, _ref2) {
      var rootState = _ref.rootState;
      var eventName = _ref2.eventName,
          _ref2$data = _ref2.data,
          data = _ref2$data === undefined ? {} : _ref2$data;

      console.log("\u6253\u70B9" + eventName);
      console.log(data);
      var isNewUser = judgeIsNewUser(rootState.user.user.id);
      var gadata = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
        event: eventName,
        is_new: isNewUser,
        prev: prevAction,
        time: window.now_time || new Date().getTime(),
        userName: rootState.user.user.name
      }, data);
      staticEventLists.push(gadata);
      if (eventName === "click_close_window") {
        sendImmediate = true;
      }
      if (immediateSendEvent.indexOf(eventName) !== -1) {
        sendImmediate = true;
      }
      if (sendImmediate) {
        // 重置队列推入的打点归属
        staticEventLists = staticEventLists.map(function (item) {
          item.userName = rootState.user.user.name;
          item.is_new = isNewUser;
          return item;
        });
        if (immediateSendEvent.indexOf(eventName) !== -1) {
          sendImmediate = false;
        }
        if (window.dataLayer) {
          staticEventLists = staticEventLists.filter(function (item) {
            return !item.isSend;
          });
          var length = staticEventLists.length;
          if (!length) {
            return;
          }
          for (var i = 0; i < length; i++) {
            var item = staticEventLists[i];
            var isSend = item.isSend;
            if (isSend) {
              continue;
            }
            window.dataLayer.push(item);
            item.isSend = true;
          }
        }
      }
      if (eventName === "login_success") {
        sendImmediate = true;
      }

      prevAction = eventName;
    },
    gaStatisticsCommon: function gaStatisticsCommon(_ref3, _ref4) {
      var eventName = _ref4.eventName,
          _ref4$data = _ref4.data,
          data = _ref4$data === undefined ? {} : _ref4$data;

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref3);

      window.dataLayer.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
        event: eventName
      }, data));
    },
    setIsFirstPlay: function setIsFirstPlay(_ref5, val) {
      var rootState = _ref5.rootState;

      var firstPlayObj = JSON.parse(window.localStorage.getItem("firstPlayObj") || "{}");
      if (!val) {
        val = false;
      }
      if (firstPlayObj[rootState.user.user.id]) {
        val = judgeIsNewUser();
      }
      // 根据isFirst区别设置firstTime
      var tmpFirstTime = val ? Date.now() : Date.now() - 48 * 60 * 60 * 1000;
      firstPlayObj.prev = rootState.user.user.id;
      firstPlayObj[rootState.user.user.id] = {
        isFirst: val,
        firstPlayTime: firstPlayObj[rootState.user.user.id] && firstPlayObj[rootState.user.user.id].firstPlayTime || tmpFirstTime
      };
      this.isFirstPlay = val;
      window.localStorage.setItem("firstPlayObj", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(firstPlayObj));
    }
  }
});

/***/ }),

/***/ "uK6g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/symbol.js
var symbol = __webpack_require__("5QVw");
var symbol_default = /*#__PURE__*/__webpack_require__.n(symbol);

// EXTERNAL MODULE: ./src/store/user.js
var user = __webpack_require__("wMq3");

// EXTERNAL MODULE: ./src/utile/constRegist.js
var constRegist = __webpack_require__("kBHO");

// EXTERNAL MODULE: ./src/utile/device.js
var device = __webpack_require__("FSl1");

// EXTERNAL MODULE: ./src/store/validator.js
var validator = __webpack_require__("akf/");

// EXTERNAL MODULE: ./src/store/ultile.js + 2 modules
var ultile = __webpack_require__("VtGx");

// EXTERNAL MODULE: ./src/utile/fb.js
var fb = __webpack_require__("Rmiw");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Account.vue





var _extends2;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var ACCOUNT_TYPE = {
  switchAccount: symbol_default()(),
  loginAccount: symbol_default()(),
  registerAccount: symbol_default()()
};

/* harmony default export */ var Account = ({
  name: "accountView", //登录注册功能
  data: function data() {
    return {
      showLogin: !(Object(ultile["i" /* getHrefParam */])("register") === "1"), //控制显示登录还是注册
      userNameLog: "",
      passwordLog: "",
      verificationLog: "",
      userName: "",
      password: "",
      confirmPassword: "",
      verification: "",
      verificationSrcLog: "",
      verificationSrcReg: "",
      postError: false,
      postErrorTips: "",
      isLoginAccount: this.loginType == ACCOUNT_TYPE.loginAccount,
      isSwitchAccount: this.loginType == ACCOUNT_TYPE.switchAccount,
      showForgetBtn: false,
      canClick: true,
      forgetLink: Object(device["d" /* isPhone */])() ? "//service.gm99.com/#/password_reset" : "//service.gm99.com/center?type=password"
    };
  },

  props: ["loginType", "show", "accoutOpsType"],
  computed: extends_default()({
    showVerificationLog: function showVerificationLog() {
      return user["f" /* default */].state.loginCkcodeStatus;
    },
    showVerificationReg: function showVerificationReg() {
      return user["f" /* default */].state.registCkcodeStatus;
    }
  }, Object(vuex_esm["c" /* mapGetters */])(["pageInfo"])),
  created: function created() {
    this.updateLoginVerificationCode();
  },

  watch: {
    show: function show(_show) {
      if (_show) {
        // 当展示的时候，初始化 是登录框还是注册框
        // 判断是否史登录类型，还是注册类型
        if (this.accoutOpsType == constRegist["a" /* ACCOUNT_LOGIN */]) {
          this.updateLoginVerificationCode();
        } else {
          this.updateRegistVerificationCode();
        }
      }
      if (this.userNameLog) {
        this.validataUserNameLog("pt_login");
      }
    },
    loginType: function loginType(newV, oldV) {
      this.isSwitchAccount = newV === ACCOUNT_TYPE.switchAccount;
      this.isLoginAccount = newV === ACCOUNT_TYPE.loginAccount;
      this.showLogin = newV !== ACCOUNT_TYPE.registerAccount;
    }
  },
  mounted: function mounted() {
    if (window.addEventListener) {
      window.addEventListener("message", this.messageHandler.bind(this), false);
    } else {
      window.attachEvent("message", this.messageHandler.bind(this));
    }
  },

  methods: extends_default()((_extends2 = {
    close: function close() {
      this.showLogin = true;
      this.$emit("hideAccountPopup");
    },
    showError: function showError(errmsg) {
      this.postErrorTips = errmsg;
    },
    switchToLogin: function switchToLogin() {
      this.showLogin = true;
      this.updateLoginVerificationCode();
      this.gaStatistics({
        eventName: "page_action",
        data: { action_name: "点击切换至账号登录界面" }
      });
    },
    switchToRegist: function switchToRegist() {
      this.showLogin = false;
      this.updateRegistVerificationCode();
      this.gaStatistics({
        eventName: "page_action",
        data: {
          action_name: "点击切换至账号注册界面"
        }
      });
    },
    updateLoginVerificationCode: function updateLoginVerificationCode() {
      var src = "//passport.gm99.com/verify_image?rnd=" + Math.random();
      this.verificationSrcLog = src;
    },
    updateRegistVerificationCode: function updateRegistVerificationCode() {
      var src = "//passport.gm99.com/verify_image?rnd=" + Math.random();
      this.verificationSrcReg = src;
    },
    validataUserNameLog: function validataUserNameLog(type) {
      if (/\#/.test(this.userNameLog)) {
        this.loginFail("用戶名6-16位字元，區分大小寫", "pt_login");
        return new promise_default.a(function (resolve) {
          resolve();
        });
      } else {
        return this.$store.dispatch(user["e" /* VERIFICATION_STATE */], this.userNameLog);
      }
    },
    validataUserNameReg: function validataUserNameReg() {
      if (/\#/.test(this.userName)) {
        this.registFail("用戶名6-16位字元，區分大小寫");
        return new promise_default.a(function (resolve) {
          resolve();
        });
      } else {
        return this.$store.dispatch(user["e" /* VERIFICATION_STATE */], this.userName);
      }
    }
  }, defineProperty_default()(_extends2, constRegist["c" /* MESSAG_REGIST */], function () {
    this.showLogin = false;
  }), defineProperty_default()(_extends2, constRegist["b" /* MESSAG_LOGIN */], function () {
    this.showLogin = true;
  }), defineProperty_default()(_extends2, constRegist["d" /* MESSAG_SWITCH */], function () {
    this.showLogin = true;
  }), defineProperty_default()(_extends2, "messageHandler", function messageHandler(evt) {
    var ev = evt || event;
    var action = ev.data.action;
    if (!!action && !!this[action]) {
      this[action]();
    }
  }), defineProperty_default()(_extends2, "doTouristLogin", function doTouristLogin() {
    var _this = this;

    if (!this.canClick) {
      return;
    }
    this.canClick = false;
    this.gaStatistics({
      eventName: "login_type",
      data: { login_type: "mv" }
    });
    Object(fb["e" /* getFingerprint */])().then(function (res) {
      return _this.touristLogin({
        loginId: res
      });
    }, function (res) {
      _this.loginFail(res, "mv");
    }).then(function () {
      _this.loginSucc("mv");
    }, function (res) {
      _this.loginFail(res, "mv");
    });
  }), defineProperty_default()(_extends2, "doFbLogin", function doFbLogin() {
    var _this2 = this;

    if (!this.canClick) {
      return;
    }
    this.canClick = false;

    Object(fb["a" /* fbSdkGetState */])().then(function (res) {
      if (res.status === "connected") {
        _this2.$store.dispatch(user["a" /* FB_LOGIN */], {
          accessToken: res.authResponse.accessToken
        }).then(function () {
          _this2.loginSucc("fb");
        }, _this2.fbLoginFail);
      } else {
        Object(fb["b" /* fbSdkLogin */])().then(function (response) {
          if (response.status === "connected") {
            _this2.canClick = true;
            _this2.doFbLogin();
          } else {
            _this2.fbLoginFail();
          }
        });
      }
    });

    this.gaStatistics({
      eventName: "login_type",
      data: { login_type: "fb" }
    });
  }), defineProperty_default()(_extends2, "fbLoginFail", function fbLoginFail(res) {
    var realmsg = res && res.errmsg || "登錄失敗";
    // 登录失败，显示失败信息
    this.loginFail(realmsg, "fb");
    this.canClick = true;
  }), defineProperty_default()(_extends2, "setAccountErrorState", function setAccountErrorState() {
    var _this3 = this;

    this.postError = true;
    setTimeout(function () {
      _this3.postError = false;
    }, 3000);
  }), defineProperty_default()(_extends2, "loginSucc", function loginSucc(type) {
    this.showLogin = true;
    this.close();
    this[user["b" /* GET_USER_INFO */]]({ isCheck: false, loginType: type });
    this.canClick = true;
    this.gaStatistics({
      eventName: "login_success",
      data: {
        login_type: type
      }
    });
  }), defineProperty_default()(_extends2, "loginFail", function loginFail(errmsg, type) {
    this.showLogin = true;
    this.canClick = true;
    this.$emit("loginFail", errmsg);
    this.setAccountErrorState();
    this.showError(errmsg);
    this.gaStatistics({
      eventName: "login_fail",
      data: {
        login_type: type,
        msg: errmsg
      }
    });
  }), defineProperty_default()(_extends2, "registFail", function registFail(errmsg) {
    this.showLogin = false;
    this.$emit("registFail", errmsg);
    this.setAccountErrorState();
    this.showError(errmsg);
    this.gaStatistics({
      eventName: "login_fail",
      data: {
        login_type: "pt_register",
        msg: errmsg
      }
    });
  }), defineProperty_default()(_extends2, "doLogin", function doLogin(loginSuccess, errMessage) {
    this.gaStatistics({
      eventName: "login_type",
      data: { login_type: "pt_login" }
    });
    var account = this.getLoginAccount();
    return this.$store.dispatch(user["c" /* LOGIN */], account);
  }), defineProperty_default()(_extends2, "getLoginAccount", function getLoginAccount() {
    return {
      uname: this.userNameLog,
      password: this.passwordLog,
      remember: true,
      forward: Object(ultile["i" /* getHrefParam */])("forward") || encodeURIComponent(window.location.href.replace(/mlocal./, "m.")),
      ckcode: this.verificationLog,
      is_change: this.isSwitchAccount ? 1 : 0
    };
  }), defineProperty_default()(_extends2, "onLoginFinish", function onLoginFinish(_ref) {
    var loginResult = _ref.loginResult,
        errmsg = _ref.errmsg;

    if (loginResult) {
      this.showLogin = true;
      this.close();
      this[user["b" /* GET_USER_INFO */]]({ isCheck: false, loginType: "pt_login" });
      this.gaStatistics({
        eventName: "login_success",
        data: {
          login_type: "pt_login"
        }
      });
    } else {
      // 登录失败，显示失败信息
      this.loginFail(errmsg, "pt_login");
      if ("密碼錯誤" == errmsg) {
        this.showForgetBtn = true;
      }
    }
    this.verificationLog = "";
    this.updateLoginVerificationCode();
    this.canClick = true;
  }), defineProperty_default()(_extends2, "login", function login() {
    if (this.postError) {
      return;
    }
    if (this.canClick) {
      var account = this.getLoginAccount();
      var validateRes = Object(validator["a" /* loginValidate */])(account, this.$store.state.user);
      if (validateRes.dirty) {
        this.loginFail(validateRes.msg, "pt_login");
        return;
      }
      this.canClick = false;
      this.validataUserNameLog("pt_login").then(this.doLogin.bind(this)).then(this.onLoginFinish.bind(this));
    }
  }), defineProperty_default()(_extends2, "getRegistAccount", function getRegistAccount() {
    return {
      uname: this.userName,
      password: this.password,
      repassword: this.confirmPassword,
      forward: Object(ultile["i" /* getHrefParam */])("forward") || encodeURIComponent(window.location.href.replace(/mlocal./, "m.")),
      ckcode: this.verification
    };
  }), defineProperty_default()(_extends2, "doRegist", function doRegist() {
    this.gaStatistics({
      eventName: "login_type",
      data: { login_type: "pt_register" }
    });

    var account = this.getRegistAccount();
    return this.$store.dispatch(user["d" /* REGIST */], account);
  }), defineProperty_default()(_extends2, "onRegistFinish", function onRegistFinish(_ref2) {
    var regestResult = _ref2.regestResult,
        errmsg = _ref2.errmsg,
        forward = _ref2.forward;

    if (regestResult) {
      this.showLogin = true;
      this.close();
      this[user["b" /* GET_USER_INFO */]]({ isCheck: false, loginType: "pt_register" });
      this.gaStatistics({
        eventName: "login_success",
        data: {
          login_type: "pt_register"
        }
      });
    } else {
      this.registFail(errmsg);
    }
    this.updateRegistVerificationCode();
    this.canClick = true;
  }), defineProperty_default()(_extends2, "regist", function regist() {
    if (this.postError) {
      return;
    }
    if (this.canClick) {
      var account = this.getRegistAccount();
      var validateRes = Object(validator["b" /* registValidate */])(account);
      if (validateRes.dirty) {
        this.registFail(validateRes.msg);
        return;
      }
      this.canClick = false;
      this.validataUserNameReg().then(this.doRegist.bind(this)).then(this.onRegistFinish.bind(this));
    }
  }), defineProperty_default()(_extends2, "userActionMark", function userActionMark(actionName) {
    this.gaStatistics({
      eventName: "page_action",
      data: {
        action_name: actionName
      }
    });
  }), _extends2), Object(vuex_esm["b" /* mapActions */])([user["b" /* GET_USER_INFO */], "touristLogin", "gaStatistics"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-380a15fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Account.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-container"},[_c('div',{staticClass:"account-bg",on:{"click":_vm.close}}),_vm._v(" "),_c('div',{staticClass:"account-form-wrapper j-account-form-wrapper"},[_c('transition',{attrs:{"name":"tipsfade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.postError),expression:"postError"}],staticClass:"err-tips"},[_c('div',{staticClass:"wrapper"},[_c('i',{staticClass:"tips-icon"}),_vm._v(" "),_c('p',{staticClass:"tips-text"},[_vm._v(_vm._s(_vm.postErrorTips))])])])]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSwitchAccount),expression:"isSwitchAccount"}],staticClass:"closeBtn",on:{"click":_vm.close}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLogin),expression:"showLogin"}],staticClass:"login-container"},[_c('label',{staticClass:"account-editor-label",attrs:{"for":"userName-log"}},[_c('i',{staticClass:"editor-icon editor-user-icon"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userNameLog),expression:"userNameLog"}],staticClass:"account-editor",attrs:{"type":"text","placeholder":"請輸入帳號","id":"userName-log"},domProps:{"value":(_vm.userNameLog)},on:{"change":function($event){return _vm.validataUserNameLog('pt_login')},"blur":function($event){return _vm.userActionMark('点击账号输入框')},"input":function($event){if($event.target.composing){ return; }_vm.userNameLog=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"account-editor-label password-editor-label",attrs:{"for":"password-log"}},[_c('label',{staticClass:"editor-icon editor-password-icon",attrs:{"for":"password-log"}}),_vm._v(" "),_c('i',{staticClass:"forget-icon",on:{"click":function($event){_vm.showForgetBtn = true}}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showForgetBtn),expression:"showForgetBtn"}],staticClass:"forget-btn",attrs:{"target":"blank","href":_vm.forgetLink}},[_vm._v("忘記密碼")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.passwordLog),expression:"passwordLog"}],staticClass:"account-editor",attrs:{"type":"password","placeholder":"請輸入密碼","id":"password-log"},domProps:{"value":(_vm.passwordLog)},on:{"focus":function($event){_vm.showForgetBtn = false},"blur":function($event){return _vm.userActionMark('点击密码输入框')},"input":function($event){if($event.target.composing){ return; }_vm.passwordLog=$event.target.value}}})],1),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVerificationLog),expression:"showVerificationLog"}],staticClass:"account-editor-label verfication-label",attrs:{"for":"verification-Code-log"}},[_c('i',{staticClass:"editor-icon editor-verification-icon"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.verificationLog),expression:"verificationLog"}],staticClass:"account-editor",attrs:{"type":"text","placeholder":"請輸入驗證碼","id":"verification-Code-log"},domProps:{"value":(_vm.verificationLog)},on:{"blur":function($event){return _vm.userActionMark('点击验证码输入框')},"input":function($event){if($event.target.composing){ return; }_vm.verificationLog=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"verification-code",attrs:{"src":_vm.verificationSrcLog},on:{"click":_vm.updateLoginVerificationCode}})]),_vm._v(" "),_c('button',{staticClass:"submitBtn",attrs:{"type":"button"},on:{"click":_vm.login}},[_vm._v("登入")]),_vm._v(" "),_c('p',{staticClass:"loginTips"},[_vm._v("\n          沒有帳號？馬上\n          "),_c('a',{staticClass:"switchLoginBtn",on:{"click":_vm.switchToRegist}},[_vm._v("免費註冊")])]),_vm._v(" "),_c('div',{staticClass:"orLine"}),_vm._v(" "),_c('a',{staticClass:"fbLoginBtn",attrs:{"href":"javascript:;"},on:{"click":_vm.doFbLogin}}),_vm._v(" "),(_vm.pageInfo.tourist)?_c('button',{staticClass:"touristLoginBtn",attrs:{"type":"button"},on:{"click":_vm.doTouristLogin}}):_vm._e()])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showLogin),expression:"!showLogin"}],staticClass:"register-container"},[_c('form',[_c('label',{staticClass:"account-editor-label",attrs:{"for":"userName"}},[_c('i',{staticClass:"editor-icon editor-user-icon"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userName),expression:"userName"}],staticClass:"account-editor",attrs:{"type":"text","placeholder":"請輸入帳號","id":"userName"},domProps:{"value":(_vm.userName)},on:{"change":_vm.validataUserNameReg,"blur":function($event){return _vm.userActionMark('点击注册账号输入框')},"input":function($event){if($event.target.composing){ return; }_vm.userName=$event.target.value}}})]),_vm._v(" "),_c('label',{staticClass:"account-editor-label",attrs:{"for":"password"}},[_c('i',{staticClass:"editor-icon editor-password-icon"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"account-editor",attrs:{"type":"password","placeholder":"請輸入密碼","id":"password"},domProps:{"value":(_vm.password)},on:{"blur":function($event){return _vm.userActionMark('点击注册密码输入框')},"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('label',{staticClass:"account-editor-label",attrs:{"for":"confirm-password"}},[_c('i',{staticClass:"editor-icon editor-password-icon"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmPassword),expression:"confirmPassword"}],staticClass:"account-editor",attrs:{"type":"password","placeholder":"再次輸入密碼","id":"confirm-password"},domProps:{"value":(_vm.confirmPassword)},on:{"blur":function($event){return _vm.userActionMark('点击注册密码二次输入框')},"input":function($event){if($event.target.composing){ return; }_vm.confirmPassword=$event.target.value}}})]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVerificationReg),expression:"showVerificationReg"}],staticClass:"account-editor-label",attrs:{"for":"verification-Code"}},[_c('i',{staticClass:"editor-icon editor-verification-icon"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.verification),expression:"verification"}],staticClass:"account-editor",attrs:{"type":"text","placeholder":"請輸入驗證碼","id":"verification-Code"},domProps:{"value":(_vm.verification)},on:{"blur":function($event){return _vm.userActionMark('点击注册验证码输入框')},"input":function($event){if($event.target.composing){ return; }_vm.verification=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"verification-code",attrs:{"src":_vm.verificationSrcReg},on:{"click":_vm.updateRegistVerificationCode}})]),_vm._v(" "),_c('div',{staticClass:"items-contianer"},[_c('div',{staticClass:"checkbox checked"}),_vm._v(" "),_c('p',[_vm._v("\n              我同意\n              "),_c('a',{staticClass:"items",attrs:{"target":"_blank","href":"https://msupport.gm99.com/About/termsofuse"}},[_vm._v("G妹遊戲服務條款")]),_vm._v("和\n              "),_c('a',{staticClass:"items",attrs:{"target":"_blank","href":"https://msupport.gm99.com/About/privacypolicy"}},[_vm._v("隱私條款")])])]),_vm._v(" "),_c('button',{staticClass:"submitBtn",attrs:{"type":"button"},on:{"click":_vm.regist}},[_vm._v("註冊")]),_vm._v(" "),_c('p',{staticClass:"loginTips"},[_vm._v("\n            已有帳號？\n            "),_c('a',{staticClass:"switchLoginBtn",on:{"click":_vm.switchToLogin}},[_vm._v("立即登入")])])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Account = (esExports);
// CONCATENATED MODULE: ./src/components/Account.vue
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return ACCOUNT_TYPE; });
function injectStyle (ssrContext) {
  __webpack_require__("NWIX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Account,
  components_Account,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Account = __webpack_exports__["b"] = (Component.exports);


/***/ }),

/***/ "wMq3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_USER_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REGIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return VERIFICATION_STATE; });
/* unused harmony export LOAD_QRCODE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FB_LOGIN; });
/* unused harmony export GET_FB_INFO */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__("2aIq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ultile__ = __webpack_require__("VtGx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validator__ = __webpack_require__("akf/");





var _mutations, _actions;



var UPDATE_USER = "updateUserInfo";
var GET_USER_INFO = "getUserInfo";
var LOGIN = "login";
var REGIST = "regist";
var VERIFICATION_STATE = "verfificationState";
var LOAD_QRCODE = "loadQrCode";
var FB_LOGIN = "fbLogin";
var GET_FB_INFO = "getFbInfo";
var UPDATE_FB_INFO = "updateFbInfo";
var GET_USER_INFO_ACTION = "ajax/h5_get_user_json";
var LOGIN_ACTION = "login/h5_login";
var REGIST_ACTION = "register/h5_register";
var NO_LOGIN = 0;
var HAVE_LOGINED = 1;
var RESET_STATE = "resetState";
var DETECT_SHOW_VERIFICATION_ACTION = "ajax/h5_ckcode_state";
var LOGIN_NEED_CKCODE = 1;
var REG_NEED_CKCODE = 1;
var UPDATE_CKCOE_LOGIN = "updataCKcodeLog";
var UPDATE_CKCOE_REGIST = "updateCKCodeReg";
var QRCODE_LOGIN_ACTION = "login/h5_qr_login";
var LOAD_QRCODE_ACTION = "ajax/h5_qrcode";
var FB_LOGIN_ACTION = "facebook/h5_direct_login_v2";
var GET_FB_USER_INFO_ACTION = "h5/fbPlay/getUserInfo";
var game_id = Object(__WEBPACK_IMPORTED_MODULE_4__ultile__["i" /* getHrefParam */])("gameid") || Object(__WEBPACK_IMPORTED_MODULE_4__ultile__["i" /* getHrefParam */])("game_id") || "";
var userMap = {
  id: "USER_ID",
  name: "LOGIN_ACCOUNT",
  avatar: "AVATAR",
  binding: "IS_BINDING",
  fbBinding: "BINDING_FB",
  lineBinding: "BINDING_LINE"
};

var emptyFBInfo = {
  avatart: "//www.gm99.com/images/noavatar.jpg",
  name: "",
  id: "",
  account: ""
};

/* harmony default export */ __webpack_exports__["f"] = ({
  state: {
    user: Object(__WEBPACK_IMPORTED_MODULE_4__ultile__["m" /* loadConverstData */])({}, userMap),
    loginState: NO_LOGIN,
    loginCkcodeStatus: 0,
    registCkcodeStatus: 0,
    fbUserInfo: emptyFBInfo
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, UPDATE_USER, function (state, user) {
    state.user = user;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, RESET_STATE, function (state, account_status) {
    state.loginState = account_status;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, UPDATE_CKCOE_LOGIN, function (state, status) {
    state.loginCkcodeStatus = status;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, UPDATE_CKCOE_REGIST, function (state, status) {
    state.registCkcodeStatus = status;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, UPDATE_FB_INFO, function (state, _ref) {
    var fb_user = _ref.fb_user,
        gm_user = _ref.gm_user;

    if (!fb_user) {
      state.fbUserInfo = emptyFBInfo;
    } else {
      state.fbUserInfo = {
        avatar: "//graph.facebook.com/" + fb_user.id,
        name: fb_user.name,
        id: fb_user.id,
        account: gm_user.LOGIN_ACCOUNT
      };
    }
  }), _mutations),
  actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, VERIFICATION_STATE, function (_ref2, userName) {
    var commit = _ref2.commit;

    var url = __WEBPACK_IMPORTED_MODULE_4__ultile__["c" /* PASSPORT_HOST */] + DETECT_SHOW_VERIFICATION_ACTION;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_4__ultile__["k" /* getJSON */])(url, {
        uname: userName
      }).then(function (_ref3) {
        var errmsg = _ref3.errmsg,
            data = _ref3.data,
            res = _ref3.res;

        if (errmsg) {
          resolve(errmsg);
        }
        if (LOGIN_NEED_CKCODE == data.H5_LOGIN_NEED_CKCODE) {
          commit(UPDATE_CKCOE_LOGIN, true);
        } else {
          commit(UPDATE_CKCOE_LOGIN, false);
        }
        if (REG_NEED_CKCODE == data.H5_REG_NEED_CKCODE) {
          commit(UPDATE_CKCOE_REGIST, true);
        } else {
          commit(UPDATE_CKCOE_REGIST, false);
        }
        resolve(false);
      });
    });
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, GET_USER_INFO, function (_ref4, _ref5) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;
    var isCheck = _ref5.isCheck,
        ignore = _ref5.ignore,
        _ref5$loginType = _ref5.loginType,
        loginType = _ref5$loginType === undefined ? "" : _ref5$loginType;

    var url = __WEBPACK_IMPORTED_MODULE_4__ultile__["c" /* PASSPORT_HOST */] + GET_USER_INFO_ACTION;
    var linkParam = Object(__WEBPACK_IMPORTED_MODULE_4__ultile__["j" /* getHrefParamObj */])();
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_4__ultile__["k" /* getJSON */])(url, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        h5_request: ignore ? 0 : 1,
        done_login: isCheck ? 0 : 1,
        login_type: loginType
      }, linkParam)).then(function (_ref6) {
        var errmsg = _ref6.errmsg,
            data = _ref6.data,
            res = _ref6.res;

        var user = Object(__WEBPACK_IMPORTED_MODULE_4__ultile__["m" /* loadConverstData */])(data, userMap);
        if (errmsg) {
          commit(UPDATE_USER, user);
          commit(RESET_STATE, NO_LOGIN);

          dispatch("gaStatistics", {
            eventName: "login_un"
          });

          resolve({
            errmsg: errmsg,
            user: {}
          });
        } else {
          commit(UPDATE_USER, user);
          commit(RESET_STATE, HAVE_LOGINED);

          dispatch("setIsFirstPlay", data.FIRST_PLAY || false);
          if (isCheck) {
            dispatch("gaStatistics", {
              eventName: "login_success",
              data: {
                login_type: "自动登录"
              }
            });
          }
          resolve({
            errmsg: "",
            user: user
          });
        }
      });
    });
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, LOGIN, function (_ref7, account) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref7);

    var url = (__WEBPACK_IMPORTED_MODULE_4__ultile__["c" /* PASSPORT_HOST */] + LOGIN_ACTION).replace(/cid=(exe|url)/, "cid=484");
    var validateResult = Object(__WEBPACK_IMPORTED_MODULE_5__validator__["a" /* loginValidate */])(account, this.state.user);
    account.password = Object(__WEBPACK_IMPORTED_MODULE_4__ultile__["d" /* encryption */])(account.password);
    account.game_id = game_id;
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var loginResult = true;
      loginResult = false;
      if (validateResult.dirty) {
        resolve({ loginResult: loginResult, errmsg: validateResult.msg });
      }
      var linkParam = Object(__WEBPACK_IMPORTED_MODULE_4__ultile__["j" /* getHrefParamObj */])();
      Object(__WEBPACK_IMPORTED_MODULE_4__ultile__["k" /* getJSON */])(url, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, account, linkParam)).then(function (_ref8) {
        var errmsg = _ref8.errmsg,
            data = _ref8.data,
            res = _ref8.res;

        var loginResult = true;
        if (errmsg) {
          loginResult = false;
          resolve({ loginResult: loginResult, errmsg: errmsg });
        } else {
          errmsg = "";
          resolve({ loginResult: loginResult, errmsg: errmsg });
        }
      });
    });
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, REGIST, function (_ref9, account) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref9);

    var url = (__WEBPACK_IMPORTED_MODULE_4__ultile__["c" /* PASSPORT_HOST */] + REGIST_ACTION).replace(/cid=(exe|url)/, "cid=484");
    var validateResult = Object(__WEBPACK_IMPORTED_MODULE_5__validator__["b" /* registValidate */])(account);
    account.password = Object(__WEBPACK_IMPORTED_MODULE_4__ultile__["d" /* encryption */])(account.password);
    account.repassword = Object(__WEBPACK_IMPORTED_MODULE_4__ultile__["d" /* encryption */])(account.repassword);
    account.game_id = game_id;
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var regestResult = true;
      var forward = "";
      if (validateResult.dirty) {
        regestResult = false;
        errmsg = validateResult.msg;
        resolve({ regestResult: regestResult, errmsg: errmsg, forward: forward });
      }
      var linkParam = Object(__WEBPACK_IMPORTED_MODULE_4__ultile__["j" /* getHrefParamObj */])();
      Object(__WEBPACK_IMPORTED_MODULE_4__ultile__["k" /* getJSON */])(url, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, account, linkParam)).then(function (_ref10) {
        var errmsg = _ref10.errmsg,
            data = _ref10.data,
            res = _ref10.res;

        var regestResult = true;
        if (errmsg) {
          regestResult = false;
          resolve({ regestResult: regestResult, errmsg: errmsg, forward: forward });
        } else {
          forward = res.forward;
          resolve({ regestResult: regestResult, errmsg: errmsg, forward: forward });
        }
      });
    });
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, FB_LOGIN, function (_ref11, params) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref11);

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var linkParam = Object(__WEBPACK_IMPORTED_MODULE_4__ultile__["j" /* getHrefParamObj */])();
      Object(__WEBPACK_IMPORTED_MODULE_4__ultile__["k" /* getJSON */])(__WEBPACK_IMPORTED_MODULE_4__ultile__["c" /* PASSPORT_HOST */] + FB_LOGIN_ACTION, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, params, linkParam)).then(function (_ref12) {
        var errmsg = _ref12.errmsg;

        errmsg ? reject({ errmsg: errmsg }) : resolve();
      });
    });
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, "touristLogin", function touristLogin(_ref13, params) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref13);

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var linkParam = Object(__WEBPACK_IMPORTED_MODULE_4__ultile__["j" /* getHrefParamObj */])();
      Object(__WEBPACK_IMPORTED_MODULE_4__ultile__["k" /* getJSON */])(__WEBPACK_IMPORTED_MODULE_4__ultile__["c" /* PASSPORT_HOST */] + "direct_login/h5_direct_login", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, params, linkParam)).then(function (_ref14) {
        var errmsg = _ref14.errmsg;

        errmsg ? reject({ errmsg: errmsg }) : resolve();
      });
    });
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, GET_FB_INFO, function (_ref15) {
    var commit = _ref15.commit;

    var location = __WEBPACK_IMPORTED_MODULE_4__ultile__["b" /* GMMOBILE_HOST */] + GET_FB_USER_INFO_ACTION;
    var appID = Object(__WEBPACK_IMPORTED_MODULE_4__ultile__["i" /* getHrefParam */])("app_id");
    var auth_uid = Object(__WEBPACK_IMPORTED_MODULE_4__ultile__["i" /* getHrefParam */])("auth_uid");
    Object(__WEBPACK_IMPORTED_MODULE_4__ultile__["k" /* getJSON */])(location, {
      access_token: auth_uid,
      app_id: appID
    }).then(function (_ref16) {
      var data = _ref16.data,
          errmsg = _ref16.errmsg;

      if (!errmsg) {
        commit(UPDATE_FB_INFO, data);
      } else {
        commit(UPDATE_FB_INFO, "");
      }
    });
  }), _actions)
});

/***/ }),

/***/ "xBpH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FOOTER_LINK */
/* unused harmony export FB_LINK */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UNREAD_MSG; });
/* unused harmony export CHANGE_FB_INFO */
/* unused harmony export LOAD_FB_INFO */
/* unused harmony export UPDATE_TIP_MSG */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user__ = __webpack_require__("wMq3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ultile__ = __webpack_require__("VtGx");



var _mutations, _actions;






var FOOTER_LINK = "getFooterLink";
var FB_LINK = "getFbLink";
var UNREAD_MSG = "getUnreadMsg";
var CHANGE_FB_INFO = "changeFbInfo";
var LOAD_FB_INFO = "loadFbInfo";
var UPDATE_FOOTER_LINK = "updataFooterLink";
var UPDATE_TIP_MSG = "updateTipMsg";
var UPDATE_FB_LINK = "unpdateFbLink";
var UPDATE_UNREAD_MSG = "updateUnreadMsg";

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);
var emptyFbInfo = {
  appName: "",
  appImg: ""
};
/* harmony default export */ __webpack_exports__["b"] = ({
  strict: "production" !== "production", //在非生产环境下，使用严格模式
  state: {
    footerLink: "",
    tipMsg: "",
    fbLink: "",
    unreadMsg: 0,
    fbInfo: emptyFbInfo,
    showFullScreen: false
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, UPDATE_FOOTER_LINK, function (state, status) {
    state.footerLink = status;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, UPDATE_TIP_MSG, function (state, status) {
    state.tipMsg = status;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, UPDATE_UNREAD_MSG, function (state, status) {
    state.unreadMsg = status;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, CHANGE_FB_INFO, function (state, info) {
    if (info) {
      state.fbInfo.appName = info.appName;
      state.fbInfo.appImg = info.LOGO_URL;
    } else {
      state.fbInfo = emptyFbInfo;
    }
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, "toggleFullScreenState", function toggleFullScreenState(state) {
    state.showFullScreen = !state.showFullScreen;
  }), _mutations),
  actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, FOOTER_LINK, function (_ref, params) {
    var commit = _ref.commit;

    var url = "https://www.gm99.com/ajax/get_flink_h5";
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_5__ultile__["k" /* getJSON */])(url, { type: 0 }).then(function (_ref2) {
        var errmsg = _ref2.errmsg,
            data = _ref2.data,
            res = _ref2.res;

        if (errmsg) {
          reject(errmsg);
        } else {
          commit(UPDATE_FOOTER_LINK, res.data);
          resolve(true);
        }
      });
    });
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, UPDATE_FB_LINK, function (state, status) {
    state.fbLink = status;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, UNREAD_MSG, function (_ref3, params) {
    var commit = _ref3.commit;

    var url = "https://www.gm99.com/message_api/query_msg?type=load";
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_5__ultile__["k" /* getJSON */])(url, {}).then(function (_ref4) {
        var errmsg = _ref4.errmsg,
            data = _ref4.data,
            res = _ref4.res;

        if (errmsg) {
          resolve(false, errmsg);
        } else {
          if (res.code === 0) {
            resolve(false, "未登录");
          } else {
            commit(UPDATE_UNREAD_MSG, res.data.remain_msg);
            resolve(true);
          }
        }
      });
    });
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, LOAD_FB_INFO, function (_ref5) {
    var commit = _ref5.commit;

    var location = __WEBPACK_IMPORTED_MODULE_5__ultile__["b" /* GMMOBILE_HOST */] + "h5/fbPlay/getAppInfo";
    var app_id = Object(__WEBPACK_IMPORTED_MODULE_5__ultile__["i" /* getHrefParam */])("app_id");
    var auth_uid = Object(__WEBPACK_IMPORTED_MODULE_5__ultile__["i" /* getHrefParam */])("auth_uid");
    Object(__WEBPACK_IMPORTED_MODULE_5__ultile__["k" /* getJSON */])(location, {
      app_id: app_id,
      access_token: auth_uid
    }).then(function (_ref6) {
      var data = _ref6.data,
          errmsg = _ref6.errmsg;

      data = errmsg ? "" : data;
      commit(CHANGE_FB_INFO, data);
    });
  }), _actions)
});

/***/ })

},[1]);


// WEBPACK FOOTER //
// js/pc.f98fff22b558c388145b.js